import { GraphQLClient } from 'graphql-request';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `AWSEmail` scalar type provided by AWS AppSync, represents an Email address string that complies with [RFC 822](https://www.ietf.org/rfc/rfc822.txt). For example, "**username@example.com**" is a valid Email address. */
  AWSEmail: any;
  Date: Date;
};

export type EventDataRes = Array<{
  attendees?: Array<string | null> | null;
  createdAt?: string | null;
  ownerChannelId?: string | null;
  slug?: string | null;
  id?: string | null;
  status?: IStatusTypeV2 | null;
  eventStartedAt?: string | null;
  eventStoppedAt?: string | null;
  viewers?: {
    id?: string | null;
    type?: string | null;
    current?: string | null;
    total?: string | null;
  } | null;
  availableActions?: {
    archive?: boolean | null;
    edit?: boolean | null;
    remove?: boolean | null;
    finish?: boolean | null;
    start?: boolean | null;
  } | null;
  details?: {
    duration?: number | null;
    eventCategory?: Array<string | null> | null;
    eventTag?: Array<string | null> | null;
    eventDescription?: string | null;
    eventName?: string | null;
    eventOwner?: string | null;
    eventOwnerAvatar?: string | null;
    eventPosterImage?: string | null;
    eventStartDateAndTime?: string | null;
    eventThumbnail?: string | null;
    eventType?: string | null;
    platform?: string | null;
    startDateTimeOfEvent?: string | null;
    restrict?: boolean | null;
    eventOwnerLive?: boolean | null;
  } | null;
  monetization?: {
    adFrequency?: number | null;
    adLength?: number | null;
    allowFreePreview?: boolean | null;
    allowFreePreviewSub?: boolean | null;
    allowNonSubscribersPPV?: boolean | null;
    allowPPVSub?: boolean | null;
    contributorsOptions?: string | null;
    freePreviewTime?: string | null;
    freePreviewTimeSub?: string | null;
    maxPrice?: string | null;
    messageForViewers?: string | null;
    minPrice?: string | null;
    monetizationType?: IMonetizationTypeV2 | null;
    preRoll?: boolean | null;
    price1?: string | null;
    price2?: string | null;
    price3?: string | null;
    price4?: string | null;
    priceInput?: IPriceInputTypeV2 | null;
    pricePerPPV?: string | null;
    pricePerPPVSub?: string | null;
    subscribersOnly?: boolean | null;
    sponsor?: Array<{
      sponsorAmount?: string | null;
      sponsorLogo?: string | null;
      sponsorName?: string | null;
    } | null> | null;
  } | null;
  options?: {
    allowOtherChats?: boolean | null;
    isPrivateEvent?: boolean | null;
    numberOfChatsPerStream?: number | null;
    privateEventPassword?: string | null;
    isFollowerOnly?: boolean | null;
    recordEvent?: boolean | null;
    recordEventExpirationDate?: string | null;
    newStreamTypeOptions?: string | null;
  } | null;
  streamers?: Array<{
    id?: string | null;
    isPromo?: boolean | null;
    type?: IStreamsTypeV2 | null;
    emailInvite?: {
      customMessage?: string | null;
      email?: string | null;
      isPrivateMessage?: boolean | null;
    } | null;
    embedStreams?: {
      logo?: string | null;
      streamName?: string | null;
      streamType?: string | null;
      streamUrl?: string | null;
      thumbnail?: string | null;
      chat?: Array<{
        type?: string | null;
        url?: string | null;
      } | null> | null;
    } | null;
    klic?: {
      isThumbnailOverridden?: boolean | null;
      logo?: string | null;
      mediaOffset?: string | null;
      streamUrl?: string | null;
      thumbnailUrl?: string | null;
      vodUrl?: string | null;
      chat?: Array<{
        url?: string | null;
        type?: string | null;
      } | null> | null;
      channel?: {
        channelArn?: string | null;
        channelInputUrl?: string | null;
        channelStreamKey?: string | null;
        id: string;
        isChannelLive?: string | null;
        ivsChannelName?: string | null;
        liveUrl?: string | null;
        userId?: string | null;
        name?: string | null;
        user?: {
          firstName?: string | null;
          lastName?: string | null;
          id: string;
          email: string;
          username: string;
          avatar?: string | null;
          heading?: string | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
} | null> | null;

export type IAboutDetails = {
  btnHeroLink?: Maybe<Scalars['String']>;
  btnHeroText?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imgInitial?: Maybe<Scalars['String']>;
  supportingCopy?: Maybe<Scalars['String']>;
  testimonialWaterMark?: Maybe<Scalars['String']>;
  testimonialsTitle?: Maybe<Scalars['String']>;
  trustedTitle?: Maybe<Scalars['String']>;
  upcomingEventTitle?: Maybe<Scalars['String']>;
  upcomingEventWaterMark?: Maybe<Scalars['String']>;
};

export type IAboutDetailsData = {
  btnHeroLink?: Maybe<Scalars['String']>;
  btnHeroText?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imgInitial?: Maybe<Scalars['String']>;
  supportingCopy?: Maybe<Scalars['String']>;
  testimonialWaterMark?: Maybe<Scalars['String']>;
  testimonialsTitle?: Maybe<Scalars['String']>;
  trustedTitle?: Maybe<Scalars['String']>;
  upcomingEventTitle?: Maybe<Scalars['String']>;
  upcomingEventWaterMark?: Maybe<Scalars['String']>;
};

export type IAboutFeature = {
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type IAboutFeatureData = {
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type IAboutPayload = {
  about?: Maybe<IAboutpageData>;
  error?: Maybe<Scalars['String']>;
};

export type IAboutpageData = {
  aboutFeatures?: Maybe<Array<Maybe<IAboutFeature>>>;
  details?: Maybe<IAboutDetails>;
  testimonials?: Maybe<Array<Maybe<ITestimonial>>>;
  trustedBy?: Maybe<Array<Maybe<ITrustedBy>>>;
  upcomingEvents?: Maybe<Array<Maybe<IUpcomingEvent>>>;
};

export type IAttendEventResponse = {
  attendees?: Maybe<Array<Maybe<Scalars['String']>>>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<IEventResponse>;
  eventId?: Maybe<Scalars['String']>;
};

export type IAttendeeType = {
  attendDateAndTime?: Maybe<Scalars['String']>;
  userDisplayName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IAuthorization = {
  authState?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IAuthorizationPayload = {
  authorization?: Maybe<IAuthorization>;
  error?: Maybe<Scalars['String']>;
};

export type IAvailableActionsType = {
  archive?: Maybe<Scalars['Boolean']>;
  edit?: Maybe<Scalars['Boolean']>;
  finish?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['Boolean']>;
};

export type IAvailableActionsTypeV2 = {
  archive?: Maybe<Scalars['Boolean']>;
  edit?: Maybe<Scalars['Boolean']>;
  finish?: Maybe<Scalars['Boolean']>;
  remove?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['Boolean']>;
};

export type ICategoryTag = {
  eventType: {
    name: Maybe<Scalars['Boolean']>;
  };
  categoryId: string;
  eventTypeId: string;
};
export type ICategoryResponseV2 = {
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  thumbnail: Scalars['String'];
  slug: Scalars['String'];
};
export type ICategoryResponseV3 = {
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  thumbnail: Scalars['String'];
  slug: Scalars['String'];
  followerCount?: Scalars['Int'];
};
export type IFeatureCategoryResponseV2 = {
  category: {
    name: Scalars['String'];
    thumbnail: Scalars['String'];
    slug: Scalars['String'];
    id: Scalars['String'];
  } | null;
  id: Scalars['String'];
  categoryId: Scalars['String'];
  position: Scalars['Int'];
};
export type ICategoryWithTagResponse = {
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  thumbnail: Scalars['String'];
  slug: Scalars['String'];
  totalView?: Scalars['Int'];
  categoryTags: Maybe<Array<ICategoryTag>>;
};

export type IChannel = {
  banner?: Maybe<Scalars['String']>;
  channelArn?: Maybe<Scalars['String']>;
  channelData?: Maybe<IChannelData>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imagen?: Maybe<Scalars['String']>;
  ingestServer?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  playbackUrl?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
  subId?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  watermark?: Maybe<Scalars['String']>;
};

export type IChannelData = {
  banner?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  ingestServer?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  playbackUrl?: Maybe<Scalars['String']>;
  streamArn?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IChannelPayload = {
  channel?: Maybe<IChannel>;
  error?: Maybe<Scalars['String']>;
};

export type IChannelResponse = {
  channelData?: Maybe<IChannelData>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  item?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IChannelResponseV2 = {
  avatar?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isChannelLive?: Maybe<Scalars['String']>;
  ivsChannelName?: Maybe<Scalars['String']>;
  liveUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  followcount?: Maybe<Scalars['Int']>;
  aboutme?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IChannelEventResponse = {
  avatar?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isChannelLive?: Maybe<Scalars['String']>;
  ivsChannelName?: Maybe<Scalars['String']>;
  liveUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  followcount?: Maybe<Scalars['Int']>;
  aboutme?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  events?: Maybe<EventDataRes>;
  eventCount?: Maybe<Scalars['Int']>;
};
export type IChat = {
  eventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<IMessage>>>;
};

export type IChatDataInput = {
  id?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<IChatDataUserInput>;
  pin?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
};

export type IChatDataResponse = {
  color?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  user?: Maybe<IChatDataUserResponse>;
};

export type IChatDataUserInput = {
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type IChatDataUserResponse = {
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type IChatInput = {
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<IMessageInput>>>;
};

export type IChatPayload = {
  eventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<IMessage>;
};

export type ICheckPpvVisitResponse = {
  alreadyVisitedByIp?: Maybe<Scalars['Boolean']>;
  alreadyVisitedByUser?: Maybe<Scalars['Boolean']>;
  isAllowed?: Maybe<Scalars['Boolean']>;
};

export type ICheckPayload = {
  isTaken?: Maybe<Scalars['Boolean']>;
};

export type ICheckUserByEmail = {
  email?: InputMaybe<Scalars['String']>;
};

export type ICheckUserByUserName = {
  username?: InputMaybe<Scalars['String']>;
};

export type IConfirmSignUpPayload = {
  confirmationCode: Scalars['String'];
  username: Scalars['String'];
};

export type ICreateAuthorizationInput = {
  authState?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ICreateCategoryInput = {
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type ICreateChannelInput = {
  banner?: InputMaybe<Scalars['String']>;
  channelArn?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imagen?: InputMaybe<Scalars['String']>;
  ingestServer?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  streamKey?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  watermark?: InputMaybe<Scalars['String']>;
};

export type ICreateEventDataResponse = {
  event?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type ICreateEventForChannelAsDraftInput = {
  channelId: Scalars['String'];
  details?: InputMaybe<IDetailsAsDraft>;
  monetization?: InputMaybe<IMonetizationAsDraft>;
  options?: InputMaybe<IOptionsAsDraft>;
  streamers?: InputMaybe<Array<InputMaybe<IStreamersAsDraft>>>;
};

export type ICreateEventForChannelAsDraftInputV2 = {
  channelId: Scalars['String'];
  details?: InputMaybe<IDetailsAsDraftV2>;
  monetization?: InputMaybe<IMonetizationAsDraftV2>;
  options?: InputMaybe<IOptionsAsDraftV2>;
  streamers?: InputMaybe<Array<InputMaybe<IStreamersAsDraftV2>>>;
};

export type ICreateEventForChannelInput = {
  channelId: Scalars['String'];
  details: IDetails;
  monetization: IMonetization;
  options: IOptions;
  streamers: Array<InputMaybe<IStreamers>>;
};

export type ICreateEventInput = {
  address?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  chats?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endTime?: InputMaybe<Scalars['String']>;
  ended?: InputMaybe<Scalars['Boolean']>;
  eventDate?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventTime?: InputMaybe<Scalars['String']>;
  eventTimezone?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  imgDescription?: InputMaybe<Scalars['String']>;
  organizer?: InputMaybe<Scalars['String']>;
  paidEvent?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  priceId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sponsorLogos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sponsors?: InputMaybe<Array<InputMaybe<ISponsorInput>>>;
  startTime?: InputMaybe<Scalars['String']>;
  streamData?: InputMaybe<Array<InputMaybe<IStreamInput>>>;
  streamingFrom?: InputMaybe<Scalars['String']>;
  subHeading?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalStreamViews?: InputMaybe<Scalars['Int']>;
  totalViews?: InputMaybe<Scalars['Int']>;
  viewedUser?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  viewers?: InputMaybe<Scalars['Int']>;
};

export type ICreateEventResponse = {
  data?: Maybe<ICreateEventDataResponse>;
  error?: Maybe<Scalars['String']>;
};

export type ICreateEventTypeInput = {
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ICreateLivestreamingInput = {
  autoRecord?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  forChilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ICreatePaymentIntentInput = {
  eventId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ICreateRoleInput = {
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roleState?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ICreateTransactionInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  img?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  receipt_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ICreateUserInput = {
  avatar?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};
export type IFollowChannelInput = {
  channelId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IFollowingInput = {
  channelId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
};

export type ICreateVideoInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  forChilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['String']>;
  recordingSessionId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnail?: InputMaybe<Scalars['String']>;
  thumbnailsPath?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ICredentialsLivestreaming = {
  channelArn?: Maybe<Scalars['String']>;
  ingestServer?: Maybe<Scalars['String']>;
  playbackUrl?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
};

export type ICredentialsLivestreamingPayload = {
  credentialsLivestreaming?: Maybe<ICredentialsLivestreaming>;
  error?: Maybe<Scalars['String']>;
};

export type IDeletePayload = {
  data?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type IDetails = {
  duration: Scalars['Int'];
  eventCategory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventDescription: Scalars['String'];
  eventName: Scalars['String'];
  eventOwner?: InputMaybe<Scalars['String']>;
  eventPosterImage?: InputMaybe<Scalars['String']>;
  eventStartDateAndTime: Scalars['String'];
  eventThumbnail?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
};

export type IDetailsAsDraft = {
  duration?: InputMaybe<Scalars['Int']>;
  eventCategory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventName: Scalars['String'];
  eventOwner?: InputMaybe<Scalars['String']>;
  eventPosterImage?: InputMaybe<Scalars['String']>;
  eventStartDateAndTime?: InputMaybe<Scalars['String']>;
  eventThumbnail?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
};

export type IDetailsAsDraftV2 = {
  duration?: InputMaybe<Scalars['Int']>;
  eventCategory?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventTag?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventDescription?: InputMaybe<Scalars['String']>;
  eventName: Scalars['String'];
  eventOwner?: InputMaybe<Scalars['String']>;
  eventPosterImage?: InputMaybe<Scalars['String']>;
  eventStartDateAndTime?: InputMaybe<Scalars['String']>;
  eventThumbnail?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  createEvent?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  restrict?: InputMaybe<Scalars['Boolean']>;
  braketologyEmbedLink?: InputMaybe<Scalars['String']>;
  braketologyType?: InputMaybe<Scalars['String']>;
  vodArchiveTime?: InputMaybe<Scalars['String']>;
  streamCheckInTime?: InputMaybe<Scalars['String']>;
};

export type IDetailsResponse = {
  duration?: Maybe<Scalars['Int']>;
  eventCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventTag?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventDescription?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  eventOwner?: Maybe<Scalars['String']>;
  eventOwnerAvatar?: Maybe<Scalars['String']>;
  eventPosterImage?: Maybe<Scalars['String']>;
  eventStartDateAndTime?: Maybe<Scalars['String']>;
  eventThumbnail?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
};

export type IDetailsResponseV2 = {
  duration?: Maybe<Scalars['Int']>;
  eventCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventCategoryThumbnail?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventDescription?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  eventOwner?: Maybe<Scalars['String']>;
  eventOwnerAvatar?: Maybe<Scalars['String']>;
  eventPosterImage?: Maybe<Scalars['String']>;
  eventStartDateAndTime?: Maybe<Scalars['String']>;
  eventThumbnail?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  braketologyEmbedLink?: Maybe<Scalars['String']>;
  braketologyType?: Maybe<Scalars['String']>;
  vodArchiveTime?: Maybe<Scalars['String']>;
  streamCheckInTime?: Maybe<Scalars['String']>;
  restrict?: Maybe<Scalars['Boolean']>;
  eventOwnerLive?: Maybe<Scalars['Boolean']>;
  startDateTimeOfEvent?: Maybe<Scalars['String']>;
  startDateTimeOfEventUTC?: Maybe<Scalars['String']>;
  kick?: Maybe<Scalars['String']>;
  twitch?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  custom?: Maybe<Scalars['String']>;
};

export type IEditEventInputV2 = {
  channelId: Scalars['String'];
  details?: InputMaybe<IDetailsAsDraftV2>;
  id: Scalars['String'];
  status?: Scalars['String'];
  monetization?: InputMaybe<IMonetizationAsDraftV2>;
  options?: InputMaybe<IOptionsAsDraftV2>;
  streamers?: InputMaybe<Array<InputMaybe<IStreamersAsDraftEditV2>>>;
};
export type IUpdateChatSettingV2 = {
  id: Scalars['String'];
  isFollowerOnly?: Scalars['Boolean'];
  subscribersOnly?: Scalars['Boolean'];
};
export type IEditEventResponse = {
  data?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type IEditMediaInput = {
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mediaId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};
export type IAddChatSettingInput = {
  followersOnly?: Scalars['Boolean'];
  subsOnly?: Scalars['Boolean'];
  emoteOnly?: Scalars['Boolean'];
  slowMode?: Scalars['Boolean'];
  eventId?: Scalars['String'];
};
export type IUpdateChatSettingInput = {
  followersOnly?: Scalars['Boolean'];
  subsOnly?: Scalars['Boolean'];
  emoteOnly?: Scalars['Boolean'];
  slowMode?: Scalars['Boolean'];
  eventId?: Scalars['String'];
};

export type IuserChatSettingInput = {
  color?: Scalars['String'];
  discrimination?: Scalars['Boolean'];
  explicitLanguage?: Scalars['Boolean'];
  hostility?: Scalars['Boolean'];
  profanity?: Scalars['Boolean'];
  userId: Scalars['String'];
  eventId: Scalars['String'];
};
export type IuserChatSettingMutation = Exact<{
  userChatSettingInput?: InputMaybe<IuserChatSettingInput>;
}>;
export type IUpdateUserChatSettingInput = {
  color?: Scalars['String'];
  discrimination?: Scalars['Boolean'];
  explicitLanguage?: Scalars['Boolean'];
  hostility?: Scalars['Boolean'];
  profanity?: Scalars['Boolean'];
  userId: Scalars['String'];
  eventId: Scalars['String'];
};
export type IEditCarouselInput = {
  carouselId?: Scalars['String'];
  eventId: Scalars['String'];
  channelId?: Scalars['String'];
  streamId?: Scalars['String'];
  position?: Scalars['Int'];
};
export type IModifyFeaturedPositionInput = {
  categoryId: Scalars['String'];
  position?: Scalars['Int'];
};
export type IEditRecommendedEventInput = {
  eventId: Scalars['String'];
  position: Scalars['Int'];
};

export type IEmailInvite = {
  customMessage?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  isPrivateMessage: Scalars['Boolean'];
};

export type IEmailInviteAsDraft = {
  customMessage?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  isPrivateMessage?: InputMaybe<Scalars['Boolean']>;
};

export type IEmailInviteResponse = {
  customMessage?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isPrivateMessage?: Maybe<Scalars['Boolean']>;
};

export type IEmailInviteResponseV2 = {
  customMessage?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isPrivateMessage?: Maybe<Scalars['Boolean']>;
};

export type IEmbedStreams = {
  chat: Array<InputMaybe<IStreamersChat>>;
  logo?: InputMaybe<Scalars['String']>;
  streamName: Scalars['String'];
  streamType: Scalars['String'];
  streamUrl: Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IEmbedStreamsAsDraft = {
  chat?: InputMaybe<Array<InputMaybe<IStreamersChatAsDraft>>>;
  logo?: InputMaybe<Scalars['String']>;
  streamName?: InputMaybe<Scalars['String']>;
  streamType?: InputMaybe<Scalars['String']>;
  streamUrl?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IEmbedStreamsAsDraftV2 = {
  chat?: InputMaybe<Array<InputMaybe<IStreamersChatAsDraftV2>>>;
  logo?: InputMaybe<Scalars['String']>;
  streamName?: InputMaybe<Scalars['String']>;
  streamType?: InputMaybe<Scalars['String']>;
  streamUrl?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IEmbedStreamsResponse = {
  chat?: Maybe<Array<Maybe<IStreamersChatResponse>>>;
  logo?: Maybe<Scalars['String']>;
  streamName?: Maybe<Scalars['String']>;
  streamType?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IEmbedStreamsResponseV2 = {
  chat?: Maybe<Array<Maybe<IStreamersChatResponseV2>>>;
  logo?: Maybe<Scalars['String']>;
  streamName?: Maybe<Scalars['String']>;
  streamType?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IEntityViewResponse = {
  current?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type IEvent = {
  address?: Maybe<Scalars['String']>;
  category?: Maybe<Array<Maybe<Scalars['String']>>>;
  chats?: Maybe<Array<Maybe<Scalars['String']>>>;
  endTime?: Maybe<Scalars['String']>;
  ended?: Maybe<Scalars['Boolean']>;
  eventDate?: Maybe<Scalars['String']>;
  eventState?: Maybe<Scalars['String']>;
  eventStatus?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventTime?: Maybe<Scalars['String']>;
  eventTimezone?: Maybe<Scalars['String']>;
  eventType?: Maybe<Array<Maybe<Scalars['String']>>>;
  featuredImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  imgDescription?: Maybe<Scalars['String']>;
  organizer?: Maybe<Scalars['String']>;
  paidEvent?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  priceId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  sponsorLogos?: Maybe<Array<Maybe<Scalars['String']>>>;
  sponsors?: Maybe<Array<Maybe<ISponsor>>>;
  startTime?: Maybe<Scalars['String']>;
  streamData?: Maybe<Array<Maybe<IStream>>>;
  streamingFrom?: Maybe<Scalars['String']>;
  subHeading?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalStreamViews?: Maybe<Scalars['Int']>;
  totalViews?: Maybe<Scalars['Int']>;
  viewedUser?: Maybe<Array<Maybe<Scalars['String']>>>;
  viewers?: Maybe<Scalars['Int']>;
};

export enum IEventActionType {
  Archive = 'ARCHIVE',
  Finish = 'FINISH',
  Remove = 'REMOVE',
  Start = 'START',
  EDIT_DESCRIPTION = 'EDIT_DESCRIPTION',
  REMOVE_STREAM = 'REMOVE_STREAM',
  ACCEPT_INVITE = 'ACCEPT_INVITE',
  DECLINE_INVITE = 'DECLINE_INVITE',
  REMOVE_CHANNEL_EVENT = 'REMOVE_CHANNEL_EVENT',
}

export type IEventCategoryData = {
  createdAt?: Maybe<Scalars['String']>;
  eventCategory?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IEventCategoryPayload = {
  error?: Maybe<Scalars['String']>;
  eventCategory?: Maybe<IEventCategoryData>;
};

export type IEventChatMessageSentResponse = {
  data?: Maybe<IChatDataResponse>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
};

export type IEventChatMessagesResponse = {
  messages?: Maybe<Array<Maybe<IChatDataResponse>>>;
};

export type IEventChatResponse = {
  error?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<IChatDataResponse>>>;
};

export type IEventData = {
  createdAt?: Maybe<Scalars['String']>;
  eventData?: Maybe<IEvent>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IEventDataResponse = {
  eventData?: Maybe<IEventViewsDetails>;
};

export type IEventDataViewersResponse = {
  eventData?: Maybe<IEventViewersDetails>;
};

export type IEventPayload = {
  error?: Maybe<Scalars['String']>;
  event?: Maybe<IEventData>;
};

export type IEventResponse = {
  attendees?: Maybe<Array<Maybe<IAttendeeType>>>;
  availableActions?: Maybe<IAvailableActionsType>;
  createdAt?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  details?: Maybe<IDetailsResponse>;
  id?: Maybe<Scalars['String']>;
  monetization?: Maybe<IMonetizationResponse>;
  options?: Maybe<IOptionsResponse>;
  status?: Maybe<IStatusType>;
  activeStreamId?: Maybe<Scalars['String']>;
  streamers?: Maybe<Array<Maybe<IStreamersResponseV2>>>;
};

export type IEventTypeData = {
  createdAt?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IEventTypePayload = {
  error?: Maybe<Scalars['String']>;
  eventType?: Maybe<IEventTypeData>;
};

export type IEventTypeResponseV2 = {
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};
export type ICategoryTagItem = {
  name: Scalars['String'];
};

export type ICarouselProps = {
  username: any;
  carouselchannelId: Scalars['String'];
  carouselstreamId: Scalars['String'];
  slug: any;
  id: Scalars['String'];
  position?: Scalars['String'];
  eventId: Scalars['String'];
  thumbnail?: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  viewers?: Maybe<ICarouselViewersProps>;
  streamers?: Scalars['String'];
};
export type ICarouselViewersProps = {
  id: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['String']>;
};

export type IFeaturedEventListProps = {
  id: Scalars['String'];
  position?: Scalars['String'];
  eventId: Scalars['String'];
  thumbnail?: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  viewers: Maybe<ICarouselViewersProps>;
  streamers: Scalars['String'];
};

export type IRecommendedEventListProps = {
  id: Scalars['String'];
  position?: Scalars['String'];
  eventId: Scalars['String'];
  thumbnail?: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  viewers: Maybe<ICarouselViewersProps>;
  streamers: Scalars['String'];
};
export type IManageUsersListCarouselProps = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  id: Scalars['String'];
  name?: Scalars['String'];
  email?: Scalars['String'];
  // signedupon?: Scalars['String'];
  // status?: Scalars['String'];
  // usertype?: Scalars['String'];
  avatar?: Scalars['String'];
  heading?: Scalars['String'];
  created_at?: Scalars['String'];
  role?: {
    id?: Scalars['String'];
    name?: Scalars['String'];
  };
  plan?: {
    id?: Scalars['String'];
    name?: Scalars['String'];
  };
  isLock?: Scalars['Boolean'];
  isTempLock?: Scalars['Boolean'];
};

export type IEventViewersDetails = {
  viewers?: Maybe<Scalars['Int']>;
};

export type IEventViewsDetails = {
  totalViews?: Maybe<Scalars['Int']>;
};

export type IFeaturedEvent = {
  eventId?: Maybe<Scalars['String']>;
  stream?: Maybe<IStream>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IFeaturedEventData = {
  event?: Maybe<IEventData>;
  stream?: Maybe<IStream>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IFeaturedEventInput = {
  eventId?: InputMaybe<Scalars['String']>;
  stream?: InputMaybe<IStreamInput>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type IFileInput = {
  src?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type IGetAboutpagePayload = {
  aboutFeatures?: Maybe<Array<Maybe<IAboutFeatureData>>>;
  details?: Maybe<IAboutDetailsData>;
  error?: Maybe<Scalars['String']>;
  testimonials?: Maybe<Array<Maybe<ITestimonialData>>>;
  trustedBy?: Maybe<Array<Maybe<ITrustedByData>>>;
  upcomingEvents?: Maybe<Array<Maybe<IUpcomingEventData>>>;
};
export type IGetCarouselDataResponse = {
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  viewers?: Maybe<IEntityViewResponse>;
};

export type IGetCurrentLiveStreamResponse = {
  isStreamLive?: Maybe<Scalars['Boolean']>;
  liveVodUrl?: Maybe<Scalars['String']>;
  offline?: Maybe<Scalars['Boolean']>;
  playbackUrl?: Maybe<Scalars['String']>;
  vodUrl?: Maybe<Scalars['String']>;
};

export type IGetEventByIdResponse = {
  error?: Maybe<Scalars['String']>;
  event?: Maybe<IEventResponse>;
};

export type IGetEventsForCarouselV2 = {
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  carouselId?: Maybe<Scalars['String']>;
  carouselstreamId?: Maybe<Scalars['String']>;
  carouselchannelId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  posterImage?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  viewers?: Maybe<IEntityViewResponse>;
};

export type IGetHomepageVideosPayload = {
  error?: Maybe<Scalars['String']>;
  featuredEvents?: Maybe<Array<Maybe<IFeaturedEventData>>>;
  recentVods?: Maybe<Array<Maybe<IFeaturedEventData>>>;
  showcaseEvents?: Maybe<Array<Maybe<IShowcaseEventData>>>;
};

export type IGetLandingVideos = {
  error?: Maybe<Scalars['String']>;
  featuredEvents?: Maybe<Array<Maybe<IEventResponse>>>;
  liveEvents?: Maybe<Array<Maybe<IEventResponse>>>;
  scheduledEvents?: Maybe<Array<Maybe<IEventResponse>>>;
};

export type IGetPresignedUploadUrlResponseV2 = {
  url: Scalars['String'];
};

export type IGetSignedUrlResponseV2 = {
  url: Scalars['String'];
};

export type IGetStreamInput = {
  channelId: Scalars['String'];
  mediaId?: InputMaybe<Scalars['String']>;
};

export type IGetThumbnailResponse = {
  url?: Maybe<Scalars['String']>;
};

export type IGlobalSignOutResponse = {
  body?: Maybe<Scalars['String']>;
};

export type IHomepageVideosPayload = {
  error?: Maybe<Scalars['String']>;
  video?: Maybe<IVideoData>;
};

export type IIsTakenResponseV2 = {
  isTaken?: Maybe<Scalars['Boolean']>;
};

export type IKlic = {
  channel: Scalars['String'];
  chat: Array<InputMaybe<IStreamersChat>>;
  isThumbnailOverridden?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  streamName?: InputMaybe<Scalars['String']>;
};

export type IKlicAsDraft = {
  channel?: InputMaybe<Scalars['String']>;
  chat?: InputMaybe<Array<InputMaybe<IStreamersChat>>>;
  isThumbnailOverridden?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  streamName?: InputMaybe<Scalars['String']>;
};

export type IKlicAsDraftV2 = {
  channel?: InputMaybe<Scalars['String']>;
  chat?: InputMaybe<Array<InputMaybe<IStreamersChatV2>>>;
  isThumbnailOverridden?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  streamName?: InputMaybe<Scalars['String']>;
};

export type IKlicChatMessageSentResponse = {
  channel?: Maybe<Scalars['String']>;
  data?: Maybe<IChatDataResponse>;
  error?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
};

export type IKlicChatMessagesResponse = {
  channel?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<IChatDataResponse>>>;
};

export type IKlicChatResponse = {
  channel?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<IChatDataResponse>>>;
};

export type IKlicResponse = {
  channel?: Maybe<IChannelResponse>;
  chat?: Maybe<Array<Maybe<IStreamersChatResponse>>>;
  isThumbnailOverridden?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type IKlicResponseV2 = {
  channel?: Maybe<ISimpleChannelResponseV2>;
  chat?: Maybe<Array<Maybe<IStreamersChatResponseV2>>>;
  isThumbnailOverridden?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  mediaOffset?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  vodUrl?: Maybe<Scalars['String']>;
  streamName?: Maybe<Scalars['String']>;
};

export type ILandingResponseV2 = {
  pastEvents?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
  categoryWithEvents: {
    slug?: string | null;
    title?: string | null;
    events: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventTag?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventOwnerAvatar?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
        startDateTimeOfEvent?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
        newStreamTypeOptions?: string | null;
      } | null;
      streamers?: Array<{
        id?: string | null;
        isPromo?: boolean | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  };
  trendingCategory: {
    id: string | null;
    name: string | null;
    slug: string | null;
    isActive: boolean | null;
    thumbnail: string | null;
    followerCount: number;
    totalEvent: number;
    totalStream: number;
    categoryTags: {
      eventType: {
        name: string | null;
      } | null;
    } | null;
  };
};

export type IListAllChannelsResponse = {
  channels?: Maybe<Array<Maybe<IChannelResponse>>>;
  error?: Maybe<Scalars['String']>;
};

export type IListAllEventsResponse = {
  error?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<IEventResponse>>>;
};

export type IListAllEventsResponseV2 = {
  events?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
};

export type IListAuthorizationsPayload = {
  authorizations?: Maybe<Array<Maybe<IAuthorization>>>;
  error?: Maybe<Scalars['String']>;
};

export type IListEventCategoriesPayload = {
  error?: Maybe<Scalars['String']>;
  eventCategories?: Maybe<Array<Maybe<IEventCategoryData>>>;
};

export type IListEventTypesPayload = {
  error?: Maybe<Scalars['String']>;
  eventTypes?: Maybe<Array<Maybe<IEventTypeData>>>;
};

export type IListEventsPayload = {
  error?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<IEventData>>>;
};

export type IListLivestreamingPayload = {
  error?: Maybe<Scalars['String']>;
  livestreamings?: Maybe<Array<Maybe<ILivestreaming>>>;
};

export type IListRolesPayload = {
  error?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<IRole>>>;
};

export type IListTransactionsPayload = {
  error?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<ITransaction>>>;
};

export type IListTransactionsUserPayload = {
  error?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<ITransactionUser>>>;
};

export type IListVideosPayload = {
  error?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<IVideo>>>;
};

export type IFeaturedCategory = {
  id?: Maybe<Scalars['Boolean']>;
  categoryId?: Maybe<Scalars['String']>;
  category?: Maybe<InputMaybe<ICategoryResponseV2>>;
};

export type ILivestreaming = {
  autoRecord?: Maybe<Scalars['Boolean']>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  forChilds?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  playbackUrl?: Maybe<Scalars['String']>;
  privacy?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ILivestreamingPayload = {
  error?: Maybe<Scalars['String']>;
  livestreaming?: Maybe<ILivestreaming>;
};

export type IMessage = {
  date?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userImg?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type IMessageChatInput = {
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<IMessageInput>;
};

export type IMessageInput = {
  date?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userImg?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type IMessagePayload = {
  error?: Maybe<Scalars['String']>;
  message?: Maybe<IChatPayload>;
};

export type IModifiedSponsorInput = {
  sponsorImage?: InputMaybe<IFileInput>;
  sponsorName?: InputMaybe<Scalars['String']>;
  sponsorUrl?: InputMaybe<Scalars['String']>;
};

export type IMonetization = {
  adFrequency?: InputMaybe<Scalars['Int']>;
  adLength?: InputMaybe<Scalars['Int']>;
  allowFreePreview: Scalars['Boolean'];
  allowFreePreviewSub: Scalars['Boolean'];
  allowNonSubscribersPPV: Scalars['Boolean'];
  allowPPVSub: Scalars['Boolean'];
  contributorsOptions?: InputMaybe<Scalars['String']>;
  freePreviewTime?: InputMaybe<Scalars['String']>;
  freePreviewTimeSub?: InputMaybe<Scalars['String']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  messageForViewers?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  monetizationType?: InputMaybe<IMonetizationType>;
  preRoll: Scalars['Boolean'];
  price1?: InputMaybe<Scalars['String']>;
  price2?: InputMaybe<Scalars['String']>;
  price3?: InputMaybe<Scalars['String']>;
  price4?: InputMaybe<Scalars['String']>;
  priceInput?: InputMaybe<IPriceInputType>;
  pricePerPPV?: InputMaybe<Scalars['String']>;
  pricePerPPVSub?: InputMaybe<Scalars['String']>;
  sponsor: Array<InputMaybe<IMonetizationSponsor>>;
  subscribersOnly: Scalars['Boolean'];
};

export type IMonetizationAsDraft = {
  adFrequency?: InputMaybe<Scalars['Int']>;
  adLength?: InputMaybe<Scalars['Int']>;
  allowFreePreview?: InputMaybe<Scalars['Boolean']>;
  allowFreePreviewSub?: InputMaybe<Scalars['Boolean']>;
  allowNonSubscribersPPV?: InputMaybe<Scalars['Boolean']>;
  allowPPVSub?: InputMaybe<Scalars['Boolean']>;
  contributorsOptions?: InputMaybe<Scalars['String']>;
  freePreviewTime?: InputMaybe<Scalars['String']>;
  freePreviewTimeSub?: InputMaybe<Scalars['String']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  messageForViewers?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  monetizationType?: InputMaybe<IMonetizationType>;
  preRoll?: InputMaybe<Scalars['Boolean']>;
  price1?: InputMaybe<Scalars['String']>;
  price2?: InputMaybe<Scalars['String']>;
  price3?: InputMaybe<Scalars['String']>;
  price4?: InputMaybe<Scalars['String']>;
  priceInput?: InputMaybe<IPriceInputType>;
  pricePerPPV?: InputMaybe<Scalars['String']>;
  pricePerPPVSub?: InputMaybe<Scalars['String']>;
  sponsor: Array<InputMaybe<IMonetizationSponsor>>;
  subscribersOnly?: InputMaybe<Scalars['Boolean']>;
};

export type IMonetizationAsDraftV2 = {
  adFrequency?: InputMaybe<Scalars['Int']>;
  adLength?: InputMaybe<Scalars['Int']>;
  allowFreePreview?: InputMaybe<Scalars['Boolean']>;
  allowFreePreviewSub?: InputMaybe<Scalars['Boolean']>;
  allowNonSubscribersPPV?: InputMaybe<Scalars['Boolean']>;
  allowPPVSub?: InputMaybe<Scalars['Boolean']>;
  contributorsOptions?: InputMaybe<Scalars['String']>;
  freePreviewTime?: InputMaybe<Scalars['String']>;
  freePreviewTimeSub?: InputMaybe<Scalars['String']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  messageForViewers?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  monetizationType?: InputMaybe<IMonetizationTypeV2>;
  preRoll?: InputMaybe<Scalars['Boolean']>;
  price1?: InputMaybe<Scalars['String']>;
  price2?: InputMaybe<Scalars['String']>;
  price3?: InputMaybe<Scalars['String']>;
  price4?: InputMaybe<Scalars['String']>;
  priceInput?: InputMaybe<IPriceInputTypeV2>;
  pricePerPPV?: InputMaybe<Scalars['String']>;
  pricePerPPVSub?: InputMaybe<Scalars['String']>;
  sponsor: Array<InputMaybe<IMonetizationSponsorV2>>;
  subscribersOnly?: InputMaybe<Scalars['Boolean']>;
};

export type IMonetizationResponse = {
  adFrequency?: Maybe<Scalars['Int']>;
  adLength?: Maybe<Scalars['Int']>;
  allowFreePreview?: Maybe<Scalars['Boolean']>;
  allowFreePreviewSub?: Maybe<Scalars['Boolean']>;
  allowNonSubscribersPPV?: Maybe<Scalars['Boolean']>;
  allowPPVSub?: Maybe<Scalars['Boolean']>;
  contributorsOptions?: Maybe<Scalars['String']>;
  freePreviewTime?: Maybe<Scalars['String']>;
  freePreviewTimeSub?: Maybe<Scalars['String']>;
  maxPrice?: Maybe<Scalars['String']>;
  messageForViewers?: Maybe<Scalars['String']>;
  minPrice?: Maybe<Scalars['String']>;
  monetizationType?: Maybe<IMonetizationType>;
  preRoll?: Maybe<Scalars['Boolean']>;
  price1?: Maybe<Scalars['String']>;
  price2?: Maybe<Scalars['String']>;
  price3?: Maybe<Scalars['String']>;
  price4?: Maybe<Scalars['String']>;
  priceInput?: Maybe<IPriceInputType>;
  pricePerPPV?: Maybe<Scalars['String']>;
  pricePerPPVSub?: Maybe<Scalars['String']>;
  ppvStripeLink?: Maybe<Scalars['String']>;
  sponsor?: Maybe<Array<Maybe<IMonetizationSponsorResponse>>>;
  subscribersOnly?: Maybe<Scalars['Boolean']>;
};

export type IMonetizationResponseV2 = {
  adFrequency?: Maybe<Scalars['Int']>;
  adLength?: Maybe<Scalars['Int']>;
  allowFreePreview?: Maybe<Scalars['Boolean']>;
  allowFreePreviewSub?: Maybe<Scalars['Boolean']>;
  allowNonSubscribersPPV?: Maybe<Scalars['Boolean']>;
  allowPPVSub?: Maybe<Scalars['Boolean']>;
  donationLink?: Maybe<Scalars['String']>;
  contributorsOptions?: Maybe<Scalars['String']>;
  freePreviewTime?: Maybe<Scalars['String']>;
  freePreviewTimeSub?: Maybe<Scalars['String']>;
  maxPrice?: Maybe<Scalars['String']>;
  messageForViewers?: Maybe<Scalars['String']>;
  minPrice?: Maybe<Scalars['String']>;
  monetizationType?: Maybe<IMonetizationTypeV2>;
  preRoll?: Maybe<Scalars['Boolean']>;
  price1?: Maybe<Scalars['String']>;
  price2?: Maybe<Scalars['String']>;
  price3?: Maybe<Scalars['String']>;
  price4?: Maybe<Scalars['String']>;
  priceInput?: Maybe<IPriceInputTypeV2>;
  pricePerPPV?: Maybe<Scalars['String']>;
  pricePerPPVSub?: Maybe<Scalars['String']>;
  ppvStripeLink?: Maybe<Scalars['String']>;
  sponsor?: Maybe<Array<Maybe<IMonetizationSponsorResponseV2>>>;
  subscribersOnly?: Maybe<Scalars['Boolean']>;
  bracketEmbedLink?: Maybe<Scalars['Boolean']>;
  bracketologyType?: Maybe<Scalars['Boolean']>;
};

export type IMonetizationSponsor = {
  sponsorAmount?: InputMaybe<Scalars['String']>;
  sponsorLogo?: InputMaybe<Scalars['String']>;
  sponsorName: Scalars['String'];
};

export type IMonetizationSponsorAsDraft = {
  sponsorAmount?: InputMaybe<Scalars['String']>;
  sponsorLogo?: InputMaybe<Scalars['String']>;
  sponsorName: Scalars['String'];
};

export type IMonetizationSponsorResponse = {
  sponsorAmount?: Maybe<Scalars['String']>;
  sponsorLogo?: Maybe<Scalars['String']>;
  sponsorName?: Maybe<Scalars['String']>;
};

export type IMonetizationSponsorResponseV2 = {
  sponsorAmount?: Maybe<Scalars['String']>;
  sponsorLogo?: Maybe<Scalars['String']>;
  sponsorName?: Maybe<Scalars['String']>;
};

export type IMonetizationSponsorV2 = {
  sponsorAmount?: InputMaybe<Scalars['String']>;
  sponsorLogo?: InputMaybe<Scalars['String']>;
  sponsorName: Scalars['String'];
};

export enum IMonetizationType {
  Advertisements = 'advertisements',
  Contributors = 'contributors',
  PayPerView = 'payPerView',
}

export enum IMonetizationTypeV2 {
  Advertisements = 'advertisements',
  Contributors = 'contributors',
  PayPerView = 'payPerView',
}

export type ICreateUserPanelInput = {
  title: Scalars['String'];
  image: Scalars['String'];
  url: Scalars['String'];
  position: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
};

export type ICreateUserMasterPanelInput = {
  master_title: Scalars['String'];
  position?: Scalars['Int'];
};

export type IMutation = {
  addLiveViewV2?: Maybe<IEntityViewResponse>;
  archiveEvent?: Maybe<IEditEventResponse>;
  attendEvent?: Maybe<IAttendEventResponse>;
  attendEventV2?: Maybe<IAttendEventResponse>;
  checkUserByEmail?: Maybe<ICheckPayload>;
  checkUserByUserName?: Maybe<ICheckPayload>;
  confirmSignUp?: Maybe<Scalars['String']>;
  createAuthorization?: Maybe<IAuthorizationPayload>;
  createCategoryV2?: Maybe<ICategoryResponseV2>;
  createEvent?: Maybe<IEventPayload>;
  createEventCategory?: Maybe<IEventCategoryPayload>;
  createEventForChannel?: Maybe<ICreateEventResponse>;
  createEventForChannelAsDraft?: Maybe<ICreateEventResponse>;
  createEventForChannelV2?: Maybe<Scalars['String']>;
  createEventType?: Maybe<IEventTypePayload>;
  createEventTypeV2?: Maybe<IEventTypeResponseV2>;
  createEventV2?: Maybe<ICreateEventResponse>;
  createLivestreaming?: Maybe<ILivestreamingPayload>;
  createPaymentIntent?: Maybe<IPaymentIntentPayload>;
  createRole?: Maybe<IRolePayload>;
  createTransaction?: Maybe<ITransactionPayload>;
  createUser?: Maybe<IUserPayload>;
  createVenueLegacy?: Maybe<Scalars['String']>;
  createVideo?: Maybe<IVideoPayload>;
  createVisitEvent?: Maybe<Scalars['String']>;
  deleteAuthorization?: Maybe<IDeletePayload>;
  deleteEvent?: Maybe<IDeletePayload>;
  deleteEventCategory?: Maybe<IDeletePayload>;
  deleteEventType?: Maybe<IDeletePayload>;
  editEvent?: Maybe<IEditEventResponse>;
  editEventV2?: Maybe<Scalars['String']>;
  updateEventChatOptionsV2?: Maybe<Scalars['String']>;
  editMediaV2?: Maybe<IStreamResponseV2>;
  enableAndDisableRecording?: Maybe<Scalars['Boolean']>;
  eventActionsV2?: Maybe<Scalars['String']>;
  deleteVideoById?: Maybe<Scalars['String']>;
  finishEvent?: Maybe<IEditEventResponse>;
  gfxImageProcessor?: Maybe<IGetPresignedUploadUrlResponseV2>;
  globalSignOutV2?: Maybe<IGlobalSignOutResponse>;
  migrateEventCategories?: Maybe<IEditEventResponse>;
  removeEvent?: Maybe<IRemoveEventResponse>;
  removeLiveViewV2?: Maybe<IEntityViewResponse>;
  sendMessageChatKlic?: Maybe<IMessagePayload>;
  sendMessageEventChat?: Maybe<IEventChatMessageSentResponse>;
  sendMessageEventChatV2?: Maybe<ISendMessageEventChatResponse>;
  pinMessageEventChatV2?: Maybe<IPinMessageEventChatResponse>;
  sendMessageKlicChat?: Maybe<IKlicChatMessageSentResponse>;
  sendMessageKlicChatV2?: Maybe<ISendMessageKlicChatResponse>;
  signUp?: Maybe<Scalars['String']>;
  startEvent?: Maybe<IEditEventResponse>;
  startStreamerByAdmin?: Maybe<IStreamersResponseV2>;
  stopStreamerByAdmin?: Maybe<IStreamersResponseV2>;
  updateAboutpage?: Maybe<IAboutPayload>;
  updateAuthorization?: Maybe<IAuthorizationPayload>;
  updateCategoryV2?: Maybe<ICategoryResponseV2>;
  updateChannel?: Maybe<IChannelPayload>;
  updateEvent?: Maybe<IEventPayload>;
  updateEventCategory?: Maybe<IEventCategoryPayload>;
  updateEventType?: Maybe<IEventTypePayload>;
  updateEventTypeV2?: Maybe<IEventTypeResponseV2>;
  updateEventViewers?: Maybe<IUpdateEventViewersResponse>;
  updateEventViews?: Maybe<IUpdateEventViewsResponse>;
  updateHomepageVideos?: Maybe<IHomepageVideosPayload>;
  updateLivestreaming?: Maybe<ILivestreamingPayload>;
  updateUserProfile?: Maybe<IUserPayload>;
  updateUserProfileV2?: Maybe<IUpdateUserProfileResponseV2>;
  updateVideo?: Maybe<IVideoPayload>;
  followChannelV2?: Maybe<IFollowChannelPayload>;
  unfollowChannelV2?: Maybe<IFollowChannelPayload>;
  followCategoryV2?: Maybe<Scalars['String']>;
  UpdateSocialLinkV2?: Maybe<IUpdateSocialLinkMutation>;
  userLockUnlockV2?: Maybe<IAdminUserLockMutation>;
  followChannelAction?: Maybe<FollowChannelActionMutation>;
};

export type IMutationAddLiveViewV2Args = {
  id: Scalars['String'];
  type: Scalars['String'];
};

export type IMutationArchiveEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationAttendEventArgs = {
  eventId?: InputMaybe<Scalars['String']>;
  userData?: InputMaybe<IUserDataInput>;
};

export type IMutationAttendEventV2Args = {
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type IMutationCheckUserByEmailArgs = {
  checkUserByEmailRequest?: InputMaybe<ICheckUserByEmail>;
};

export type IMutationCheckUserByUserNameArgs = {
  checkUserByUserNameRequest?: InputMaybe<ICheckUserByUserName>;
};

export type IMutationConfirmSignUpArgs = {
  confirmSignUpPayload?: InputMaybe<IConfirmSignUpPayload>;
};

export type IMutationCreateAuthorizationArgs = {
  createAuthorizationPayload?: InputMaybe<ICreateAuthorizationInput>;
};

export type IMutationCreateCategoryV2Args = {
  createCategoryInput?: InputMaybe<ICreateCategoryInput>;
};

export type IMutationCreateEventArgs = {
  createEventPayload?: InputMaybe<ICreateEventInput>;
};

export type IMutationCreateEventCategoryArgs = {
  eventCategory?: InputMaybe<Scalars['String']>;
};

export type IMutationCreateEventForChannelArgs = {
  createEventForChannelRequest?: InputMaybe<ICreateEventForChannelInput>;
};

export type IMutationCreateEventForChannelAsDraftArgs = {
  createEventForChannelAsDraftRequest?: InputMaybe<ICreateEventForChannelAsDraftInput>;
};

export type IMutationCreateEventForChannelV2Args = {
  createEventInput?: InputMaybe<ICreateEventForChannelAsDraftInputV2>;
};

export type IMutationCreateEventTypeArgs = {
  eventType?: InputMaybe<Scalars['String']>;
};

export type IMutationCreateEventTypeV2Args = {
  createEventTypeInput?: InputMaybe<ICreateEventTypeInput>;
};

export type IMutationCreateEventV2Args = {
  createEventForChannelAsDraftRequest?: InputMaybe<ICreateEventForChannelAsDraftInput>;
};

export type IMutationCreateLivestreamingArgs = {
  createLivestreamingPayload?: InputMaybe<ICreateLivestreamingInput>;
};

export type IMutationCreatePaymentIntentArgs = {
  createPaymentIntentPayload?: InputMaybe<ICreatePaymentIntentInput>;
};

export type IMutationCreateRoleArgs = {
  createRolePayload?: InputMaybe<ICreateRoleInput>;
};

export type IMutationCreateTransactionArgs = {
  createTransactionPayload?: InputMaybe<ICreateTransactionInput>;
};

export type IMutationCreateUserArgs = {
  createUserPayload?: InputMaybe<ICreateUserInput>;
};
export type IMutationFollowChannelV2MutationVariables = {
  followChannelPayload?: InputMaybe<IFollowChannelInput>;
};

export type IMutationCreateVenueLegacyArgs = {
  userId?: InputMaybe<Scalars['String']>;
};

export type IMutationCreateVideoArgs = {
  createVideoPayload?: InputMaybe<ICreateVideoInput>;
};

export type IMutationCreateVisitEventArgs = {
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type IMutationDeleteAuthorizationArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationDeleteEventArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationDeleteEventCategoryArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationDeleteEventTypeArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationEditEventArgs = {
  editEventRequest?: InputMaybe<ICreateEventForChannelAsDraftInput>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationEditEventV2Args = {
  editEventInput?: InputMaybe<IEditEventInputV2>;
};

export type IMutationEditMediaV2Args = {
  editMediaInput?: InputMaybe<IEditMediaInput>;
};

export type IMutationEnableAndDisableRecordingArgs = {
  activate?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationEventActionsV2Args = {
  action: IEventActionType;
  eventId: Scalars['String'];
};

export type IMutationFinishEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationGetPresignedUploadUrlV2Args = {
  key: Scalars['String'];
  type: Scalars['String'];
};

export type IMutationGlobalSignOutV2Args = {
  username: Scalars['String'];
};

export type IMutationRemoveEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationRemoveLiveViewV2Args = {
  id: Scalars['String'];
  type: Scalars['String'];
};

export type IMutationSendMessageChatKlicArgs = {
  messagePayload?: InputMaybe<IMessageChatInput>;
};

export type IMutationSendMessageEventChatArgs = {
  chatData?: InputMaybe<IChatDataInput>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationSendMessageEventChatV2Args = {
  chatData: IChatDataInput;
  eventId: Scalars['String'];
};

export type IMutationSendMessageKlicChatArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  chatData?: InputMaybe<IChatDataInput>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationSendMessageKlicChatV2Args = {
  channelId: Scalars['String'];
  chatData: IChatDataInput;
  eventId: Scalars['String'];
};

export type IMutationSignUpArgs = {
  signUpPayload?: InputMaybe<ISignupPayload>;
};

export type IMutationStartEventArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IMutationStartStreamerByAdminArgs = {
  streamerId: Scalars['String'];
};

export type IMutationStopStreamerByAdminArgs = {
  streamerId: Scalars['String'];
};

export type IMutationUpdateAboutpageArgs = {
  aboutPayload?: InputMaybe<IUpdateAboutpageInput>;
};

export type IMutationUpdateAuthorizationArgs = {
  updateAuthorizationPayload?: InputMaybe<IUpdateAuthorizationInput>;
};

export type IMutationUpdateCategoryV2Args = {
  updateCategoryInput?: InputMaybe<IUpdateCategoryInput>;
};

export type IMutationUpdateChannelArgs = {
  updateChannelPayload?: InputMaybe<IUpdateChannelInput>;
};

export type IMutationUpdateEventArgs = {
  updateEventPayload?: InputMaybe<IUpdateEventInput>;
};

export type IMutationUpdateEventCategoryArgs = {
  updateEventCategoryPayload?: InputMaybe<IUpdateEventCategoryInput>;
};

export type IMutationUpdateEventTypeArgs = {
  updateEventTypePayload?: InputMaybe<IUpdateEventTypeInput>;
};

export type IMutationUpdateEventTypeV2Args = {
  updateEventTypeInput?: InputMaybe<IUpdateEventTypeInput>;
};

export type IMutationUpdateEventViewersArgs = {
  id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type IMutationUpdateEventViewsArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type IMutationUpdateHomepageVideosArgs = {
  updateHomepageVideosPayload?: InputMaybe<IUpdateHomepageVideosInput>;
};

export type IMutationUpdateLivestreamingArgs = {
  updateLivestreamingPayload?: InputMaybe<IUpdateLivestreamingInput>;
};

export type IMutationUpdateUserProfileArgs = {
  updateUserPayload?: InputMaybe<IUpdateUserInput>;
};

export type IMutationUpdateUserProfileV2Args = {
  updateUserProfileInput?: InputMaybe<IUpdateUserProfileInput>;
};

export type IMutationUpdateVideoArgs = {
  updateVideoPayload?: InputMaybe<IUpdateVideoInput>;
};

export type ISubscribeChannelMutationVariables = {
  createSubscription?: InputMaybe<ISubscribeChannelPayload>;
};

export type ISubscribeChannelPayload = {
  channelId: Scalars['String'];
  userId: Scalars['String'];
  planId: Scalars['String'];
  subscriptionType: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  identifier: Scalars['String'];
  paymentMode: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export type ISubscribeChannelMutation = {
  createSubscriptionV2?: string | null;
};

export type IOptions = {
  allowOtherChats: Scalars['Boolean'];
  isPrivateEvent: Scalars['Boolean'];
  numberOfChatsPerStream?: InputMaybe<Scalars['Int']>;
  privateEventPassword?: InputMaybe<Scalars['String']>;
  recordEvent: Scalars['Boolean'];
  recordEventExpirationDate?: InputMaybe<Scalars['String']>;
};

export type IOptionsAsDraft = {
  allowOtherChats?: InputMaybe<Scalars['Boolean']>;
  isPrivateEvent?: InputMaybe<Scalars['Boolean']>;
  numberOfChatsPerStream?: InputMaybe<Scalars['Int']>;
  privateEventPassword?: InputMaybe<Scalars['String']>;
  recordEvent?: InputMaybe<Scalars['Boolean']>;
  recordEventExpirationDate?: InputMaybe<Scalars['String']>;
};

export type IOptionsAsDraftV2 = {
  allowOtherChats?: InputMaybe<Scalars['Boolean']>;
  isPrivateEvent?: InputMaybe<Scalars['Boolean']>;
  numberOfChatsPerStream?: InputMaybe<Scalars['Int']>;
  privateEventPassword?: InputMaybe<Scalars['String']>;
  recordEvent?: InputMaybe<Scalars['Boolean']>;
  recordEventExpirationDate?: InputMaybe<Scalars['String']>;
  isFollowerOnly?: InputMaybe<Scalars['Boolean']>;
};

export type IOptionsResponse = {
  allowOtherChats?: Maybe<Scalars['Boolean']>;
  isPrivateEvent?: Maybe<Scalars['Boolean']>;
  numberOfChatsPerStream?: Maybe<Scalars['Int']>;
  privateEventPassword?: Maybe<Scalars['String']>;
  recordEvent?: Maybe<Scalars['Boolean']>;
  recordEventExpirationDate?: Maybe<Scalars['String']>;
};

export type IOptionsResponseV2 = {
  allowOtherChats?: Maybe<Scalars['Boolean']>;
  isPrivateEvent?: Maybe<Scalars['Boolean']>;
  numberOfChatsPerStream?: Maybe<Scalars['Int']>;
  privateEventPassword?: Maybe<Scalars['String']>;
  recordEvent?: Maybe<Scalars['Boolean']>;
  recordEventExpirationDate?: Maybe<Scalars['String']>;
  isFollowerOnly?: Maybe<Scalars['Boolean']>;
  newStreamTypeOptions?: Maybe<Scalars['String']>;
};

export type IPaymentIntentPayload = {
  clientSecret?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type IPaymentMeta = {
  stripePaymentMethod?: InputMaybe<Scalars['String']>;
};

export type IPresignedUploadInput = {
  key?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type IPresignedUploadVideoInput = {
  key?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export enum IPriceInputType {
  ExactAmount = 'exactAmount',
  PriceRange = 'priceRange',
}

export enum IPriceInputTypeV2 {
  ExactAmount = 'exactAmount',
  PriceRange = 'priceRange',
}

export type IQuery = {
  checkEmailV2?: Maybe<IIsTakenResponseV2>;
  checkPpvVisit?: Maybe<ICheckPpvVisitResponse>;
  checkUsernameV2?: Maybe<IIsTakenResponseV2>;
  getAboutpage?: Maybe<IGetAboutpagePayload>;
  getAllChannels?: Maybe<Array<Maybe<IChannelResponseV2>>>;
  getAllChatMessagesForEventChat?: Maybe<IEventChatResponse>;
  getAllChatMessagesForKlicChat?: Maybe<IKlicChatResponse>;
  getAttendeesV2?: Maybe<Array<Maybe<IUserSimpleResponseV2>>>;
  getAuthorByChannelAndUser?: Maybe<IAuthorizationPayload>;
  getCategoriesV2?: Maybe<Array<Maybe<ICategoryResponseV2>>>;
  getChannelById?: Maybe<IChannelPayload>;
  getChannelV2?: Maybe<IChannelResponseV2>;
  getCredentialsLivestreaming?: Maybe<ICredentialsLivestreamingPayload>;
  getCurrentLiveStream?: Maybe<IGetCurrentLiveStreamResponse>;
  getEvent?: Maybe<IEventPayload>;
  getEventById?: Maybe<IGetEventByIdResponse>;
  getEventByIdV2?: Maybe<ISimpleEventResponse>;
  getEventChatMessagesV2?: Maybe<IEventChatMessagesResponse>;
  getEventTypesV2?: Maybe<Array<Maybe<IEventTypeResponseV2>>>;
  getEventsForCarouselV2?: Maybe<Array<Maybe<IGetEventsForCarouselV2>>>;
  getCarouselEventsV2?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
  getCarouselEventsV3?: Maybe<Array<Maybe<ISimpleEventResponse>>>;
  getEventsForChannel?: Maybe<IListAllEventsResponseV2>;
  getEventList?: Maybe<IListAllEventsResponseV2>;
  getExistsChannel?: Maybe<Scalars['Boolean']>;
  getHomepageVideos?: Maybe<IGetHomepageVideosPayload>;
  getIsLiveChannel?: Maybe<Scalars['Boolean']>;
  getKlicChatMessagesV2?: Maybe<IKlicChatMessagesResponse>;
  getLandingVideos?: Maybe<IGetLandingVideos>;
  getListVideosByChannel?: Maybe<IListVideosPayload>;
  getLivestreamingByChannel?: Maybe<ILivestreamingPayload>;
  getMeV2?: Maybe<IUserResponseV2>;
  getAboutMeV2?: Maybe<IAboutMeResponseV2>;
  getMediasForChannel?: Maybe<Array<Maybe<IStreamResponseV2>>>;
  getPresignedUploadUrl?: Maybe<Scalars['String']>;
  getPresignedUploadVideoUrl?: Maybe<Scalars['String']>;
  getRecentVideos?: Maybe<IListVideosPayload>;
  getRecentVideosByChannel?: Maybe<IListVideosPayload>;
  getRoleById?: Maybe<IRolePayload>;
  getSignedUrlV2?: Maybe<IGetSignedUrlResponseV2>;
  getStreamV2?: Maybe<IStreamResponseV2>;
  getStreamViewerV2?: Maybe<IStreamResponse>;
  getThumbnail?: Maybe<IGetThumbnailResponse>;
  getTransactionByUserAndEvent?: Maybe<ITransactionPayload>;
  getTransactionsByUser?: Maybe<IListTransactionsUserPayload>;
  getUserByEmail?: Maybe<IUserPayload>;
  getUserById?: Maybe<IUserPayload>;
  getUserByUsernameV2?: Maybe<IUserResponseV2>;
  getVideoById?: Maybe<IVideoPayload>;
  getVideosForChannel?: Maybe<IListVideosPayload>;
  getViews?: Maybe<IEntityViewResponse>;
  listAllAuthorByChannelId?: Maybe<IListAuthorizationsPayload>;
  listAllChannels?: Maybe<IListAllChannelsResponse>;
  listAllEvents?: Maybe<IListEventsPayload>;
  listAllEventsForAdmin?: Maybe<IListEventsPayload>;
  listAllEventsForChannel?: Maybe<IListAllEventsResponse>;
  listAllRolesByChannelId?: Maybe<IListRolesPayload>;
  listAllTransactions?: Maybe<IListTransactionsPayload>;
  listEventCategories?: Maybe<IListEventCategoriesPayload>;
  listEventTypes?: Maybe<IListEventTypesPayload>;
  sendMessageContactUs?: Maybe<ISendMessagePayload>;
  userPaymentStatus?: Maybe<IUserPaymentStatusPayload>;
  getPlanListV2?: Maybe<IPlanListResponseV2>;
  FollowCategoryV2?: Maybe<IIsTakenResponseV2>;
  getMeAboutV2?: Maybe<IGetAboutMeQuery>;
  GetFollowerListV2?: Maybe<IGetFollowerListQuery>;
  getFollowerByChannel?: Maybe<IGetFollowingQuery>;
  getPanelByUserId?: Maybe<IGetPanelByUserIdQuery>;
  getChannelEventStreams?: Maybe<IGetChannelEventStreamsQuery>;
  getRevenueChart?: Maybe<IGetRevenueChartQuery>;
  getChannelEventByStatusV2?: Maybe<IChannelEventResponse>;
};

export type IQueryCheckEmailV2Args = {
  email: Scalars['String'];
};

export type IQueryCheckPpvVisitArgs = {
  cache: Scalars['String'];
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryCheckUsernameV2Args = {
  username: Scalars['String'];
};

export type IQueryGetAllChatMessagesForEventChatArgs = {
  eventId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetAllChatMessagesForKlicChatArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetAttendeesV2Args = {
  userIds: Array<InputMaybe<Scalars['String']>>;
};

export type IQueryGetAuthorByChannelAndUserArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetChannelByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetChannelV2Args = {
  username: Scalars['String'];
};

export type IQueryGetCredentialsLivestreamingArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetCurrentLiveStreamArgs = {
  channelArn: Scalars['String'];
  eventId?: InputMaybe<Scalars['String']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
};

export type IQueryGetEventArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetEventByIdArgs = {
  eventId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetEventByIdV2Args = {
  channelName: Scalars['String'];
  slug: Scalars['String'];
};

export type IQueryGetEventChatMessagesV2Args = {
  eventId: Scalars['String'];
};

export type IQueryGetEventsForChannelArgs = {
  channelId: Scalars['String'];
};

export type IQueryGetExistsChannelArgs = {
  subId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetIsLiveChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetKlicChatMessagesV2Args = {
  channelId: Scalars['String'];
  eventId: Scalars['String'];
};

export type IQueryGetLandingDataV2Args = {
  withVod?: InputMaybe<Scalars['Boolean']>;
};

export type IQueryGetListVideosByChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetLivestreamingByChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetMeV2Args = {
  token: Scalars['String'];
};

export type IQueryGetMediasForChannelArgs = {
  username: Scalars['String'];
};

export type IQueryGetPresignedUploadUrlArgs = {
  presignedUploadInput?: InputMaybe<IPresignedUploadInput>;
};

export type IQueryGetPresignedUploadVideoUrlArgs = {
  presignedUploadVideoInput?: InputMaybe<IPresignedUploadVideoInput>;
};

export type IQueryGetRecentVideosByChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetRoleByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetSignedUrlV2Args = {
  key: Scalars['String'];
};

export type IQueryGetStreamV2Args = {
  getStreamInput?: InputMaybe<IGetStreamInput>;
};

export type IQueryGetThumbnailArgs = {
  path: Scalars['String'];
};

export type IQueryGetTransactionByUserAndEventArgs = {
  eventId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetTransactionsByUserArgs = {
  userId?: InputMaybe<Scalars['String']>;
};

export type IQueryGetUserByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};

export type IQueryGetUserByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetUserByUsernameV2Args = {
  username: Scalars['String'];
};

export type IQueryGetVideoByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetVideosForChannelArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQueryGetViewsArgs = {
  id: Scalars['String'];
  type: Scalars['String'];
};

export type IQueryListAllAuthorByChannelIdArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};

export type IQueryListAllEventsForChannelArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};

export type IQueryListAllRolesByChannelIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type IQuerySendMessageContactUsArgs = {
  email?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type IQueryUserPaymentStatusArgs = {
  paymentStatusPayload?: InputMaybe<IUserPaymentStatusInput>;
};

export type IRemoveEventResponse = {
  data?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type IRole = {
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  roleState?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IRolePayload = {
  error?: Maybe<Scalars['String']>;
  role?: Maybe<IRole>;
};

export type IRoleResponseV2 = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ISendMessageEventChatResponse = {
  data?: Maybe<IChatDataResponse>;
  event?: Maybe<Scalars['String']>;
};

export type IPinMessageEventChatResponse = {
  data?: Maybe<IChatDataResponse>;
  event?: Maybe<Scalars['String']>;
};
export type ISendMessageKlicChatResponse = {
  channel?: Maybe<Scalars['String']>;
  data?: Maybe<IChatDataResponse>;
  event?: Maybe<Scalars['String']>;
};

export type ISendMessagePayload = {
  error?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type IShowcaseEvent = {
  eventDescription?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventTitle?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  stream?: Maybe<IStream>;
  streamUrl?: Maybe<Scalars['String']>;
};

export type IShowcaseEventData = {
  event?: Maybe<IEventData>;
  eventDescription?: Maybe<Scalars['String']>;
  eventTitle?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  stream?: Maybe<IStream>;
  streamUrl?: Maybe<Scalars['String']>;
};

export type IShowcaseEventInput = {
  eventDescription?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  eventTitle?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  stream?: InputMaybe<IStreamInput>;
  streamUrl?: InputMaybe<Scalars['String']>;
};

export type ISignupPayload = {
  email: Scalars['AWSEmail'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ISimpleChannelResponseV2 = {
  avatar?: string;
  channelArn?: Maybe<Scalars['String']>;
  channelInputUrl?: Maybe<Scalars['String']>;
  channelStreamKey?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isChannelLive?: Maybe<Scalars['String']>;
  ivsChannelName?: Maybe<Scalars['String']>;
  liveUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<ISimpleChannelUserResponse>;
  userId?: Maybe<Scalars['String']>;
  followcount?: Maybe<Scalars['Int']>;
  aboutme?: Maybe<Scalars['String']>;
};

export type ISimpleChannelUserResponse = {
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export type IPaymentHistoryResponse = {
  id: string | null;
  userId: string | null;
  fromUserId: string | null;
  paymentMethod: string | null;
  amount: string | null;
  type: string | null;
  paymentDate: string | null;
  buyer: {
    avatar: string | null;
    heading: string | null;
    username: string | null;
  } | null;
  owner: {
    avatar: string | null;
    heading: string | null;
    username: string | null;
  } | null;
  subscription: {
    id: string | null;
    planId: string | null;
    startDate: string | null;
    endDate: string | null;
    paymentMode: string | null;
    isActive: boolean | null;
  };
};
export type ISimpleEventResponse = {
  attendees?: Maybe<Array<Maybe<Scalars['String']>>>;
  availableActions?: Maybe<IAvailableActionsTypeV2>;
  ownerChannelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  details?: Maybe<IDetailsResponseV2>;
  eventStartedAt?: Maybe<Scalars['String']>;
  eventStoppedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  monetization?: Maybe<IMonetizationResponseV2>;
  options?: Maybe<IOptionsResponseV2>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<IStatusTypeV2>;
  streamers?: Maybe<Array<Maybe<IStreamersResponseV2>>>;
  viewers?: Maybe<IEntityViewResponse>;
};

export type ISimplePlanResponseV2 = {
  annual_price?: Maybe<Scalars['Int']>;
  description: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  paypal_annual: Maybe<Scalars['String']>;
  paypal_monthly?: Maybe<Scalars['String']>;
  revenue: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  stripe_annual?: Maybe<Scalars['String']>;
  stripe_monthly?: Maybe<Scalars['String']>;
  vod_storage?: Maybe<Scalars['Int']>;
  monthly_price?: Maybe<Scalars['Int']>;
  klic_stream?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['Boolean']>;
  monitization?: Maybe<Scalars['Boolean']>;
  streamType?: Maybe<Scalars['Boolean']>;
  bracktology?: Maybe<Scalars['Boolean']>;
};

export type ISponsor = {
  index?: Maybe<Scalars['String']>;
  sponsorLogo?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ISponsorInput = {
  index?: InputMaybe<Scalars['String']>;
  sponsorLogo?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type IFollowerListV2 = {
  avatar?: Maybe<Scalars['String']>;
  channel?: Maybe<{
    channelArn?: Maybe<Scalars['String']>;
    channelInputUrl?: Maybe<Scalars['String']>;
    channelStreamKey?: Maybe<Scalars['String']>;
    id: Scalars['String'];
    isChannelLive?: Maybe<Scalars['String']>;
    ivsChannelName?: Maybe<Scalars['String']>;
    liveUrl?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    userId?: Maybe<Scalars['String']>;
    followcount?: Maybe<Scalars['Int']>;
    aboutme?: Maybe<Scalars['String']>;
  } | null> | null;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  isSubscribed?: Scalars['Boolean'];
  isTBlock?: Scalars['Boolean'];
  created_at?: Maybe<Scalars['String']>;
};

export enum IStatusType {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Past = 'PAST',
  Recorded = 'RECORDED',
  Scheduled = 'SCHEDULED',
}

export enum IStatusTypeV2 {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Past = 'PAST',
  Recorded = 'RECORDED',
  Scheduled = 'SCHEDULED',
}

export type IStream = {
  chatKlic?: Maybe<IChat>;
  chatsOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  discordChatUrl?: Maybe<Scalars['String']>;
  embedCode?: Maybe<Scalars['String']>;
  facebookChatUrl?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  homeThumbnailVod?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  streamPosition?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  subHeading?: Maybe<Scalars['String']>;
  techName?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  twitchChatUrl?: Maybe<Scalars['String']>;
  viewers?: Maybe<Scalars['Int']>;
  youtubeChatCode?: Maybe<Scalars['String']>;
};

export type IStreamInput = {
  chatKlic?: InputMaybe<IChatInput>;
  chatsOrder?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  discordChatUrl?: InputMaybe<Scalars['String']>;
  embedCode?: InputMaybe<Scalars['String']>;
  facebookChatUrl?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
  homeThumbnailVod?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  streamPosition?: InputMaybe<Scalars['String']>;
  streamUrl?: InputMaybe<Scalars['String']>;
  subHeading?: InputMaybe<Scalars['String']>;
  techName?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  twitchChatUrl?: InputMaybe<Scalars['String']>;
  viewers?: InputMaybe<Scalars['Int']>;
  youtubeChatCode?: InputMaybe<Scalars['String']>;
};

export type IStreamResponseV2 = {
  id?: Maybe<Scalars['String']>;
  isChannelLive?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  livePlaybackUrl?: Maybe<Scalars['String']>;
  masterKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  playlistDuration?: Maybe<Scalars['String']>;
  recordingStartedAt?: Maybe<Scalars['String']>;
};
export type IStreamResponse = {
  id?: Maybe<Scalars['String']>;
  isChannelLive?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  livePlaybackUrl?: Maybe<Scalars['String']>;
  masterKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  playlistDuration?: Maybe<Scalars['String']>;
  recordingStartedAt?: Maybe<Scalars['String']>;
  viewerCount?: Maybe<Scalars['Int']>;
};
export type IStreamerInput = {
  chatsOrder?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discordChatUrl?: InputMaybe<Scalars['String']>;
  facebookChatUrl?: InputMaybe<Scalars['String']>;
  streamTech?: InputMaybe<Scalars['String']>;
  streamerLogo?: InputMaybe<IFileInput>;
  streamerThumbnail?: InputMaybe<IFileInput>;
  streamerTitle?: InputMaybe<Scalars['String']>;
  streamerUrl?: InputMaybe<Scalars['String']>;
  subHeading?: InputMaybe<Scalars['String']>;
  twitchChatUrl?: InputMaybe<Scalars['String']>;
  youtubeChatCode?: InputMaybe<Scalars['String']>;
};

export type IStreamers = {
  emailInvite?: InputMaybe<IEmailInvite>;
  embedStreams?: InputMaybe<IEmbedStreams>;
  klic?: InputMaybe<IKlic>;
  type: IStreamsType;
};

export type IStreamersAsDraft = {
  emailInvite?: InputMaybe<IEmailInviteAsDraft>;
  embedStreams?: InputMaybe<IEmbedStreamsAsDraft>;
  klic?: InputMaybe<IKlicAsDraft>;
  type?: InputMaybe<IStreamsType>;
};

export type IStreamersAsDraftEditV2 = {
  emailInvite?: InputMaybe<IEmailInviteAsDraft>;
  embedStreams?: InputMaybe<IEmbedStreamsAsDraftV2>;
  id?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  klic?: InputMaybe<IKlicAsDraftV2>;
  type?: InputMaybe<IStreamsTypeV2>;
};

export type IStreamersAsDraftV2 = {
  emailInvite?: InputMaybe<IEmailInviteAsDraft>;
  embedStreams?: InputMaybe<IEmbedStreamsAsDraftV2>;
  klic?: InputMaybe<IKlicAsDraftV2>;
  type?: InputMaybe<IStreamsTypeV2>;
  categoryId?: InputMaybe<Scalars['String']>;
};

export type IStreamersChat = {
  type: Scalars['String'];
  url: Scalars['String'];
};

export type IStreamersChatAsDraft = {
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type IStreamersChatAsDraftV2 = {
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type IStreamersChatResponse = {
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type IStreamersChatResponseV2 = {
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type IStreamersChatV2 = {
  type: Scalars['String'];
  url: Scalars['String'];
};

export type IStreamersResponse = {
  emailInvite?: Maybe<IEmailInviteResponse>;
  embedStreams?: Maybe<IEmbedStreamsResponse>;
  klic?: Maybe<IKlicResponseV2>;
  type?: Maybe<IStreamsType>;
};

export type IStreamersResponseV2 = {
  emailInvite?: Maybe<IEmailInviteResponseV2>;
  embedStreams?: Maybe<IEmbedStreamsResponseV2>;
  streamName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isEventActive?: Maybe<Scalars['Boolean']>;
  isPromo?: Maybe<Scalars['Boolean']>;
  klic?: Maybe<IKlicResponseV2>;
  media?: Maybe<IStreamResponseV2>;
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<IStreamsTypeV2>;
  viewers?: Maybe<IEntityViewResponse>;
  category?: Maybe<ICategoryResponseV3>;
};

export enum IStreamsType {
  EmailInvite = 'EMAIL_INVITE',
  EmbedStreams = 'EMBED_STREAMS',
  Klic = 'KLIC',
}

export enum IStreamsTypeV2 {
  EmailInvite = 'EMAIL_INVITE',
  EmbedStreams = 'EMBED_STREAMS',
  Klic = 'KLIC',
}

export type ISubscription = {
  onAttendEventV2?: Maybe<IAttendEventResponse>;
  onAttendUpdate?: Maybe<IAttendEventResponse>;
  onSendMessageChatKlic?: Maybe<IMessagePayload>;
  onSendMessageEventChat?: Maybe<IEventChatMessageSentResponse>;
  onNewSendMessageEventChatV2?: Maybe<ISendMessageEventChatResponse>;
  onPinMessageEventChatV2?: Maybe<IPinMessageEventChatResponse>;
  onSendMessageKlicChat?: Maybe<IKlicChatMessageSentResponse>;
  onSendMessageKlicChatV2?: Maybe<ISendMessageKlicChatResponse>;
  onStartStreamerByAdmin?: Maybe<IStreamersResponseV2>;
  onStopStreamerByAdmin?: Maybe<IStreamersResponseV2>;
  onUpdateEventViewers?: Maybe<IUpdateEventViewersResponse>;
  onUpdateEventViews?: Maybe<IUpdateEventViewsResponse>;
  onViewerNumberChange?: Maybe<IEntityViewResponse>;
  onEventActionChange?: Maybe<IEntityViewResponse>;
};

export type ISubscriptionOnUpdateEventViewsArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type ITestimonial = {
  btnText?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  testimony?: Maybe<Scalars['String']>;
  urlInfo?: Maybe<Scalars['String']>;
};

export type ITestimonialData = {
  btnText?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  testimony?: Maybe<Scalars['String']>;
  urlInfo?: Maybe<Scalars['String']>;
};

export type ITransaction = {
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receipt_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ITransactionPayload = {
  error?: Maybe<Scalars['String']>;
  transaction?: Maybe<ITransaction>;
};

export type ITransactionUser = {
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  receipt_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ITrustedBy = {
  img?: Maybe<Scalars['String']>;
};

export type ITrustedByData = {
  img?: Maybe<Scalars['String']>;
};

export type IUpcomingEvent = {
  event?: Maybe<IEvent>;
  eventId?: Maybe<Scalars['String']>;
};

export type IUpcomingEventData = {
  event?: Maybe<IEvent>;
  eventId?: Maybe<Scalars['String']>;
};

export type IUpcomingEventInput = {
  eventId?: InputMaybe<Scalars['String']>;
};

export type IUpdateAboutpageInput = {
  aboutFeatures?: InputMaybe<Array<InputMaybe<IAboutFeatureInput>>>;
  details?: InputMaybe<IAboutDetailsInput>;
  testimonials?: InputMaybe<Array<InputMaybe<ITestimonialInput>>>;
  trustedBy?: InputMaybe<Array<InputMaybe<ITrustedByInput>>>;
  upcomingEvents?: InputMaybe<Array<InputMaybe<IUpcomingEventInput>>>;
};

export type IUpdateAuthorizationInput = {
  authState?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IUpdateCategoryInput = {
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IUpdateChannelInput = {
  banner?: InputMaybe<Scalars['String']>;
  channelArn?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imagen?: InputMaybe<Scalars['String']>;
  ingestServer?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  streamKey?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  watermark?: InputMaybe<Scalars['String']>;
};

export type IUpdateEventCategoryInput = {
  eventCategory?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type IUpdateEventInput = {
  address?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  chats?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endTime?: InputMaybe<Scalars['String']>;
  ended?: InputMaybe<Scalars['Boolean']>;
  eventDate?: InputMaybe<Scalars['String']>;
  eventState?: InputMaybe<Scalars['String']>;
  eventStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventTime?: InputMaybe<Scalars['String']>;
  eventTimezone?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  imgDescription?: InputMaybe<Scalars['String']>;
  organizer?: InputMaybe<Scalars['String']>;
  paidEvent?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  priceId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sponsorLogos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sponsors?: InputMaybe<Array<InputMaybe<ISponsorInput>>>;
  startTime?: InputMaybe<Scalars['String']>;
  streamData?: InputMaybe<Array<InputMaybe<IStreamInput>>>;
  streamingFrom?: InputMaybe<Scalars['String']>;
  subHeading?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalStreamViews?: InputMaybe<Scalars['Int']>;
  totalViews?: InputMaybe<Scalars['Int']>;
  viewedUser?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  viewers?: InputMaybe<Scalars['Int']>;
};

export type IUpdateEventTypeInput = {
  eventType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type IUpdateEventViewersResponse = {
  email?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  viewers?: Maybe<IEventDataViewersResponse>;
};

export type IUpdateEventViewsResponse = {
  email?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  totalViews?: Maybe<IEventDataResponse>;
};

export type IUpdateHomepageVideosInput = {
  featuredEvents?: InputMaybe<Array<InputMaybe<IFeaturedEventInput>>>;
  recentVods?: InputMaybe<Array<InputMaybe<IFeaturedEventInput>>>;
  showcaseEvents?: InputMaybe<Array<InputMaybe<IShowcaseEventInput>>>;
};

export type IUpdateLivestreamingInput = {
  autoRecord?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  forChilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type IUpdateUserInput = {
  avatar?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type IUpdateUserProfileInput = {
  avatar?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};
export type IUserProfileInput = {
  firstName?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  kick?: InputMaybe<Scalars['String']>;
  twitch?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  firstLogin?: InputMaybe<Scalars['Boolean']>;
};
export type ICongnitoProfileInput = {
  userId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
};

export type IUpdateUserProfileResponseV2 = {
  avatar?: Maybe<Scalars['String']>;
  cognitoId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};
export type IUpdateVideoInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  channelId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  forChilds?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  playbackUrl?: InputMaybe<Scalars['String']>;
  privacy?: InputMaybe<Scalars['String']>;
  recordingSessionId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnail?: InputMaybe<Scalars['String']>;
  thumbnailsPath?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type IUser = {
  avatar?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userData?: Maybe<IUserData>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  isLock?: Maybe<Scalars['Boolean']>;
  isTempLock?: Maybe<Scalars['Boolean']>;
};

export type IUserData = {
  avatar?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  displayEmail?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type IUserDataInput = {
  userDisplayName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IUserPayload = {
  error?: Maybe<Scalars['String']>;
  user?: Maybe<IUser>;
};

export type IUserPaymentStatusInput = {
  eventId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type IUserPaymentStatusPayload = {
  error?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Boolean']>;
};

export type IAboutMeResponseV2 = Maybe<Array<{
  text: string;
  link?: string | null;
} | null> | null>;
export type IUserResponseV2 = {
  avatar?: Maybe<Scalars['String']>;
  channel?: Maybe<ISimpleChannelResponseV2>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  role: IRoleResponseV2;
  username: Scalars['String'];
  lastUpdated?: Scalars['String'];
  firstLogin?: Scalars['Boolean'];
  isLock?: Scalars['Boolean'];
  isTempLock?: Scalars['Boolean'];
  isSubscribed?: Scalars['Boolean'];
  plan?: Maybe<ISimplePlanResponseV2>;
  twitch?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  kick?: Maybe<Scalars['String']>;
  google_account?: Maybe<Scalars['String']>;
  twitter_account?: Maybe<Scalars['String']>;
  apple_account?: Maybe<Scalars['String']>;
  discord_account?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  unread?: Maybe<Scalars['Int']>;
};
export type IPlanListResponseV2 = Maybe<Array<{
  annual_price?: number | null;
  description: string;
  id?: string | null;
  paypal_annual: string;
  paypal_monthly?: string | null;
  revenue: string;
  slug?: string | null;
  stripe_annual?: string | null;
  stripe_monthly?: string | null;
  vod_storage?: number | null;
  monthly_price?: number | null;
  klic_stream?: number | null;
  name?: string | null;
} | null> | null>;

export type IUserSimpleResponseV2 = {
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  heading?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  roleId: Scalars['String'];
  username: Scalars['String'];
};

export type IVideo = {
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  channelId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  forChilds?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  playbackUrl?: Maybe<Scalars['String']>;
  privacy?: Maybe<Scalars['String']>;
  recordingSessionId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnail?: Maybe<Scalars['String']>;
  thumbnailsPath?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type IVideoData = {
  featuredEvents?: Maybe<Array<Maybe<IFeaturedEvent>>>;
  recentVods?: Maybe<Array<Maybe<IFeaturedEvent>>>;
  showcaseEvents?: Maybe<Array<Maybe<IShowcaseEvent>>>;
};

export type IVideoPayload = {
  error?: Maybe<Scalars['String']>;
  video?: Maybe<IVideo>;
};

export type IFollowChannelPayload = {
  channelId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IDeleteMediaIdPayload = {
  mediaId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type IDeleteFeaturedEventPayload = {
  eventId: Maybe<Scalars['String']>;
};
export type IDeleteEventTypePayload = {
  eventTypeId: Maybe<Scalars['String']>;
};
export type IDeleteCategoryPayload = {
  categoryId: Maybe<Scalars['String']>;
};
export type IDeleteUserPanelPayload = {
  panelId: Maybe<Scalars['String']>;
};
export type IDeleteUserMasterPanelPayload = {
  masterId: Maybe<Scalars['String']>;
};
export type IDeleteRecommendedEventPayload = {
  position: Maybe<Scalars['Int']>;
};
export type IDeleteFeaturedCategoryPayload = {
  featuredId: Maybe<Scalars['String']>;
};

// export type ISearchPayload = {
//   keyword?: Maybe<Scalars['String']>;
// };
export type IDashboardV2Payload = {
  channelId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};
export type IRevenueChartVariables = {
  channelId: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['String']>;
  endDate: Maybe<Scalars['String']>;
};
export type IFollowChCPayload = {
  channelId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
};

export type IFollowChannelCPayload = {
  getFollowerInput: IFollowChCPayload;
};
export type IFollowingCPayload = {
  getFollowerInput: IFollowChCPayload;
};

export type IAboutDetailsInput = {
  btnHeroLink?: InputMaybe<Scalars['String']>;
  btnHeroText?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  imgInitial?: InputMaybe<Scalars['String']>;
  supportingCopy?: InputMaybe<Scalars['String']>;
  testimonialWaterMark?: InputMaybe<Scalars['String']>;
  testimonialsTitle?: InputMaybe<Scalars['String']>;
  trustedTitle?: InputMaybe<Scalars['String']>;
  upcomingEventTitle?: InputMaybe<Scalars['String']>;
  upcomingEventWaterMark?: InputMaybe<Scalars['String']>;
};

export type IAboutFeatureInput = {
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  img?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ITestimonialInput = {
  btnText?: InputMaybe<Scalars['String']>;
  img?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  testimony?: InputMaybe<Scalars['String']>;
  urlInfo?: InputMaybe<Scalars['String']>;
};

export type ITrustedByInput = {
  img?: InputMaybe<Scalars['String']>;
};

export type IGetSignedUrlV2QueryVariables = Exact<{
  key: Scalars['String'];
}>;

export type IGetSignedUrlV2Query = { getSignedUrlV2?: { url: string } | null };

export type IGetPresignedUploadUrlV2MutationVariables = Exact<{
  key: Scalars['String'];
  type: Scalars['String'];
}>;

export type IGetPresignedUploadUrlV2Mutation = {
  gfxImageProcessor?: { url: string } | null;
};

export type ICheckCategoryQueryVariables = Exact<{
  categoryId: Scalars['String'];
  userId: Scalars['String'];
}>;

export type ICheckCategoryQuery = {
  FollowCategoryV2?: { isTaken?: boolean | null } | null;
};
export const CheckFollowCategoryDocument = gql`
  query FollowCategoryV2($categoryId: String!, $userId: String!) {
    FollowCategoryV2(categoryId: $categoryId, userId: $userId) {
      isTaken
    }
  }
`;

export type ICheckUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;

export type ICheckUsernameQuery = {
  checkUsernameV2?: { isTaken?: boolean | null } | null;
};

export type ICheckEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type IFollowerChannelQueryVariables = Exact<{
  channelId: Scalars['String'];
}>;
export type ICheckEmailQuery = {
  checkEmailV2?: { isTaken?: boolean | null } | null;
};
export type ICheckFollowerQuery = {
  checkFollowerV2?: { isTaken?: boolean | null } | null;
};

export type ICheckFollowerChannelQuery = {
  count?: boolean | null;
};

export type IGetCurrentUserQueryVariables = Exact<{
  token: Scalars['String'];
}>;
export type IGetAboutMeQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type IDeleteMediaQuery = {
  deleteMediaById?: { isTaken?: boolean | null } | null;
};
export type IDeleteFeatureEventQuery = {
  deleteFeaturedEvent?: string | null;
};
export type IDeleteEntityType = {
  deleteEntityType?: string | null;
};
export type IDeleteCategory = {
  deleteCategory?: string | null;
};
export type IDeleteUserPanel = {
  deleteUserPanel?: string | null;
};
export type IDeleteUserMasterPanel = {
  deleteUserMasterPanel?: string | null;
};
export type IDeleteRecommendedEventQuery = {
  deleteRecommendedEvent?: string | null;
};
export type IDeleteCarouselEventQuery = {
  deletCarouselEvent?: string | null;
};
export type IDeleteFeaturedCategoryQuery = {
  deleteFeaturedCategory?: string | null;
};

export type IGetLiveEventsV3QueryVariables = Exact<{
  userId?: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export type IGetUpcomingEventsV3QueryVariables = Exact<{
  userId?: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export type IGetTrendingCategoriesQueryVariables = Exact<{
  userId?: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export type IGetCategoryWithScheduleEventsQueryVariables = Exact<{
  userId?: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export type IGetCategoryWithEventsQueryVariables = Exact<{
  userId?: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export type IChatSettingVariables = {
  eventId: Scalars['String'];
};
export type IRoleManagerVariables = {
  userId: Scalars['String'];
};
export type IGetPaymentHistoryVariables = {
  userId: Scalars['String'];
  channelId: Scalars['String'];
};
export type IDeleteRoleManagerVariables = {
  roleId: Scalars['String'];
};
export type IDeletePaymentSettingVariables = {
  cardId: Scalars['String'];
};
export type IChatModeratorVariables = {
  eventId: Scalars['String'];
};
export type IUserChatSettingVariables = {
  eventId: Scalars['String'];
  userId: Scalars['String'];
};

export type IGetChannelRevenueChartDataQuery = {
  getChannelRevenueChart?: {
    total_revenue: number | null;
    chart: Maybe<
      Array<{
        date: string | null;
        revenue: number | null;
        subscription: number | null;
        ppv_revenue: number | null;
        ad_revenue: number | null;
      } | null>
    > | null;
  } | null;
};
export type IGetRevenueChartQuery = {
  getRevenueChart?: {
    total: {
      revenue: number | null;
      subscription: number | null;
      minute_watch: number | null;
      stream_minute: number | null;
      follower: number | null;
    };
    chart: Maybe<
      Array<{
        date: string | null;
        value: number | null;
        average: number | null;
      } | null>
    > | null;
    additional: Maybe<
      Array<{
        date: string | null;
        average: Maybe<{
          follower: number | null;
          minute_watch: number | null;
          revenue: number | null;
          stream_minute: number | null;
          subscription: number | null;
        } | null> | null;
        value: Maybe<{
          avg_viewers: number | null;
          follower: number | null;
          subscription: number | null;
          revenue: number | null;
          stream_minute: number | null;
          minute_watch: number | null;
          live_views: number | null;
          max_viewers: number | null;
          ad_break: number | null;
          ad_time_per_hour: number | null;
          unique_viewer: number | null;
        } | null> | null;
      } | null>
    > | null;
  };
};
export type IGetDashboardV2Query = {
  getDashboardV2?: {
    stats: {
      followers: number | null;
      subscriber: number | null;
      revenue: string | null;
      streamers: string | null;
      views: string | null;
      max_viewers?: string | null;
      average_viewers?: string | null;
      total_event?: number | null;
      new_followers?: number | null;
      new_event?: number | null;
      minute_watch?: number | null;
    } | null;
    latestChannel: Maybe<
      Array<{
        created_at?: string | null;
        firstName: String;
        name: String;
        lastName: String;
        id: String;
        email: String;
        avatar?: String;
        heading: String;
        isSubscribed?: boolean | null;
      } | null>
    > | null;
    events: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
        newStreamTypeOptions?: string | null;
      } | null;
      streamers?: Array<{
        isPromo?: boolean | null;
        id?: string | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null>;
  };
};

export type IGetCurrentUserQuery = {
  getMeV2?: {
    avatar?: string | null;
    email: string;
    firstName?: string | null;
    id: string;
    lastName?: string | null;
    username: string;
    heading?: string | null;
    lastUpdated?: string | null;
    isSubscribed?: boolean | null;
    isLock?: boolean | null;
    isTempLock?: boolean | null;
    firstLogin?: boolean | null;
    google_account?: string | null;
    apple_account?: string | null;
    twitter_account?: string | null;
    discord_account?: string | null;
    birthdate?: string | null;
    country?: string | null;
    unread?: number | null;
    channel?: {
      id: string;
      isChannelLive?: string | null;
      ivsChannelName?: string | null;
      liveUrl?: string | null;
      channelArn?: string | null;
      channelStreamKey?: string | null;
      channelInputUrl?: string | null;
      name?: string | null;
    } | null;
    role: { id?: string | null; name?: string | null };
    plan?: {
      annual_price?: number | null;
      description: string;
      id?: string | null;
      paypal_annual: string;
      paypal_monthly?: string | null;
      revenue: string;
      slug?: string | null;
      stripe_annual?: string | null;
      stripe_monthly?: string | null;
      vod_storage?: number | null;
      monthly_price?: number | null;
      klic_stream?: number | null;
      name?: string | null;
      contentType?: boolean | null;
      monitization?: boolean | null;
      streamType?: boolean | null;
      bracktology?: boolean | null;
    } | null;
  } | null;
};
export type IGetFollowerListQuery = {
  getFollowerListV2?: Array<{
    avatar?: string | null;
    email: string;
    firstName?: string | null;
    id: string;
    lastName?: string | null;
    username: string;
    heading?: string | null;
    isSubscribed?: boolean | null;
    isTBlock?: boolean | null;
    channel?: {
      id: string;
      isChannelLive?: string | null;
      ivsChannelName?: string | null;
      liveUrl?: string | null;
      channelArn?: string | null;
      channelStreamKey?: string | null;
      channelInputUrl?: string | null;
      name?: string | null;
      followcount?: number | null;
      aboutme?: string | null;
    } | null;
    created_at?: string | null;
  } | null> | null;
};
export type IGetFollowingQuery = {
  getFollowerByChannel?: {
    events: Array<{
      avatar?: string | null;
      email: string;
      firstName?: string | null;
      id: string;
      lastName?: string | null;
      username: string;
      heading?: string | null;
      isSubscribed?: boolean | null;
      isTBlock?: boolean | null;
      channel?: {
        id: string;
        isChannelLive?: string | null;
        ivsChannelName?: string | null;
        liveUrl?: string | null;
        channelArn?: string | null;
        channelStreamKey?: string | null;
        channelInputUrl?: string | null;
        name?: string | null;
        followcount?: number | null;
        aboutme?: string | null;
      } | null;
      created_at?: string | null;
    } | null> | null;
    count?: number | null;
  };
};
export type IGetFollowingData = {
  avatar?: string | null;
  email: string;
  firstName?: string | null;
  id: string;
  lastName?: string | null;
  username: string;
  heading?: string | null;
  isSubscribed?: boolean | null;
  isTBlock?: boolean | null;
  channel?: {
    id: string;
    isChannelLive?: string | null;
    ivsChannelName?: string | null;
    liveUrl?: string | null;
    channelArn?: string | null;
    channelStreamKey?: string | null;
    channelInputUrl?: string | null;
    name?: string | null;
    followcount?: number | null;
    aboutme?: string | null;
  } | null;
  created_at?: string | null;
};
export type IGetAboutMeQuery = {
  getMeAboutV2?: Array<{
    text: string;
    link?: string | null;
    linkType?: string | null;
  } | null> | null;
};

export type IGetChatSettingQuery = {
  getChatSettingV2?: {
    followersOnly: boolean | null;
    subsOnly: boolean | null;
    emoteOnly: boolean | null;
    slowMode: boolean | null;
    eventId: string | null;
  };
};
export type IDeleteRoleManagerQuery = {
  deleteManagerById: string | null;
};
export type IDeletePaymentSettingQuery = {
  deletePaymentSetting: string | null;
};
export type IGetRoleManagerQuery = {
  getManagerList?: Array<{
    editor: boolean | null;
    id: string | null;
    moderator: boolean | null;
    updatedAt: Date | null;
    user: {
      avatar?: string | null;
      heading?: string | null;
      email: string;
      firstName?: string | null;
      id: string;
      lastName?: string | null;
      username: string;
      channel?: {
        id: string;
        isChannelLive?: string | null;
        ivsChannelName?: string | null;
        liveUrl?: string | null;
        channelArn?: string | null;
        channelStreamKey?: string | null;
        channelInputUrl?: string | null;
        name?: string | null;
      } | null;
    } | null;
  }> | null;
};
export type IGetChatRuleByUserIdQuery = {
  getChatRuleByUserId?: Array<{
    id: string | null;
    userId: string | null;
    title: string | null;
    description: string | null;
    position: number | null;
  }> | null;
};
export type IGetPaymentSettingByUserIdQuery = {
  getPaymentSettingByUserId?: Array<{
    id: string | null;
    card_name: string | null;
    expiry_month: string | null;
    expiry_year: string | null;
    card_no: string | null;
    card_type: string | null;
  }> | null;
};
export type IGetPaymentHistoryQuery = {
  getPaymentHistory?: Array<{
    id: string | null;
    userId: string | null;
    fromUserId: string | null;
    paymentMethod: string | null;
    amount: string | null;
    type: string | null;
    paymentDate: string | null;
    buyer: {
      avatar: string | null;
      heading: string | null;
      username: string | null;
    } | null;
    owner: {
      avatar: string | null;
      heading: string | null;
      username: string | null;
    } | null;
    subscription: {
      id: string | null;
      planId: string | null;
      startDate: string | null;
      endDate: string | null;
      paymentMode: string | null;
      isActive: boolean | null;
    };
  }> | null;
};
export type IGetReasonListForReportQuery = {
  getAllReasons?: Array<{
    id: string | null;
    title: string | null;
  }> | null;
};
export type IGetChatModeratorQuery = {
  getChatModeratorV2?: Array<{
    userId: string;
    eventId: string;
  } | null>;
};
export type IGetUserChatSettingQuery = {
  getUserChatSettingV2?: {
    color: string;
    discrimination: boolean;
    explicitLanguage: boolean;
    hostility: boolean;
    profanity: boolean;
  };
};

export type ICreateCategoryV2MutationVariables = Exact<{
  createCategoryInput?: InputMaybe<ICreateCategoryInput>;
}>;

export type ICreateUserPanelMutationVariables = Exact<{
  masterId: string;
  data?: InputMaybe<ICreateUserPanelInput>;
}>;
export type ICreateUserMasterPanelMutationVariables = Exact<{
  userId: string;
  data?: InputMaybe<ICreateUserMasterPanelInput>;
}>;
export type IUpdateMasterPanelMutationVariables = Exact<{
  masterId: string;
  title: string;
  type: string;
}>;
export type IUpdateUserPanelMutationVariables = Exact<{
  panelId: string;
  masterId: string;
  data?: InputMaybe<ICreateUserPanelInput>;
}>;
export type IUpdatePanelPositionMutationVariables = Exact<{
  panelId: string;
  masterId: string;
  position: number;
}>;
export type IUpdateCarouselPositionV2MutationVariables = Exact<{
  updatedCarousel: IUpdatedCarouselListInput;
}>;
export type IUpdateFeaturedEventPositionInput = {
  eventId: string;
  position: number;
};
export type IUpdateFeaturedEventPositionMutationVariables = Exact<{
  featuredEventInput: Array<IUpdateFeaturedEventPositionInput>;
}>;
export type IUpdatePanelPositionByUserIdMutationVariables = Exact<{
  masterId: string;
  position: number;
  userId: string;
}>;
export type ICreateCategoryV2Mutation = {
  createCategoryV2?: {
    id: string;
    isActive: boolean;
    name: string;
    thumbnail: string;
  } | null;
};

export type IUpdatedCarouselListInput = {
  updatedCarouselList: Array<IUpdatedCarouselInput>;
};
export type IUpdatedCarouselInput = {
  carouselId: string;
  position: number;
};
export type ICreateUserPanelMutation = {
  createUserPanel?: {
    id: string;
    title: string;
    url: string;
    image: string;
    description: string;
  } | null;
};
export type ICreateEventPanelMutation = {
  createEventPanel?: {
    id: string;
    title: string;
    url: string;
    image: string;
    description: string;
  } | null;
};
export type ICreateUserMasterPanelMutation = {
  createUserMasterPanel?: string | null;
};
export type IUpdateMasterPanelMutation = {
  updateMasterPanel?: string | null;
};

export type ICreateEventMasterPanelMutation = {
  createEventMasterPanel?: string | null;
};

export type IUpdateUserPanelMutation = {
  updateUserPanel?: string | null;
};
export type IUpdateEventPanelMutation = {
  updateEventPanel?: string | null;
};
export type IUpdatePanelPositionMutation = {
  updatePositionByMasterId?: string | null;
};
export type IUpdateCarouselPositionV2Mutation = {
  updateCarouselPosition?: string | null;
};
export type IUpdateFeaturedEventPositionV2Mutation = {
  updateFeatureEventPosition?: string | null;
};
export type IUpdatePanelPositionByUserIdMutation = {
  updatePanelPositionByUserId?: string | null;
};

export type IGetCategoriesV2QueryVariables = Exact<{ [key: string]: never }>;

export type IGetPlanListV2QueryVariables = Exact<{ [key: string]: never }>;

export type IGetCategoriesV2Query = {
  getCategoriesV2?: Array<{
    id: string;
    isActive: boolean;
    name: string;
    thumbnail: string;
    slug: string;
    totalView?: number;
    categoryTags: {
      categoryId: string;
      eventTypeId: string;
      eventType: {
        name: string;
      };
    };
  } | null> | null;
};
export type IGetTrendingCategoriesQuery = {
  getTrendingCategory: Array<{
    id: string | null;
    name: string | null;
    slug: string | null;
    isActive: boolean | null;
    thumbnail: string | null;
    followerCount: number;
    totalEvent: number;
    totalStream: number;
    totalView: number;
    categoryTags: {
      eventType: {
        name: string | null;
      } | null;
    } | null;
  } | null> | null;
};
export type IGetCategoryWithScheduleEventsQuery = {
  getCategoryWithScheduleEvents: Array<{
    slug?: string | null;
    title?: string | null;
    events: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventTag?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventOwnerAvatar?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
        startDateTimeOfEvent?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        newStreamTypeOptions?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
      } | null;
      streamers?: Array<{
        id?: string | null;
        isPromo?: boolean | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};
export type IGetCategoryWithEventsQuery = {
  getCategoryWithEvents: Array<{
    slug?: string | null;
    title?: string | null;
    events: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventTag?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventOwnerAvatar?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
        startDateTimeOfEvent?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
        newStreamTypeOptions?: string | null;
      } | null;
      streamers?: Array<{
        id?: string | null;
        isPromo?: boolean | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type NotifyResetPasswordUserIdQuery = {
  notifyResetPassword?: string | null;
};

export type IGetPanelByUserIdQuery = {
  getPanelByUserId?: Array<{
    id: string;
    title?: string;
    userId?: string;
    panels?: Array<{
      id: string;
      title?: string;
      link?: string;
      description?: string;
      image?: string;
    } | null> | null;
    description?: string;
    image?: string;
  } | null> | null;
};

export type IGetPanelByEventIdQuery = {
  getPanelbyEventId?: Array<{
    id: string;
    title?: string;
    panels?: Array<{
      id: string;
      title?: string;
      link?: string;
      description?: string;
      image?: string;
    } | null> | null;
  } | null> | null;
};

export type IUpdateCategoryV2MutationVariables = Exact<{
  updateCategoryInput?: InputMaybe<IUpdateCategoryInput>;
}>;

export type IUpdateCategoryV2Mutation = {
  updateCategoryV2?: {
    id: string;
    isActive: boolean;
    name: string;
    thumbnail: string;
    slug: string;
  } | null;
};

export type IGetChannelQueryVariables = Exact<{
  username: Scalars['String'];
}>;

export type IGetChannelQuery = {
  getChannelV2?: {
    avatar?: string | null;
    banner?: string | null;
    id: string;
    isChannelLive?: string | null;
    ivsChannelName?: string | null;
    liveUrl?: string | null;
    name?: string | null;
    followcount?: number | null;
    aboutme?: string | null;
    isLock?: boolean | null;
    isTempLock?: boolean | null;
  } | null;
};

export type IGetAllChannelsQueryVariables = Exact<{ [key: string]: never }>;

export type IGetAllChannelsQuery = {
  getAllChannels?: Array<{
    avatar?: string | null;
    banner?: string | null;
    id: string;
    isChannelLive?: string | null;
    ivsChannelName?: string | null;
    liveUrl?: string | null;
    name?: string | null;
    userId?: string | null;
    followcount?: number | null;
    aboutme?: string | null;
  } | null> | null;
};
export type IGetAllUsersV2QueryVariables = Exact<{
  [key: string]: never;
}>;
export type IGetAllUsersV2Query = {
  getAllUsers?: Array<{
    firstName: String;
    name: String;
    lastName: String;
    id: String;
    email: String;
    avatar?: String;
    heading: String;
    role: {
      id?: Maybe<Scalars['String']>;
      name?: Maybe<Scalars['String']>;
    };
    created_at: String;
    plan: {
      id?: Maybe<Scalars['String']>;
      name?: Maybe<Scalars['String']>;
    } | null;
    isLock?: Maybe<Scalars['Boolean']>;
    isTempLock?: Maybe<Scalars['Boolean']>;
  } | null> | null;
};

export type IGetEventsForChannelQueryVariables = Exact<{
  channelId: Scalars['String'];
}>;
export type GetAdminEventQueryVariables = Exact<{
  limit?: Scalars['Int'];
}>;

export type IGetCategoryByIdQueryVariables = Exact<{
  slug: Scalars['String'];
  limit?: Scalars['Int'];
}>;
export type IGetCategoryByIdStatusQueryVariables = Exact<{
  categoryId: Scalars['String'];
  type: Scalars['String'];
  limit?: Scalars['Int'];
}>;
export type IGetPanelByUserIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;
export type IGetCategoryByIdQuery = {
  getEventByCategory?: {
    detail: {
      id: string;
      isActive: boolean;
      name: string;
      thumbnail: string;
      slug: string;
      followerCount: number;
      totalEvent: number;
      totalStream: number;
    };
    scheduledEvents?: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
        startDateTimeOfEvent?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
        newStreamTypeOptions?: string | null;
      } | null;
      streamers?: Array<{
        isPromo?: boolean | null;
        id?: string | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
    pastEvents?: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
        newStreamTypeOptions?: string | null;
      } | null;
      streamers?: Array<{
        isPromo?: boolean | null;
        id?: string | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
    liveEvents?: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
        newStreamTypeOptions?: string | null;
      } | null;
      streamers?: Array<{
        isPromo?: boolean | null;
        id?: string | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};
export type IGetEventsForChannelQuery = {
  getEventsForChannel?: {
    events?: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventCategoryThumbnail?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventOwnerAvatar?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        startDateTimeOfEvent?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
        newStreamTypeOptions?: string | null;
      } | null;
      streamers?: Array<{
        id?: string | null;
        isPromo?: boolean | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};
export type IGetAdminEventListQuery = {
  getEventList?: Array<{
    attendees?: Array<string | null> | null;
    createdAt?: string | null;
    slug?: string | null;
    id?: string | null;
    status?: IStatusTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    availableActions?: {
      archive?: boolean | null;
      edit?: boolean | null;
      remove?: boolean | null;
      finish?: boolean | null;
      start?: boolean | null;
    } | null;
    details?: {
      duration?: number | null;
      eventCategory?: Array<string | null> | null;
      eventDescription?: string | null;
      eventName?: string | null;
      eventOwner?: string | null;
      eventPosterImage?: string | null;
      eventStartDateAndTime?: string | null;
      eventThumbnail?: string | null;
      eventType?: string | null;
    } | null;
    monetization?: {
      adFrequency?: number | null;
      adLength?: number | null;
      allowFreePreview?: boolean | null;
      allowFreePreviewSub?: boolean | null;
      allowNonSubscribersPPV?: boolean | null;
      allowPPVSub?: boolean | null;
      contributorsOptions?: string | null;
      freePreviewTime?: string | null;
      freePreviewTimeSub?: string | null;
      maxPrice?: string | null;
      messageForViewers?: string | null;
      minPrice?: string | null;
      monetizationType?: IMonetizationTypeV2 | null;
      preRoll?: boolean | null;
      price1?: string | null;
      price2?: string | null;
      price3?: string | null;
      price4?: string | null;
      priceInput?: IPriceInputTypeV2 | null;
      pricePerPPV?: string | null;
      pricePerPPVSub?: string | null;
      subscribersOnly?: boolean | null;
      sponsor?: Array<{
        sponsorAmount?: string | null;
        sponsorLogo?: string | null;
        sponsorName?: string | null;
      } | null> | null;
    } | null;
    options?: {
      allowOtherChats?: boolean | null;
      isPrivateEvent?: boolean | null;
      numberOfChatsPerStream?: number | null;
      privateEventPassword?: string | null;
      recordEvent?: boolean | null;
      recordEventExpirationDate?: string | null;
      newStreamTypeOptions?: string | null;
    } | null;
    streamers?: Array<{
      id?: string | null;
      isPromo?: boolean | null;
      type?: IStreamsTypeV2 | null;
      emailInvite?: {
        customMessage?: string | null;
        email?: string | null;
        isPrivateMessage?: boolean | null;
      } | null;
      embedStreams?: {
        logo?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        streamUrl?: string | null;
        thumbnail?: string | null;
        chat?: Array<{
          type?: string | null;
          url?: string | null;
        } | null> | null;
      } | null;
      klic?: {
        isThumbnailOverridden?: boolean | null;
        logo?: string | null;
        mediaOffset?: string | null;
        streamUrl?: string | null;
        thumbnailUrl?: string | null;
        vodUrl?: string | null;
        chat?: Array<{
          url?: string | null;
          type?: string | null;
        } | null> | null;
        channel?: {
          channelArn?: string | null;
          channelInputUrl?: string | null;
          channelStreamKey?: string | null;
          id: string;
          isChannelLive?: string | null;
          ivsChannelName?: string | null;
          liveUrl?: string | null;
          userId?: string | null;
          user?: {
            firstName?: string | null;
            lastName?: string | null;
            id: string;
            email: string;
            username: string;
            avatar?: string | null;
            heading?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null> | null;
} | null;
export type ICreateEventForChannelV2MutationVariables = Exact<{
  createEventInput?: InputMaybe<ICreateEventForChannelAsDraftInputV2>;
}>;

export type ICreateEventForChannelV2Mutation = {
  createEventForChannelV2?: string | null;
};

export type IEditEventV2MutationVariables = Exact<{
  editEventInput?: InputMaybe<IEditEventInputV2>;
}>;
export type IUpdateEventSettingV2MutationVariables = Exact<{
  editEventChatOptionsInput?: InputMaybe<IUpdateChatSettingV2>;
}>;
export type IEditEventV2Mutation = { editEventV2?: string | null };
export type IUpdateEventChatOptionsV2Mutation = {
  updateEventChatOptionsV2?: string | null;
};

export type IEventActionsV2MutationVariables = Exact<{
  eventId: Scalars['String'];
  description?: Scalars['String'];
  streamId?: Scalars['String'];
  channelId?: Scalars['String'];
  action: IEventActionType;
}>;
export type ICreatorEventActionsV2MutationVariables = Exact<{
  eventId: Scalars['String'];
  stremerId?: Scalars['String'];
  action: IEventActionType;
}>;

export type IDeleteVideoByIdMutationVariables = Exact<{
  videoId: Scalars['String'];
}>;

export type IEventActionsV2Mutation = {
  eventActionsV2?: {
    eventId: Scalars['String'];
    action: Scalars['String'];
  };
};
export type ICreatorEventActionsV2Mutation = {
  eventCreatorActionsV2?: string | null;
};
export type IDeleteVideoByIdMutation = {
  deleteVideoById?: string | null;
};

export type IGetEventByIdV2QueryVariables = Exact<{
  slug: Scalars['String'];
  channelName: Scalars['String'];
}>;

export type IGetEventViewersQueryVariables = Exact<{
  slug: Scalars['String'];
  channelName: Scalars['String'];
}>;

export type IGetEventViewersQuery = {
  getEventViewers?: {
    id?: string | null;
    type?: string | null;
    current?: string | null;
    total?: string | null;
  } | null;
};

export type IGetEventByIdV2Query = {
  getEventByIdV2?: {
    slug?: string | null;
    eventStartedAt?: string | null;
    eventStoppedAt?: string | null;
    attendees?: Array<string | null> | null;
    createdAt?: string | null;
    id?: string | null;
    ownerId?: string | null;
    status?: IStatusTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    availableActions?: {
      archive?: boolean | null;
      edit?: boolean | null;
      remove?: boolean | null;
      finish?: boolean | null;
      start?: boolean | null;
    } | null;
    details?: {
      duration?: number | null;
      eventCategory?: Array<string | null> | null;
      eventTag?: Array<string | null> | null;
      eventDescription?: string | null;
      eventName?: string | null;
      eventOwner?: string | null;
      eventOwnerAvatar?: string | null;
      eventPosterImage?: string | null;
      eventStartDateAndTime?: string | null;
      eventThumbnail?: string | null;
      eventType?: string | null;
      platform?: string | null;
      braketologyEmbedLink?: string | null;
      braketologyType?: string | null;
      vodArchiveTime?: string | null;
      streamCheckInTime?: string | null;
      restrict?: boolean | null;
      eventOwnerLive?: boolean | null;
      facebook?: string | null;
      custom?: string | null;
      youtube?: string | null;
      kick?: string | null;
      twitch?: string | null;
      startDateTimeOfEvent?: string | null;
      startDateTimeOfEventUTC?: string | null;
    } | null;
    monetization?: {
      adFrequency?: number | null;
      adLength?: number | null;
      allowFreePreview?: boolean | null;
      allowFreePreviewSub?: boolean | null;
      allowNonSubscribersPPV?: boolean | null;
      allowPPVSub?: boolean | null;
      contributorsOptions?: string | null;
      freePreviewTime?: string | null;
      freePreviewTimeSub?: string | null;
      maxPrice?: string | null;
      messageForViewers?: string | null;
      minPrice?: string | null;
      monetizationType?: IMonetizationTypeV2 | null;
      preRoll?: boolean | null;
      price1?: string | null;
      price2?: string | null;
      price3?: string | null;
      price4?: string | null;
      priceInput?: IPriceInputTypeV2 | null;
      pricePerPPV?: string | null;
      pricePerPPVSub?: string | null;
      donationLink?: string | null;
      subscribersOnly?: boolean | null;
      sponsor?: Array<{
        sponsorAmount?: string | null;
        sponsorLogo?: string | null;
        sponsorName?: string | null;
      } | null> | null;
    } | null;
    options?: {
      allowOtherChats?: boolean | null;
      isPrivateEvent?: boolean | null;
      numberOfChatsPerStream?: number | null;
      privateEventPassword?: string | null;
      recordEvent?: boolean | null;
      recordEventExpirationDate?: string | null;
      newStreamTypeOptions?: string | null;
      isFollowerOnly?: boolean | null;
    } | null;
    streamers?: Array<{
      id?: string | null;
      position?: number | null;
      isPromo?: boolean | null;
      isActive?: boolean | null;
      isEventActive?: boolean | null;
      type?: IStreamsTypeV2 | null;
      categoryId?: string | null;
      category: ICategoryResponseV3 | null;
      streamName?: string | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      media?: {
        id?: string | null;
        name?: string | null;
        isChannelLive?: boolean | null;
        livePlaybackUrl?: string | null;
        masterKey?: string | null;
        playlistDuration?: string | null;
        recordingStartedAt?: string | null;
      } | null;
      emailInvite?: {
        customMessage?: string | null;
        email?: string | null;
        isPrivateMessage?: boolean | null;
      } | null;
      embedStreams?: {
        logo?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        streamUrl?: string | null;
        thumbnail?: string | null;
        chat?: Array<{
          type?: string | null;
          url?: string | null;
        } | null> | null;
      } | null;
      klic?: {
        isThumbnailOverridden?: boolean | null;
        logo?: string | null;
        mediaOffset?: string | null;
        streamUrl?: string | null;
        thumbnailUrl?: string | null;
        vodUrl?: string | null;
        chat?: Array<{
          url?: string | null;
          type?: string | null;
        } | null> | null;
        channel?: {
          channelArn?: string | null;
          channelInputUrl?: string | null;
          channelStreamKey?: string | null;
          id: string;
          isChannelLive?: string | null;
          ivsChannelName?: string | null;
          liveUrl?: string | null;
          userId?: string | null;
          name?: string | null;
          user?: {
            firstName?: string | null;
            lastName?: string | null;
            id: string;
            email: string;
            username: string;
            avatar?: string | null;
            heading?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ISendMessageEventChatV2MutationVariables = Exact<{
  eventId: Scalars['String'];
  chatData: IChatDataInput;
}>;
export type IPinMessageEventChatV2MutationVariables = Exact<{
  eventId: Scalars['String'];
  setPriority: Scalars['Boolean'];
  chatData: IChatDataInput;
}>;
export type IRemoveMessageChatMutationVariables = Exact<{
  eventId: Scalars['String'];
  chatData: IChatDataInput;
}>;

export type ISendMessageEventChatV2Mutation = {
  sendMessageEventChatV2?: {
    eventId?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      pin?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};
export type IPinMessageEventChatV2Mutation = {
  pinMessageEventChatV2?: {
    event?: string | null;
    data?: {
      id?: string | null;
      message?: string | null;
      color?: string | null;
      time?: string | null;
      priority?: number | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};
export type RemoveMessageChatMutation = {
  removeMessageChat?: string | null;
};

export type IOnSendMessageEventChatV2SubscriptionVariables = Exact<{
  eventId: Scalars['String'];
}>;

export type IOnUpdateChatSettingV2SubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnPinMessageEventChatV2SubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnSendMessageEventChatV2Subscription = {
  onNewSendMessageEventChatV2?: {
    eventId?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      pin?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};

export type IOnUpdateChatSettingV2Subscription = {
  onUpdateChatSettingV2?: {
    followersOnly: boolean | null;
    subsOnly: boolean | null;
    emoteOnly: boolean | null;
    slowMode: boolean | null;
    eventId: boolean | null;
  } | null;
};

export type IOnPinMessageEventChatV2Subscription = {
  onPinMessageEventChatV2?: {
    event?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      pin?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};

export type IGetEventChatMessagesV2QueryVariables = Exact<{
  eventId: Scalars['String'];
}>;

export type IGetEventChatMessagesV2Query = {
  getEventChatMessagesV2?: {
    messages?: Array<{
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
      ping?: string | null;
      int?: number | null;
      priority?: number | null;
    } | null> | null;
  } | null;
};

export type ISendMessageKlicChatV2MutationVariables = Exact<{
  eventId: Scalars['String'];
  channelId: Scalars['String'];
  chatData: IChatDataInput;
}>;
export type IClearChatV2MutationVariables = Exact<{
  eventId: Scalars['String'];
}>;

export type IModifyRoleManagerInput = {
  userId: Scalars['String'];
  ownerUserId: Scalars['String'];
  editor: Scalars['Boolean'];
  moderator: Scalars['Boolean'];
  roleId?: Scalars['String'];
};
export type IModifyRoleManagerMutationVariables = Exact<{
  roleManager?: InputMaybe<IModifyRoleManagerInput>;
}>;
export type CardPaymentSettingInput = {
  brand: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  last4: Scalars['String'];
};
export type IModifyPaymentSettingInput = {
  userId: Scalars['String'];
  card_name: Scalars['String'];
  card_no: Scalars['String'];
  expiry_month: Scalars['String'];
  expiry_year: Scalars['String'];
  cardNonce: Scalars['String'];
  card: CardPaymentSettingInput;
  roleId?: Scalars['String'];
};
export type IModifyPaymentSettingMutationVariables = Exact<{
  cardInput?: InputMaybe<IModifyPaymentSettingInput>;
}>;
export type IReportAndBlockInput = {
  description: Scalars['String'];
  userId?: Scalars['String'];
  channelId?: Scalars['String'];
  eventId?: Scalars['String'];
  streamerId?: Scalars['String'];
  reasonId?: Scalars['String'];
};
export type IReportAndBlockMutationVariables = Exact<{
  report?: InputMaybe<IReportAndBlockInput>;
}>;
export type IReadNotificationMutationVariables = Exact<{
  userId: Scalars['String'];
  notificationId?: Scalars['String'];
}>;
export type ICancelSubscriptionInput = {
  subscriptionId: Scalars['String'];
  channelId?: Scalars['String'];
};
export type ICancelSubscriptionMutationVariables = Exact<{
  subscriptionInput?: InputMaybe<ICancelSubscriptionInput>;
}>;
export type IModifyChatRuleInput = {
  userId: Scalars['String'];
  title: Scalars['String'];
  position: Scalars['Int'];
};
export type IModifyChatRuleMutationVariables = Exact<{
  ruleInput?: Array<InputMaybe<IModifyChatRuleInput>>;
}>;
export type IVerifyStreamerAvailabilityQueryVariables = Exact<{
  channelId: Scalars['String'];
  duration: Scalars['Int'];
  startDate: Scalars['String'];
}>;
export type IGetNotificationHistoryQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type ISendMessageKlicChatV2Mutation = {
  sendMessageKlicChatV2?: {
    event?: string | null;
    channel?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};
export type IClearChatV2Mutation = {
  clearChatV2?: {
    eventId: string;
  };
};
export type IModifyRoleManagerMutation = {
  modifyRoleManager?: string | null;
};
export type IModifyPaymentSettingMutation = {
  modifyPaymentSetting?: string | null;
};
export type IReportAndBlockMutation = {
  insertReport?: {
    id: string | null;
    description: string | null;
  } | null;
};
export type IModifyChatRuleByArrayMutation = {
  modifyChatRuleByArray?: string | null;
};
export type IReadNotificationMutation = {
  markAsReadNotification?: string | null;
};
export type ICancelSubscriptionMutation = {
  cancelSubscription?: string | null;
};
export type IVerifyStremerAvailabilityQuery = {
  verifyChannelAvailability?: boolean | null;
};

export type IIGetNotificationHistoryQuery = {
  getNotificationHistory: Array<{
    id: string | null;
    userId: string | null;
    notificationType: string | null;
    title: string | null;
    body: string | null;
    referenceId: string | null;
    addition_data?: {
      channelId?: string | null;
      channelName?: string | null;
      userId?: string | null;
      eventId?: string | null;
    } | null;
    read: boolean | null;
    avatar: string | null;
    createdAt: Date | null;
    slug: string | null;
    username: string | null;
    page: string | null;
    url: string | null;
  } | null> | null;
};
export type IOnSendMessageKlicChatV2SubscriptionVariables = Exact<{
  [key: string]: never;
}>;
export type IOnClearChatV2SubscriptionVariables = Exact<{
  [key: string]: never;
}>;
export type IOnSendMessageKlicChatV2Subscription = {
  onSendMessageKlicChatV2?: {
    event?: string | null;
    channel?: string | null;
    data?: {
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null;
  } | null;
};
export type IOnClearChatV2Subscription = {
  onClearChatV2?: {
    eventId: string;
  };
};
export type IGetKlicChatMessagesV2QueryVariables = Exact<{
  eventId: Scalars['String'];
  channelId: Scalars['String'];
}>;

export type IGetKlicChatMessagesV2Query = {
  getKlicChatMessagesV2?: {
    channel?: string | null;
    messages?: Array<{
      message?: string | null;
      color?: string | null;
      time?: string | null;
      user?: { id?: string | null; displayName?: string | null } | null;
    } | null> | null;
  } | null;
};
export type ISetUserPreferenceV2Input = {
  userId?: InputMaybe<Scalars['String']>;
  categoryId: Array<Scalars['String']>;
};
export type ILandingFeatureCategoryV2Input = {
  liveCategory: Array<Scalars['String']>;
  scheduleCategory: Array<Scalars['String']>;
};
export type ILandingFeatureCategoryV2MutationVariables = Exact<{
  editCategoryInput?: InputMaybe<ILandingFeatureCategoryV2Input>;
}>;

export type ILandingFeatureCategoryV2Mutation = {
  editLandingFeatureCategoryV2?: string | null;
};
export type ISetUserPreferenceV2Mutation = {
  SetUserPreferenceV2?: string | null;
};
export type ISetUserPreferenceV2MutationVariables = Exact<{
  preferenceInput?: InputMaybe<ISetUserPreferenceV2Input>;
}>;

export type IUpdateEventTypeV2MutationVariables = Exact<{
  updateEventTypeInput?: InputMaybe<IUpdateEventTypeInput>;
}>;

export type IUpdateEventTypeV2Mutation = {
  updateEventTypeV2?: { id: string; name: string; isActive: boolean } | null;
};

export type ICreateEventTypeV2MutationVariables = Exact<{
  createEventTypeInput?: InputMaybe<ICreateEventTypeInput>;
}>;

export type ICreateEventTypeV2Mutation = {
  createEventTypeV2?: { id: string; name: string; isActive: boolean } | null;
};

export type IGetEventTypesV2QueryVariables = Exact<{ [key: string]: never }>;

export type IGetHomepageSetupV2QueryVariables = Exact<{ [key: string]: never }>;

export type ISearchPayload = {
  keyword?: Maybe<Scalars['String']>;
};
export type ISearchResponse = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  eventStatus?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
};

export type ISearchKeywordResponseV2 = Maybe<Array<Maybe<ISearchResponse>>>;
export type ISearchKeywordQuery = {
  getSearchByKeyword?: Array<{
    title?: string | null;
    description?: string | null;
    imgUrl: string;
    type?: string | null;
    userId?: string | null;
    eventId?: string | null;
    channelId?: string | null;
    isLive?: boolean | null;
    eventStatus?: string | null;
  } | null> | null;
};
export type IGetEventTypesV2Query = {
  getEventTypesV2?: Array<{
    id: string;
    name: string;
    isActive: boolean;
  } | null> | null;
};

export type IGetHomePageSetupV2Query = {
  getCarouselListV2?: Array<{
    id: string;
    name: string;
    isActive: boolean;
  } | null> | null;
};
export type IGetPastEventsQueryVariables = Exact<{
  userId?: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export type IGetCategoryWithEventsV2QueryVariables = Exact<{
  userId?: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export type IGetLandingDataV2QueryVariables = Exact<{ [key: string]: never }>;
export type IGetLandingSidebarDataV2QueryVariables = Exact<{ userId: string }>;
export type IGetLandingSidebarDataV2Query = {
  getLandingSidebarDataV2?: {
    recommededEvents: Array<{
      eventId?: string | null;
      id: string;
      position?: number | null;
      thumbnail?: string | null;
      status?: string | null;
      name?: string | null;
      streamers?: number | null;
      description?: string | null;
      category?: string | null;
      username?: string | null;
      slug?: string | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
    } | null> | null;
    followerChannel: Array<{
      id?: string | null;
      followcount?: string | null;
      isChannelLive?: string | null;
      ivsChannelName?: string | null;
      aboutme?: string | null;
      user?: {
        avatar?: string | null;
        username?: string | null;
        lastName?: string | null;
        id?: string | null;
        heading?: string | null;
        email?: string | null;
      } | null;
    }>;
    followerWithEvent: Array<{
      id?: string | null;
      followcount?: string | null;
      isChannelLive?: string | null;
      ivsChannelName?: string | null;
      aboutme?: string | null;
      user?: {
        avatar?: string | null;
        username?: string | null;
        lastName?: string | null;
        id?: string | null;
        heading?: string | null;
        email?: string | null;
      } | null;
      event: {
        attendees?: Array<string | null> | null;
        createdAt?: string | null;
        slug?: string | null;
        id?: string | null;
        status?: IStatusTypeV2 | null;
        viewers?: {
          id?: string | null;
          type?: string | null;
          current?: string | null;
          total?: string | null;
        } | null;
        availableActions?: {
          archive?: boolean | null;
          edit?: boolean | null;
          remove?: boolean | null;
          finish?: boolean | null;
          start?: boolean | null;
        } | null;
        details?: {
          duration?: number | null;
          eventCategory?: Array<string | null> | null;
          eventDescription?: string | null;
          eventName?: string | null;
          eventOwner?: string | null;
          eventOwnerAvatar?: string | null;
          eventPosterImage?: string | null;
          eventStartDateAndTime?: string | null;
          eventThumbnail?: string | null;
          eventType?: string | null;
          platform?: string | null;
          startDateTimeOfEvent?: string | null;
        } | null;
        monetization?: {
          adFrequency?: number | null;
          adLength?: number | null;
          allowFreePreview?: boolean | null;
          allowFreePreviewSub?: boolean | null;
          allowNonSubscribersPPV?: boolean | null;
          allowPPVSub?: boolean | null;
          contributorsOptions?: string | null;
          freePreviewTime?: string | null;
          freePreviewTimeSub?: string | null;
          maxPrice?: string | null;
          messageForViewers?: string | null;
          minPrice?: string | null;
          monetizationType?: IMonetizationTypeV2 | null;
          preRoll?: boolean | null;
          price1?: string | null;
          price2?: string | null;
          price3?: string | null;
          price4?: string | null;
          priceInput?: IPriceInputTypeV2 | null;
          pricePerPPV?: string | null;
          pricePerPPVSub?: string | null;
          subscribersOnly?: boolean | null;
          sponsor?: Array<{
            sponsorAmount?: string | null;
            sponsorLogo?: string | null;
            sponsorName?: string | null;
          } | null> | null;
        } | null;
        options?: {
          allowOtherChats?: boolean | null;
          isPrivateEvent?: boolean | null;
          numberOfChatsPerStream?: number | null;
          privateEventPassword?: string | null;
          recordEvent?: boolean | null;
          recordEventExpirationDate?: string | null;
          newStreamTypeOptions?: string | null;
        } | null;
        streamers?: Array<{
          id?: string | null;
          isPromo?: boolean | null;
          type?: IStreamsTypeV2 | null;
          emailInvite?: {
            customMessage?: string | null;
            email?: string | null;
            isPrivateMessage?: boolean | null;
          } | null;
          embedStreams?: {
            logo?: string | null;
            streamName?: string | null;
            streamType?: string | null;
            streamUrl?: string | null;
            thumbnail?: string | null;
            chat?: Array<{
              type?: string | null;
              url?: string | null;
            } | null> | null;
          } | null;
          klic?: {
            isThumbnailOverridden?: boolean | null;
            logo?: string | null;
            mediaOffset?: string | null;
            streamUrl?: string | null;
            thumbnailUrl?: string | null;
            vodUrl?: string | null;
            chat?: Array<{
              url?: string | null;
              type?: string | null;
            } | null> | null;
            channel?: {
              channelArn?: string | null;
              channelInputUrl?: string | null;
              channelStreamKey?: string | null;
              id: string;
              isChannelLive?: string | null;
              ivsChannelName?: string | null;
              liveUrl?: string | null;
              userId?: string | null;
              name?: string | null;
              user?: {
                firstName?: string | null;
                lastName?: string | null;
                id: string;
                email: string;
                username: string;
                avatar?: string | null;
                heading?: string | null;
              } | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    }>;
  };
};
export type IGetLandingDataV2Query = {
  getLandingDataV2?: {
    categoryWithEvents: {
      slug?: string | null;
      title?: string | null;
      events: Array<{
        attendees?: Array<string | null> | null;
        createdAt?: string | null;
        slug?: string | null;
        id?: string | null;
        status?: IStatusTypeV2 | null;
        viewers?: {
          id?: string | null;
          type?: string | null;
          current?: string | null;
          total?: string | null;
        } | null;
        availableActions?: {
          archive?: boolean | null;
          edit?: boolean | null;
          remove?: boolean | null;
          finish?: boolean | null;
          start?: boolean | null;
        } | null;
        details?: {
          duration?: number | null;
          eventCategory?: Array<string | null> | null;
          eventTag?: Array<string | null> | null;
          eventDescription?: string | null;
          eventName?: string | null;
          eventOwner?: string | null;
          eventOwnerAvatar?: string | null;
          eventPosterImage?: string | null;
          eventStartDateAndTime?: string | null;
          eventThumbnail?: string | null;
          eventType?: string | null;
          platform?: string | null;
          startDateTimeOfEvent?: string | null;
        } | null;
        monetization?: {
          adFrequency?: number | null;
          adLength?: number | null;
          allowFreePreview?: boolean | null;
          allowFreePreviewSub?: boolean | null;
          allowNonSubscribersPPV?: boolean | null;
          allowPPVSub?: boolean | null;
          contributorsOptions?: string | null;
          freePreviewTime?: string | null;
          freePreviewTimeSub?: string | null;
          maxPrice?: string | null;
          messageForViewers?: string | null;
          minPrice?: string | null;
          monetizationType?: IMonetizationTypeV2 | null;
          preRoll?: boolean | null;
          price1?: string | null;
          price2?: string | null;
          price3?: string | null;
          price4?: string | null;
          priceInput?: IPriceInputTypeV2 | null;
          pricePerPPV?: string | null;
          pricePerPPVSub?: string | null;
          subscribersOnly?: boolean | null;
          sponsor?: Array<{
            sponsorAmount?: string | null;
            sponsorLogo?: string | null;
            sponsorName?: string | null;
          } | null> | null;
        } | null;
        options?: {
          allowOtherChats?: boolean | null;
          isPrivateEvent?: boolean | null;
          numberOfChatsPerStream?: number | null;
          privateEventPassword?: string | null;
          recordEvent?: boolean | null;
          recordEventExpirationDate?: string | null;
          newStreamTypeOptions?: string | null;
          isFollowerOnly?: boolean | null;
        } | null;
        streamers?: Array<{
          id?: string | null;
          isPromo?: boolean | null;
          type?: IStreamsTypeV2 | null;
          emailInvite?: {
            customMessage?: string | null;
            email?: string | null;
            isPrivateMessage?: boolean | null;
          } | null;
          embedStreams?: {
            logo?: string | null;
            streamName?: string | null;
            streamType?: string | null;
            streamUrl?: string | null;
            thumbnail?: string | null;
            chat?: Array<{
              type?: string | null;
              url?: string | null;
            } | null> | null;
          } | null;
          klic?: {
            isThumbnailOverridden?: boolean | null;
            logo?: string | null;
            mediaOffset?: string | null;
            streamUrl?: string | null;
            thumbnailUrl?: string | null;
            vodUrl?: string | null;
            chat?: Array<{
              url?: string | null;
              type?: string | null;
            } | null> | null;
            channel?: {
              channelArn?: string | null;
              channelInputUrl?: string | null;
              channelStreamKey?: string | null;
              id: string;
              isChannelLive?: string | null;
              ivsChannelName?: string | null;
              liveUrl?: string | null;
              userId?: string | null;
              name?: string | null;
              user?: {
                firstName?: string | null;
                lastName?: string | null;
                id: string;
                email: string;
                username: string;
                avatar?: string | null;
                heading?: string | null;
              } | null;
            } | null;
          } | null;
        } | null> | null;
      } | null> | null;
    };
    trendingCategory: {
      id: string | null;
      name: string | null;
      slug: string | null;
      isActive: boolean | null;
      thumbnail: string | null;
      followerCount: number;
      totalEvent: number;
      totalStream: number;
      categoryTags: {
        eventType: {
          name: string | null;
        } | null;
      } | null;
    };
    pastEvents?: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventOwnerAvatar?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
        startDateTimeOfEvent?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        isFollowerOnly?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        newStreamTypeOptions?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
      } | null;
      streamers?: Array<{
        id?: string | null;
        isPromo?: boolean | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};
export type IGetPastEventsQuery = {
  getPastEvents?: Array<{
    attendees?: Array<string | null> | null;
    createdAt?: string | null;
    slug?: string | null;
    id?: string | null;
    eventStartedAt?: string | null;
    eventStoppedAt?: string | null;
    status?: IStatusTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    availableActions?: {
      archive?: boolean | null;
      edit?: boolean | null;
      remove?: boolean | null;
      finish?: boolean | null;
      start?: boolean | null;
    } | null;
    details?: {
      duration?: number | null;
      eventCategory?: Array<string | null> | null;
      eventDescription?: string | null;
      eventName?: string | null;
      eventOwner?: string | null;
      eventOwnerAvatar?: string | null;
      eventPosterImage?: string | null;
      eventStartDateAndTime?: string | null;
      eventThumbnail?: string | null;
      eventType?: string | null;
      platform?: string | null;
      startDateTimeOfEvent?: string | null;
    } | null;
    monetization?: {
      adFrequency?: number | null;
      adLength?: number | null;
      allowFreePreview?: boolean | null;
      allowFreePreviewSub?: boolean | null;
      allowNonSubscribersPPV?: boolean | null;
      allowPPVSub?: boolean | null;
      contributorsOptions?: string | null;
      freePreviewTime?: string | null;
      freePreviewTimeSub?: string | null;
      maxPrice?: string | null;
      messageForViewers?: string | null;
      minPrice?: string | null;
      monetizationType?: IMonetizationTypeV2 | null;
      preRoll?: boolean | null;
      price1?: string | null;
      price2?: string | null;
      price3?: string | null;
      price4?: string | null;
      priceInput?: IPriceInputTypeV2 | null;
      pricePerPPV?: string | null;
      pricePerPPVSub?: string | null;
      subscribersOnly?: boolean | null;
      sponsor?: Array<{
        sponsorAmount?: string | null;
        sponsorLogo?: string | null;
        sponsorName?: string | null;
      } | null> | null;
    } | null;
    options?: {
      allowOtherChats?: boolean | null;
      isPrivateEvent?: boolean | null;
      isFollowerOnly?: boolean | null;
      numberOfChatsPerStream?: number | null;
      privateEventPassword?: string | null;
      recordEvent?: boolean | null;
      recordEventExpirationDate?: string | null;
      newStreamTypeOptions?: string | null;
    } | null;
    streamers?: Array<{
      id?: string | null;
      isPromo?: boolean | null;
      type?: IStreamsTypeV2 | null;
      emailInvite?: {
        customMessage?: string | null;
        email?: string | null;
        isPrivateMessage?: boolean | null;
      } | null;
      embedStreams?: {
        logo?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        streamUrl?: string | null;
        thumbnail?: string | null;
        chat?: Array<{
          type?: string | null;
          url?: string | null;
        } | null> | null;
      } | null;
      klic?: {
        isThumbnailOverridden?: boolean | null;
        logo?: string | null;
        mediaOffset?: string | null;
        streamUrl?: string | null;
        thumbnailUrl?: string | null;
        vodUrl?: string | null;
        chat?: Array<{
          url?: string | null;
          type?: string | null;
        } | null> | null;
        channel?: {
          channelArn?: string | null;
          channelInputUrl?: string | null;
          channelStreamKey?: string | null;
          id: string;
          isChannelLive?: string | null;
          ivsChannelName?: string | null;
          liveUrl?: string | null;
          userId?: string | null;
          name?: string | null;
          user?: {
            firstName?: string | null;
            lastName?: string | null;
            id: string;
            email: string;
            username: string;
            avatar?: string | null;
            heading?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null> | null;
};
export type IGetCategoryWithEventsV2Query = {
  getCategoryWithEventsV2: {
    slug?: string | null;
    title?: string | null;
    events: Array<{
      attendees?: Array<string | null> | null;
      createdAt?: string | null;
      slug?: string | null;
      id?: string | null;
      status?: IStatusTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      availableActions?: {
        archive?: boolean | null;
        edit?: boolean | null;
        remove?: boolean | null;
        finish?: boolean | null;
        start?: boolean | null;
      } | null;
      details?: {
        duration?: number | null;
        eventCategory?: Array<string | null> | null;
        eventTag?: Array<string | null> | null;
        eventDescription?: string | null;
        eventName?: string | null;
        eventOwner?: string | null;
        eventOwnerAvatar?: string | null;
        eventPosterImage?: string | null;
        eventStartDateAndTime?: string | null;
        eventThumbnail?: string | null;
        eventType?: string | null;
        platform?: string | null;
        startDateTimeOfEvent?: string | null;
      } | null;
      monetization?: {
        adFrequency?: number | null;
        adLength?: number | null;
        allowFreePreview?: boolean | null;
        allowFreePreviewSub?: boolean | null;
        allowNonSubscribersPPV?: boolean | null;
        allowPPVSub?: boolean | null;
        contributorsOptions?: string | null;
        freePreviewTime?: string | null;
        freePreviewTimeSub?: string | null;
        maxPrice?: string | null;
        messageForViewers?: string | null;
        minPrice?: string | null;
        monetizationType?: IMonetizationTypeV2 | null;
        preRoll?: boolean | null;
        price1?: string | null;
        price2?: string | null;
        price3?: string | null;
        price4?: string | null;
        priceInput?: IPriceInputTypeV2 | null;
        pricePerPPV?: string | null;
        pricePerPPVSub?: string | null;
        subscribersOnly?: boolean | null;
        sponsor?: Array<{
          sponsorAmount?: string | null;
          sponsorLogo?: string | null;
          sponsorName?: string | null;
        } | null> | null;
      } | null;
      options?: {
        allowOtherChats?: boolean | null;
        isPrivateEvent?: boolean | null;
        isFollowerOnly?: boolean | null;
        numberOfChatsPerStream?: number | null;
        privateEventPassword?: string | null;
        recordEvent?: boolean | null;
        recordEventExpirationDate?: string | null;
        newStreamTypeOptions?: string | null;
      } | null;
      streamers?: Array<{
        id?: string | null;
        isPromo?: boolean | null;
        type?: IStreamsTypeV2 | null;
        emailInvite?: {
          customMessage?: string | null;
          email?: string | null;
          isPrivateMessage?: boolean | null;
        } | null;
        embedStreams?: {
          logo?: string | null;
          streamName?: string | null;
          streamType?: string | null;
          streamUrl?: string | null;
          thumbnail?: string | null;
          chat?: Array<{
            type?: string | null;
            url?: string | null;
          } | null> | null;
        } | null;
        klic?: {
          isThumbnailOverridden?: boolean | null;
          logo?: string | null;
          mediaOffset?: string | null;
          streamUrl?: string | null;
          thumbnailUrl?: string | null;
          vodUrl?: string | null;
          chat?: Array<{
            url?: string | null;
            type?: string | null;
          } | null> | null;
          channel?: {
            channelArn?: string | null;
            channelInputUrl?: string | null;
            channelStreamKey?: string | null;
            id: string;
            isChannelLive?: string | null;
            ivsChannelName?: string | null;
            liveUrl?: string | null;
            userId?: string | null;
            name?: string | null;
            user?: {
              firstName?: string | null;
              lastName?: string | null;
              id: string;
              email: string;
              username: string;
              avatar?: string | null;
              heading?: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};
export type IGetEventsForCarouselV2QueryVariables = Exact<{
  [key: string]: never;
}>;
export type IGetCarouselEventsV2QueryVariables = Exact<{
  [key: string]: never;
}>;
export type IGetReasonListForReportQueryVariables = Exact<{
  [key: string]: never;
}>;
export type IGetFeaturedEventsV2QueryVariables = Exact<{
  [key: string]: never;
}>;
export type IGetFeaturedEventsV2ByTypeQueryVariables = Exact<{
  type?: Scalars['String'];
}>;
export type IGetLiveEventsV2QueryVariables = Exact<{
  [key: string]: never;
}>;
export type IGetEventsV2QueryVariables = Exact<{
  [key: string]: never;
}>;

export type IGetEventsForCarouselV2Query = {
  getEventsForCarouselV2?: Array<{
    slug?: string | null;
    username?: string | null;
    eventId?: string | null;
    id: string;
    carouselId: string;
    carouselstreamId: string;
    carouselchannelId: string;
    position?: number | null;
    posterImage?: string | null;
    thumbnail?: string | null;
    name?: string | null;
    description?: string | null;
    status?: string | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
  } | null> | null;
};

export type IGetCarouselEventsV2Query = {
  getCarouselEventsV2?: Array<{
    slug?: string | null;
    eventStartedAt?: string | null;
    eventStoppedAt?: string | null;
    attendees?: Array<string | null> | null;
    createdAt?: string | null;
    id?: string | null;
    status?: IStatusTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    availableActions?: {
      archive?: boolean | null;
      edit?: boolean | null;
      remove?: boolean | null;
      finish?: boolean | null;
      start?: boolean | null;
    } | null;
    details?: {
      duration?: number | null;
      eventCategory?: Array<string | null> | null;
      eventDescription?: string | null;
      eventName?: string | null;
      eventOwner?: string | null;
      eventOwnerAvatar?: string | null;
      eventPosterImage?: string | null;
      eventStartDateAndTime?: string | null;
      eventThumbnail?: string | null;
      eventType?: string | null;
      platform?: string | null;
      braketologyEmbedLink?: string | null;
      braketologyType?: string | null;
      vodArchiveTime?: string | null;
      streamCheckInTime?: string | null;
      startDateTimeOfEvent?: string | null;
    } | null;
    monetization?: {
      adFrequency?: number | null;
      adLength?: number | null;
      allowFreePreview?: boolean | null;
      allowFreePreviewSub?: boolean | null;
      allowNonSubscribersPPV?: boolean | null;
      allowPPVSub?: boolean | null;
      contributorsOptions?: string | null;
      freePreviewTime?: string | null;
      freePreviewTimeSub?: string | null;
      maxPrice?: string | null;
      messageForViewers?: string | null;
      minPrice?: string | null;
      monetizationType?: IMonetizationTypeV2 | null;
      preRoll?: boolean | null;
      price1?: string | null;
      price2?: string | null;
      price3?: string | null;
      price4?: string | null;
      priceInput?: IPriceInputTypeV2 | null;
      pricePerPPV?: string | null;
      pricePerPPVSub?: string | null;
      donationLink?: string | null;
      subscribersOnly?: boolean | null;
      sponsor?: Array<{
        sponsorAmount?: string | null;
        sponsorLogo?: string | null;
        sponsorName?: string | null;
      } | null> | null;
    } | null;
    options?: {
      allowOtherChats?: boolean | null;
      isPrivateEvent?: boolean | null;
      isFollowerOnly?: boolean | null;
      numberOfChatsPerStream?: number | null;
      privateEventPassword?: string | null;
      recordEvent?: boolean | null;
      recordEventExpirationDate?: string | null;
      newStreamTypeOptions?: string | null;
    } | null;
    streamers?: Array<{
      id?: string | null;
      position?: number | null;
      isPromo?: boolean | null;
      isActive?: boolean | null;
      type?: IStreamsTypeV2 | null;
      viewers?: {
        id?: string | null;
        type?: string | null;
        current?: string | null;
        total?: string | null;
      } | null;
      media?: {
        id?: string | null;
        name?: string | null;
        isChannelLive?: boolean | null;
        livePlaybackUrl?: string | null;
        masterKey?: string | null;
        playlistDuration?: string | null;
        recordingStartedAt?: string | null;
      } | null;
      emailInvite?: {
        customMessage?: string | null;
        email?: string | null;
        isPrivateMessage?: boolean | null;
      } | null;
      embedStreams?: {
        logo?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        streamUrl?: string | null;
        thumbnail?: string | null;
        chat?: Array<{
          type?: string | null;
          url?: string | null;
        } | null> | null;
      } | null;
      klic?: {
        isThumbnailOverridden?: boolean | null;
        logo?: string | null;
        mediaOffset?: string | null;
        streamUrl?: string | null;
        thumbnailUrl?: string | null;
        vodUrl?: string | null;
        chat?: Array<{
          url?: string | null;
          type?: string | null;
        } | null> | null;
        channel?: {
          channelArn?: string | null;
          channelInputUrl?: string | null;
          channelStreamKey?: string | null;
          id: string;
          isChannelLive?: string | null;
          ivsChannelName?: string | null;
          liveUrl?: string | null;
          userId?: string | null;
          name?: string | null;
          user?: {
            firstName?: string | null;
            lastName?: string | null;
            id: string;
            email: string;
            username: string;
            avatar?: string | null;
            heading?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null> | null;
};
/**
 * Created by Marvin Calvo on 11.7.24.
 */
export type IGetCarouselEventsV3Query = {
  getCarouselEventsV3?: Array<{
    attendees?: Array<string | null> | null;
    createdAt?: string | null;
    slug?: string | null;
    activeStreamId?: string | null;
    id?: string | null;
    ownerChannelId?: string | null;
    ownerId?: string | null;
    status?: IStatusTypeV2 | null;
    eventStartedAt?: string | null;
    eventStoppedAt?: string | null;
    featuredPosition?: string | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    availableActions?: {
      archive?: boolean | null;
      edit?: boolean | null;
      remove?: boolean | null;
      finish?: boolean | null;
      start?: boolean | null;
    } | null;
    details?: {
      duration?: number | null;
      eventCategory?: Array<string | null> | null;
      eventDescription?: string | null;
      eventName?: string | null;
      eventOwner?: string | null;
      eventOwnerAvatar?: string | null;
      eventPosterImage?: string | null;
      eventStartDateAndTime?: string | null;
      eventThumbnail?: string | null;
      eventType?: string | null;
      platform?: string | null;
      startDateTimeOfEvent?: string | null;
    } | null;
    monetization?: {
      adFrequency?: number | null;
      adLength?: number | null;
      allowFreePreview?: boolean | null;
      allowFreePreviewSub?: boolean | null;
      isFollowerOnly?: boolean | null;
      allowNonSubscribersPPV?: boolean | null;
      allowPPVSub?: boolean | null;
      contributorsOptions?: string | null;
      freePreviewTime?: string | null;
      freePreviewTimeSub?: string | null;
      maxPrice?: string | null;
      messageForViewers?: string | null;
      minPrice?: string | null;
      monetizationType?: IMonetizationTypeV2 | null;
      preRoll?: boolean | null;
      price1?: string | null;
      price2?: string | null;
      price3?: string | null;
      price4?: string | null;
      priceInput?: IPriceInputTypeV2 | null;
      pricePerPPV?: string | null;
      pricePerPPVSub?: string | null;
      subscribersOnly?: boolean | null;
      sponsor?: Array<{
        sponsorAmount?: string | null;
        sponsorLogo?: string | null;
        sponsorName?: string | null;
      } | null> | null;
    } | null;
    options?: {
      allowOtherChats?: boolean | null;
      isPrivateEvent?: boolean | null;
      isFollowerOnly?: boolean | null;
      numberOfChatsPerStream?: number | null;
      privateEventPassword?: string | null;
      recordEvent?: boolean | null;
      recordEventExpirationDate?: string | null;
      newStreamTypeOptions?: string | null;
    } | null;
    streamers?: Array<{
      id?: string | null;
      isPromo?: boolean | null;
      type?: IStreamsTypeV2 | null;
      emailInvite?: {
        customMessage?: string | null;
        email?: string | null;
        isPrivateMessage?: boolean | null;
      } | null;
      embedStreams?: {
        logo?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        streamUrl?: string | null;
        thumbnail?: string | null;
        chat?: Array<{
          type?: string | null;
          url?: string | null;
        } | null> | null;
      } | null;
      klic?: {
        isThumbnailOverridden?: boolean | null;
        logo?: string | null;
        mediaOffset?: string | null;
        streamUrl?: string | null;
        thumbnailUrl?: string | null;
        vodUrl?: string | null;
        chat?: Array<{
          url?: string | null;
          type?: string | null;
        } | null> | null;
        channel?: {
          channelArn?: string | null;
          channelInputUrl?: string | null;
          channelStreamKey?: string | null;
          id: string;
          isChannelLive?: string | null;
          ivsChannelName?: string | null;
          liveUrl?: string | null;
          userId?: string | null;
          name?: string | null;
          user?: {
            firstName?: string | null;
            lastName?: string | null;
            id: string;
            email: string;
            username: string;
            avatar?: string | null;
            heading?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null> | null;
};
//
export type IGetFeaturedEventsV2Query = {
  getFeaturedEventV2?: Array<{
    attendees?: Array<string | null> | null;
    createdAt?: string | null;
    slug?: string | null;
    id?: string | null;
    featuredPosition?: number | null;
    status?: IStatusTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    availableActions?: {
      archive?: boolean | null;
      edit?: boolean | null;
      remove?: boolean | null;
      finish?: boolean | null;
      start?: boolean | null;
    } | null;
    details?: {
      duration?: number | null;
      eventCategory?: Array<string | null> | null;
      eventDescription?: string | null;
      eventName?: string | null;
      eventOwner?: string | null;
      eventOwnerAvatar?: string | null;
      eventPosterImage?: string | null;
      eventStartDateAndTime?: string | null;
      eventThumbnail?: string | null;
      eventType?: string | null;
      startDateTimeOfEvent?: string | null;
    } | null;
    monetization?: {
      adFrequency?: number | null;
      adLength?: number | null;
      allowFreePreview?: boolean | null;
      allowFreePreviewSub?: boolean | null;
      allowNonSubscribersPPV?: boolean | null;
      allowPPVSub?: boolean | null;
      contributorsOptions?: string | null;
      freePreviewTime?: string | null;
      freePreviewTimeSub?: string | null;
      maxPrice?: string | null;
      messageForViewers?: string | null;
      minPrice?: string | null;
      monetizationType?: IMonetizationTypeV2 | null;
      preRoll?: boolean | null;
      price1?: string | null;
      price2?: string | null;
      price3?: string | null;
      price4?: string | null;
      priceInput?: IPriceInputTypeV2 | null;
      pricePerPPV?: string | null;
      pricePerPPVSub?: string | null;
      subscribersOnly?: boolean | null;
      sponsor?: Array<{
        sponsorAmount?: string | null;
        sponsorLogo?: string | null;
        sponsorName?: string | null;
      } | null> | null;
    } | null;
    options?: {
      allowOtherChats?: boolean | null;
      isPrivateEvent?: boolean | null;
      isFollowerOnly?: boolean | null;
      numberOfChatsPerStream?: number | null;
      privateEventPassword?: string | null;
      recordEvent?: boolean | null;
      recordEventExpirationDate?: string | null;
      newStreamTypeOptions?: string | null;
    } | null;
    streamers?: Array<{
      id?: string | null;
      isPromo?: boolean | null;
      type?: IStreamsTypeV2 | null;
      emailInvite?: {
        customMessage?: string | null;
        email?: string | null;
        isPrivateMessage?: boolean | null;
      } | null;
      embedStreams?: {
        logo?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        streamUrl?: string | null;
        thumbnail?: string | null;
        chat?: Array<{
          type?: string | null;
          url?: string | null;
        } | null> | null;
      } | null;
      klic?: {
        isThumbnailOverridden?: boolean | null;
        logo?: string | null;
        mediaOffset?: string | null;
        streamUrl?: string | null;
        thumbnailUrl?: string | null;
        vodUrl?: string | null;
        chat?: Array<{
          url?: string | null;
          type?: string | null;
        } | null> | null;
        channel?: {
          channelArn?: string | null;
          channelInputUrl?: string | null;
          channelStreamKey?: string | null;
          id: string;
          isChannelLive?: string | null;
          ivsChannelName?: string | null;
          liveUrl?: string | null;
          userId?: string | null;
          user?: {
            firstName?: string | null;
            lastName?: string | null;
            id: string;
            email: string;
            username: string;
            avatar?: string | null;
            heading?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type IGetLiveEventsV2Query = {
  getLiveEventsV2?: Array<{
    id: string;
    name: string | null;
    posterImage?: string | null;
    slug?: string | null;
    status?: string | null;
    eventId?: string | null;
    thumbnail?: string | null;
    description?: string | null;
  } | null> | null;
};
/**
 * Created by Marvin Calvo on 11.7.24.
 */
export type IGetLiveEventsV3Query = {
  getLiveEventsV3?: Array<{
    attendees?: Array<string | null> | null;
    createdAt?: string | null;
    slug?: string | null;
    id?: string | null;
    status?: IStatusTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    availableActions?: {
      archive?: boolean | null;
      edit?: boolean | null;
      remove?: boolean | null;
      finish?: boolean | null;
      start?: boolean | null;
    } | null;
    details?: {
      duration?: number | null;
      eventCategory?: Array<string | null> | null;
      eventTag?: Array<string | null> | null;
      eventDescription?: string | null;
      eventName?: string | null;
      eventOwner?: string | null;
      eventOwnerAvatar?: string | null;
      eventPosterImage?: string | null;
      eventStartDateAndTime?: string | null;
      eventThumbnail?: string | null;
      eventType?: string | null;
      platform?: string | null;
      startDateTimeOfEvent?: string | null;
    } | null;
    monetization?: {
      adFrequency?: number | null;
      adLength?: number | null;
      allowFreePreview?: boolean | null;
      allowFreePreviewSub?: boolean | null;
      allowNonSubscribersPPV?: boolean | null;
      allowPPVSub?: boolean | null;
      contributorsOptions?: string | null;
      freePreviewTime?: string | null;
      freePreviewTimeSub?: string | null;
      maxPrice?: string | null;
      messageForViewers?: string | null;
      minPrice?: string | null;
      monetizationType?: IMonetizationTypeV2 | null;
      preRoll?: boolean | null;
      price1?: string | null;
      price2?: string | null;
      price3?: string | null;
      price4?: string | null;
      priceInput?: IPriceInputTypeV2 | null;
      pricePerPPV?: string | null;
      pricePerPPVSub?: string | null;
      subscribersOnly?: boolean | null;
      sponsor?: Array<{
        sponsorAmount?: string | null;
        sponsorLogo?: string | null;
        sponsorName?: string | null;
      } | null> | null;
    } | null;
    options?: {
      allowOtherChats?: boolean | null;
      isPrivateEvent?: boolean | null;
      numberOfChatsPerStream?: number | null;
      privateEventPassword?: string | null;
      recordEvent?: boolean | null;
      isFollowerOnly?: boolean | null;
      recordEventExpirationDate?: string | null;
      newStreamTypeOptions?: string | null;
    } | null;
    streamers?: Array<{
      id?: string | null;
      isPromo?: boolean | null;
      type?: IStreamsTypeV2 | null;
      emailInvite?: {
        customMessage?: string | null;
        email?: string | null;
        isPrivateMessage?: boolean | null;
      } | null;
      embedStreams?: {
        logo?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        streamUrl?: string | null;
        thumbnail?: string | null;
        chat?: Array<{
          type?: string | null;
          url?: string | null;
        } | null> | null;
      } | null;
      klic?: {
        isThumbnailOverridden?: boolean | null;
        logo?: string | null;
        mediaOffset?: string | null;
        streamUrl?: string | null;
        thumbnailUrl?: string | null;
        vodUrl?: string | null;
        chat?: Array<{
          url?: string | null;
          type?: string | null;
        } | null> | null;
        channel?: {
          channelArn?: string | null;
          channelInputUrl?: string | null;
          channelStreamKey?: string | null;
          id: string;
          isChannelLive?: string | null;
          ivsChannelName?: string | null;
          liveUrl?: string | null;
          userId?: string | null;
          name?: string | null;
          user?: {
            firstName?: string | null;
            lastName?: string | null;
            id: string;
            email: string;
            username: string;
            avatar?: string | null;
            heading?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null> | null;
};
//
/**
 * Created by Marvin Calvo on 11.9.24.
 */
export type IGetUpcomingEventsV3Query = {
  getUpcomingEventsV3: Array<{
    attendees?: Array<string | null> | null;
    createdAt?: string | null;
    slug?: string | null;
    id?: string | null;
    status?: IStatusTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    availableActions?: {
      archive?: boolean | null;
      edit?: boolean | null;
      remove?: boolean | null;
      finish?: boolean | null;
      start?: boolean | null;
    } | null;
    details?: {
      duration?: number | null;
      eventCategory?: Array<string | null> | null;
      eventTag?: Array<string | null> | null;
      eventDescription?: string | null;
      eventName?: string | null;
      eventOwner?: string | null;
      eventOwnerAvatar?: string | null;
      eventPosterImage?: string | null;
      eventStartDateAndTime?: string | null;
      eventThumbnail?: string | null;
      eventType?: string | null;
      platform?: string | null;
      startDateTimeOfEvent?: string | null;
    } | null;
    monetization?: {
      adFrequency?: number | null;
      adLength?: number | null;
      allowFreePreview?: boolean | null;
      allowFreePreviewSub?: boolean | null;
      allowNonSubscribersPPV?: boolean | null;
      allowPPVSub?: boolean | null;
      contributorsOptions?: string | null;
      freePreviewTime?: string | null;
      freePreviewTimeSub?: string | null;
      maxPrice?: string | null;
      messageForViewers?: string | null;
      minPrice?: string | null;
      monetizationType?: IMonetizationTypeV2 | null;
      preRoll?: boolean | null;
      price1?: string | null;
      price2?: string | null;
      price3?: string | null;
      price4?: string | null;
      priceInput?: IPriceInputTypeV2 | null;
      pricePerPPV?: string | null;
      pricePerPPVSub?: string | null;
      subscribersOnly?: boolean | null;
      sponsor?: Array<{
        sponsorAmount?: string | null;
        sponsorLogo?: string | null;
        sponsorName?: string | null;
      } | null> | null;
    } | null;
    options?: {
      allowOtherChats?: boolean | null;
      isPrivateEvent?: boolean | null;
      isFollowerOnly?: boolean | null;
      numberOfChatsPerStream?: number | null;
      privateEventPassword?: string | null;
      recordEvent?: boolean | null;
      recordEventExpirationDate?: string | null;
      newStreamTypeOptions?: string | null;
    } | null;
    streamers?: Array<{
      id?: string | null;
      isPromo?: boolean | null;
      type?: IStreamsTypeV2 | null;
      emailInvite?: {
        customMessage?: string | null;
        email?: string | null;
        isPrivateMessage?: boolean | null;
      } | null;
      embedStreams?: {
        logo?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        streamUrl?: string | null;
        thumbnail?: string | null;
        chat?: Array<{
          type?: string | null;
          url?: string | null;
        } | null> | null;
      } | null;
      klic?: {
        isThumbnailOverridden?: boolean | null;
        logo?: string | null;
        mediaOffset?: string | null;
        streamUrl?: string | null;
        thumbnailUrl?: string | null;
        vodUrl?: string | null;
        chat?: Array<{
          url?: string | null;
          type?: string | null;
        } | null> | null;
        channel?: {
          channelArn?: string | null;
          channelInputUrl?: string | null;
          channelStreamKey?: string | null;
          id: string;
          isChannelLive?: string | null;
          ivsChannelName?: string | null;
          liveUrl?: string | null;
          userId?: string | null;
          name?: string | null;
          user?: {
            firstName?: string | null;
            lastName?: string | null;
            id: string;
            email: string;
            username: string;
            avatar?: string | null;
            heading?: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null> | null;
};
//
export type IGetEventsV2Query = {
  getEventV2?: Array<{
    id: string;
    name: string | null;
    posterImage?: string | null;
    slug?: string | null;
    status?: string | null;
    eventId?: string | null;
    thumbnail?: string | null;
    description?: string | null;
  } | null> | null;
};

export type IGetStreamV2QueryVariables = Exact<{
  getStreamInput?: InputMaybe<IGetStreamInput>;
}>;

export type IGetStreamV2Query = {
  getStreamV2?: {
    name?: string | null;
    isChannelLive?: boolean | null;
    livePlaybackUrl?: string | null;
    masterKey?: string | null;
    playlistDuration?: string | null;
    recordingStartedAt?: string | null;
  } | null;
};
export type IGetStreamViewerV2Query = {
  getStreamViewerV2?: {
    name?: string | null;
    isChannelLive?: boolean | null;
    livePlaybackUrl?: string | null;
    masterKey?: string | null;
    playlistDuration?: string | null;
    recordingStartedAt?: string | null;
    viewerCount?: number | null;
  } | null;
};

export type IGetMediasForChannelQueryVariables = Exact<{
  username: Scalars['String'];
}>;

export type IGetMediasForChannelQuery = {
  getMediasForChannel?: Array<{
    id?: string | null;
    name?: string | null;
    isChannelLive?: boolean | null;
    livePlaybackUrl?: string | null;
    masterKey?: string | null;
    playlistDuration?: string | null;
    recordingStartedAt?: string | null;
    isPublic?: boolean | null;
  } | null> | null;
};

export type IGetThumbnailQueryVariables = Exact<{
  path: Scalars['String'];
}>;

export type IGetThumbnailQuery = {
  getThumbnail?: { url?: string | null } | null;
};

export type IAddViewMutationVariables = Exact<{
  id: Scalars['String'];
  type: Scalars['String'];
}>;
export type IChatSetting = Exact<{
  followersOnly: Scalars['Boolean'];
  subsOnly: Scalars['Boolean'];
  emoteOnly: Scalars['Boolean'];
  slowMode: Scalars['Boolean'];
  eventId: Scalars['String'];
}>;
export type IAddChatSettingMutationVariables = Exact<{
  chatSettingInput?: InputMaybe<IChatSetting>;
}>;
export type IContactRequestV2 = Exact<{
  name: Scalars['Boolean'];
  username: Scalars['Boolean'];
  email: Scalars['Boolean'];
  subject: Scalars['Boolean'];
  description: Scalars['Boolean'];
  category: Scalars['Boolean'];
  subcategory: Scalars['Boolean'];
  platform: Scalars['Boolean'];
  attachement: Scalars['Boolean'];
}>;
export type IContactRequestV2MutationVariables = Exact<{
  contactInput?: InputMaybe<IContactRequestV2>;
}>;
export type IUpdateChatSettingMutationVariables = {
  chatSettingInput?: InputMaybe<IChatSetting>;
};
export type IUserChatSetting = Exact<{
  color?: Scalars['String'];
  discrimination?: Scalars['Boolean'];
  explicitLanguage?: Scalars['Boolean'];
  hostility?: Scalars['Boolean'];
  profanity?: Scalars['Boolean'];
  userId: Scalars['String'];
  eventId: Scalars['String'];
}>;
export type AddUserChatSettingMutationVariables = {
  userChatSettingInput?: InputMaybe<IUserChatSetting>;
};
export type UpdateUserChatSettingMutationVariables = {
  userChatSettingInput?: InputMaybe<IUserChatSetting>;
};
export type AddChatModeratorMutationVariables = Exact<{
  userId: Scalars['String'];
  eventId: Scalars['String'];
}>;
export type DeleteChatModeratorMutationVariables = Exact<{
  userId: Scalars['String'];
  eventId: Scalars['String'];
}>;
export type IUpdateEventStatusMutationVariables = Exact<{
  eventId: Scalars['String'];
  status: Scalars['String'];
}>;

export type ISocialLink = Exact<{
  link: Scalars['String'];
  text: Scalars['String'];
  linkType: Scalars['String'];
}>;
export type IDuplicateEventMutationVariables = Exact<{
  eventId: Scalars['String'];
  channelId: Scalars['String'];
}>;
export type IChangePLanMutationVariables = Exact<{
  userId: Scalars['String'];
  planId: Scalars['String'];
}>;
export type IUpdateSocialLinkMutationVariables = Exact<{
  userSocialLinkInput?: InputMaybe<IUpdateSocialLinInput>;
}>;
export type IAdminUserLockInput = Exact<{
  id: Scalars['String'];
  ftype: Scalars['String'];
  value: Scalars['Boolean'];
  duration: Scalars['Int'];
}>;
export type IDeleteUserByIdInput = Exact<{
  userId: Scalars['String'];
}>;
export type IAdminUserLockMutationVariables = Exact<{
  userInput?: InputMaybe<IAdminUserLockInput>;
}>;
export type IDeleteUserByIdMutationVariables = Exact<{
  cognitoInput?: InputMaybe<IDeleteUserByIdInput>;
}>;
export type IResetPasswordByIdMutationVariables = Exact<{
  userId: Scalars['String'];
  password: Scalars['String'];
}>;

export const AdminUserLockDocument = gql`
  mutation UserLockUnlockV2($userInput: UserAdminInput) {
    userLockUnlockV2(userInput: $userInput)
  }
`;

export type IUpdateSocialLinInput = Exact<{
  userId: Scalars['String'];
  social_link: InputMaybe<Array<InputMaybe<ISocialLink>>>;
}>;

export type IUpdateSocialLinkMutation = {
  updateSocialLinkV2?: string | null;
};
export type IAdminUserLockMutation = {
  userLockUnlockV2?: string | null;
};
export type IDeleteUserByIdMutation = {
  DeleteUserById?: string | null;
};
export type IResetUserPasswordMutation = {
  resetUserPassword?: string | null;
};
export type IDuplicateEventMutation = {
  DuplicateEventForChannelV2?: string | null;
};
export type IChangePLanMutation = {
  changePlanV2?: string | null;
};

export const UpdateSocialLinkV2Document = gql`
  mutation UpdateSocialLinkV2($userSocialLinkInput: UpdateSocialInput) {
    updateSocialLinkV2(userSocialLinkInput: $userSocialLinkInput)
  }
`;
export const DeleteUserByIdDocument = gql`
  mutation DeleteUserById($cognitoInput: DeleteCognitoProfileInput) {
    DeleteUserById(cognitoInput: $cognitoInput)
  }
`;
export const ResetUserPasswordDocument = gql`
  mutation ResetPasswordByAdmin($password: String!, $userId: String!) {
    resetUserPassword(password: $password, userId: $userId)
  }
`;
export const ChangePlanV2Document = gql`
  mutation changePlanV2($planId: String!, $userId: String!) {
    changePlanV2(planId: $planId, userId: $userId)
  }
`;
export const DuplicateEventDocument = gql`
  mutation DuplicateEventForChannelV2($eventId: String!, $channelId: String!) {
    DuplicateEventForChannelV2(eventId: $eventId, channelId: $channelId)
  }
`;
export const UpdateEventStatusDocument = gql`
  mutation updateEventStatus($eventId: String!, $status: String!) {
    updateEventStatus(eventId: $eventId, status: $status)
  }
`;
export type IUpdateEventStatusMutation = {
  updateEventStatusV2?: string | null;
};
export type IContactRequestV2Mutation = {
  ContactRequestV2?: string | null;
};
export type IAddViewMutation = {
  addLiveViewV2?: {
    id?: string | null;
    type?: string | null;
    total?: string | null;
    current?: string | null;
  } | null;
};
export type IAddChatSettingMutation = {
  followersOnly?: boolean | null;
  subsOnly?: boolean | null;
  emoteOnly?: boolean | null;
  slowMode?: boolean | null;
  eventId?: string | null;
};
export type IUpdateChatSettingMutation = {
  followersOnly?: boolean | null;
  subsOnly?: boolean | null;
  emoteOnly?: boolean | null;
  slowMode?: boolean | null;
  eventId?: string | null;
};
export type IAddUserChatSettingMutation = {
  color?: string | null;
  discrimination?: boolean | null;
  explicitLanguage?: boolean | null;
  hostility?: boolean | null;
  profanity?: boolean | null;
  userId?: string | null;
  eventId?: string | null;
};
export type IUpdateUserChatSettingMutation = {
  color?: string | null;
  discrimination?: boolean | null;
  explicitLanguage?: boolean | null;
  hostility?: boolean | null;
  profanity?: boolean | null;
  userId?: string | null;
  eventId?: string | null;
};
export type IAddChatModeratorMutation = {
  addChatModeratorV2?: {
    eventId?: string | null;
    userId?: string | null;
  };
};
export type IDeleteChatModeratorMutation = {
  deleteChatModeratorV2?: {
    eventId?: string | null;
    userId?: string | null;
  };
};
export type IRemoveViewMutationVariables = Exact<{
  id: Scalars['String'];
  type: Scalars['String'];
}>;

export type IRemoveViewMutation = {
  removeLiveViewV2?: {
    id?: string | null;
    type?: string | null;
    total?: string | null;
    current?: string | null;
  } | null;
};

export type IGetViewsQueryVariables = Exact<{
  id: Scalars['String'];
  type: Scalars['String'];
}>;

export type IGetViewsQuery = {
  getViews?: {
    id?: string | null;
    type?: string | null;
    total?: string | null;
    current?: string | null;
  } | null;
};

export type IOnViewerNumberChangeSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnViewerNumberChangeSubscription = {
  onViewerNumberChange?: {
    id?: string | null;
    type?: string | null;
    total?: string | null;
    current?: string | null;
  } | null;
};

export type IAttendEventV2MutationVariables = Exact<{
  eventId: Scalars['String'];
  userId: Scalars['String'];
}>;

export type IAttendEventV2Mutation = {
  attendEventV2?: {
    attendees?: Array<string | null> | null;
    eventId?: string | null;
  } | null;
};

export type IOnAttendEventSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnAttendEventSubscription = {
  onAttendEventV2?: {
    attendees?: Array<string | null> | null;
    eventId?: string | null;
  } | null;
};

export type IGetAttendeesV2QueryVariables = Exact<{
  userIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;

export type IGetAttendeesV2Query = {
  getAttendeesV2?: Array<{
    avatar?: string | null;
    email: string;
    firstName: string;
    heading?: string | null;
    lastName: string;
    roleId: string;
    username: string;
  } | null> | null;
};

export type IStopStreamerByAdminMutationVariables = Exact<{
  streamerId: Scalars['String'];
}>;

export type IStopStreamerByAdminMutation = {
  stopStreamerByAdmin?: {
    id?: string | null;
    isPromo?: boolean | null;
    isActive?: boolean | null;
    type?: IStreamsTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    media?: {
      id?: string | null;
      name?: string | null;
      isChannelLive?: boolean | null;
      livePlaybackUrl?: string | null;
      masterKey?: string | null;
      playlistDuration?: string | null;
      recordingStartedAt?: string | null;
    } | null;
    emailInvite?: {
      customMessage?: string | null;
      email?: string | null;
      isPrivateMessage?: boolean | null;
    } | null;
    embedStreams?: {
      logo?: string | null;
      streamName?: string | null;
      streamType?: string | null;
      streamUrl?: string | null;
      thumbnail?: string | null;
      chat?: Array<{ type?: string | null; url?: string | null } | null> | null;
    } | null;
    klic?: {
      isThumbnailOverridden?: boolean | null;
      logo?: string | null;
      mediaOffset?: string | null;
      streamUrl?: string | null;
      thumbnailUrl?: string | null;
      vodUrl?: string | null;
      chat?: Array<{ url?: string | null; type?: string | null } | null> | null;
      channel?: {
        channelArn?: string | null;
        channelInputUrl?: string | null;
        channelStreamKey?: string | null;
        id: string;
        isChannelLive?: string | null;
        ivsChannelName?: string | null;
        liveUrl?: string | null;
        userId?: string | null;
        name?: string | null;
        user?: {
          firstName?: string | null;
          lastName?: string | null;
          id: string;
          email: string;
          username: string;
          avatar?: string | null;
          heading?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type IOnStopStreamerByAdminSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnStopStreamerByAdminSubscription = {
  onStopStreamerByAdmin?: {
    id?: string | null;
    isPromo?: boolean | null;
    isActive?: boolean | null;
    type?: IStreamsTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    media?: {
      id?: string | null;
      name?: string | null;
      isChannelLive?: boolean | null;
      livePlaybackUrl?: string | null;
      masterKey?: string | null;
      playlistDuration?: string | null;
      recordingStartedAt?: string | null;
    } | null;
    emailInvite?: {
      customMessage?: string | null;
      email?: string | null;
      isPrivateMessage?: boolean | null;
    } | null;
    embedStreams?: {
      logo?: string | null;
      streamName?: string | null;
      streamType?: string | null;
      streamUrl?: string | null;
      thumbnail?: string | null;
      chat?: Array<{ type?: string | null; url?: string | null } | null> | null;
    } | null;
    klic?: {
      isThumbnailOverridden?: boolean | null;
      logo?: string | null;
      mediaOffset?: string | null;
      streamUrl?: string | null;
      thumbnailUrl?: string | null;
      vodUrl?: string | null;
      chat?: Array<{ url?: string | null; type?: string | null } | null> | null;
      channel?: {
        channelArn?: string | null;
        channelInputUrl?: string | null;
        channelStreamKey?: string | null;
        id: string;
        isChannelLive?: string | null;
        ivsChannelName?: string | null;
        liveUrl?: string | null;
        userId?: string | null;
        name?: string | null;
        user?: {
          firstName?: string | null;
          lastName?: string | null;
          id: string;
          email: string;
          username: string;
          avatar?: string | null;
          heading?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type IStartStreamerByAdminMutationVariables = Exact<{
  streamerId: Scalars['String'];
}>;

export type IStartStreamerByAdminMutation = {
  startStreamerByAdmin?: {
    id?: string | null;
    isPromo?: boolean | null;
    isActive?: boolean | null;
    type?: IStreamsTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    media?: {
      id?: string | null;
      name?: string | null;
      isChannelLive?: boolean | null;
      livePlaybackUrl?: string | null;
      masterKey?: string | null;
      playlistDuration?: string | null;
      recordingStartedAt?: string | null;
    } | null;
    emailInvite?: {
      customMessage?: string | null;
      email?: string | null;
      isPrivateMessage?: boolean | null;
    } | null;
    embedStreams?: {
      logo?: string | null;
      streamName?: string | null;
      streamType?: string | null;
      streamUrl?: string | null;
      thumbnail?: string | null;
      chat?: Array<{ type?: string | null; url?: string | null } | null> | null;
    } | null;
    klic?: {
      isThumbnailOverridden?: boolean | null;
      logo?: string | null;
      mediaOffset?: string | null;
      streamUrl?: string | null;
      thumbnailUrl?: string | null;
      vodUrl?: string | null;
      chat?: Array<{ url?: string | null; type?: string | null } | null> | null;
      channel?: {
        channelArn?: string | null;
        channelInputUrl?: string | null;
        channelStreamKey?: string | null;
        id: string;
        isChannelLive?: string | null;
        ivsChannelName?: string | null;
        liveUrl?: string | null;
        userId?: string | null;
        name?: string | null;
        user?: {
          firstName?: string | null;
          lastName?: string | null;
          id: string;
          email: string;
          username: string;
          avatar?: string | null;
          heading?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type IOnStartStreamerByAdminSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IOnStartStreamerByAdminSubscription = {
  onStartStreamerByAdmin?: {
    id?: string | null;
    isPromo?: boolean | null;
    isActive?: boolean | null;
    type?: IStreamsTypeV2 | null;
    viewers?: {
      id?: string | null;
      type?: string | null;
      current?: string | null;
      total?: string | null;
    } | null;
    media?: {
      id?: string | null;
      name?: string | null;
      isChannelLive?: boolean | null;
      livePlaybackUrl?: string | null;
      masterKey?: string | null;
      playlistDuration?: string | null;
      recordingStartedAt?: string | null;
    } | null;
    emailInvite?: {
      customMessage?: string | null;
      email?: string | null;
      isPrivateMessage?: boolean | null;
    } | null;
    embedStreams?: {
      logo?: string | null;
      streamName?: string | null;
      streamType?: string | null;
      streamUrl?: string | null;
      thumbnail?: string | null;
      chat?: Array<{ type?: string | null; url?: string | null } | null> | null;
    } | null;
    klic?: {
      isThumbnailOverridden?: boolean | null;
      logo?: string | null;
      mediaOffset?: string | null;
      streamUrl?: string | null;
      thumbnailUrl?: string | null;
      vodUrl?: string | null;
      chat?: Array<{ url?: string | null; type?: string | null } | null> | null;
      channel?: {
        channelArn?: string | null;
        channelInputUrl?: string | null;
        channelStreamKey?: string | null;
        id: string;
        isChannelLive?: string | null;
        ivsChannelName?: string | null;
        liveUrl?: string | null;
        userId?: string | null;
        name?: string | null;
        user?: {
          firstName?: string | null;
          lastName?: string | null;
          id: string;
          email: string;
          username: string;
          avatar?: string | null;
          heading?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type IEditMediaMutationVariables = Exact<{
  editMediaInput?: InputMaybe<IEditMediaInput>;
}>;

export type IEditCarousalV2MutationVariables = Exact<{
  editCarouselInput?: InputMaybe<IEditCarouselInput>;
}>;
export type IModifyCarouselV2MutationVariables = Exact<{
  editCarouselInput?: Array<InputMaybe<IEditCarouselInput>>;
}>;
export type ModifyFeaturedCategoryPositionMutationVariables = Exact<{
  featuredCategoryInput?: Array<InputMaybe<IModifyFeaturedPositionInput>>;
  type?: Scalars['String'];
}>;
export const IModifyFeaturedCategoryPositionMutationVariablesDocument = gql`
  mutation modifyFeatureCategoryPosition(
    $featuredCategoryInput: [ModifyFeaturedCategoryInput]
    $type: String!
  ) {
    modifyFeatureCategoryPosition(
      featuredCategoryInput: $featuredCategoryInput
      type: $type
    )
  }
`;
export type ICreateFeaturedCategoryV2Mutation = Exact<{
  createFeaturedCategory?: string | null;
}>;
export type IUpdateFeaturedCategoryPositionMutation = Exact<{
  updateFeaturedCategoryPosition?: string | null;
}>;
export type IUpdateFeaturedCategoryV2Mutation = Exact<{
  updateFeaturedCategory?: InputMaybe<IUpdateFeaturedCategoryInput>;
}>;
export type ICreateFeaturedCategoryV2MutationVariables = Exact<{
  createInput?: InputMaybe<ICreateFeaturedCategoryMultiInput>;
}>;
export type IUpdateFeaturedCategoryV2MutationVariables = Exact<{
  updateInput?: InputMaybe<IUpdateFeaturedCategoryInput>;
}>;
type IUpdateFeaturedCategoryPositionInput = {
  featuredId: Scalars['String'];
  type?: Scalars['String'];
  position?: Scalars['Int'];
};
type ICreateFeaturedCategoryInput = {
  categoryId: Scalars['String'];
  type?: Scalars['String'];
  position?: Scalars['Int'];
};
type ICreateFeaturedCategoryMultiInput = {
  type?: Scalars['String'];
  data: [IFeatureCategoryMultiInput];
};

type IFeatureCategoryMultiInput = {
  categoryId: Scalars['String'];
  position?: Scalars['Int'];
};
type IUpdateFeaturedCategoryInput = {
  categoryId: Scalars['String'];
  featuredId?: Scalars['String'];
  position?: Scalars['Int'];
};

export type IEditFeatureEventV2MutationVariables = Exact<{
  editFeaturedInput?: Array<InputMaybe<IEditCarouselInput>>;
}>;
export type IEditRecommendedEventV2MutationVariables = Exact<{
  editInput?: InputMaybe<IEditRecommendedEventInput>;
}>;

export type IEditMediaMutation = {
  editMediaV2?: {
    id?: string | null;
    isChannelLive?: boolean | null;
    livePlaybackUrl?: string | null;
    masterKey?: string | null;
    name?: string | null;
    playlistDuration?: string | null;
    recordingStartedAt?: string | null;
    isPublic?: boolean | null;
  } | null;
};

export type IEditCarousalV2Mutation = { editCarousalV2?: string | null };
export type IModifyCarousalV2Mutation = { modifyCarouselV2?: string | null };
export type IModifyFeatureCategoryPositionMutation = {
  modifyFeatureCategoryPosition?: string | null;
};

export type IEditFeaturedV2Mutation = { editFeaturedInput?: string | null };

export type IEditRecommendedV2Mutation = { editInput?: string | null };

export type IUpdateUserProfileV2MutationVariables = Exact<{
  updateUserProfileInput?: InputMaybe<IUpdateUserProfileInput>;
}>;
export type IUserProfileV2MutationVariables = Exact<{
  socialProfileInput?: InputMaybe<IUserProfileInput>;
}>;
export type ICongnitoProfileV2MutationVariables = Exact<{
  cognitoInput?: InputMaybe<ICongnitoProfileInput>;
}>;
export type ICompleteSignUpInput = {
  id: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['String']>;
};
export type ICompleteSignUpMutationVariables = Exact<{
  completeSignUpInput?: InputMaybe<ICompleteSignUpInput>;
}>;

export type ICompleteSignUpMutation = {
  completeSignUp?: string | null;
};

export type IUpdateUserProfileV2Mutation = {
  userSocialProfileV2?: {
    avatar?: string | null;
    cognitoId?: string | null;
    firstName?: string | null;
    id?: string | null;
    lastName?: string | null;
    roleId?: string | null;
    username?: string | null;
    heading?: string | null;
  } | null;
};
export type IUserProfileV2Mutation = {
  UserProfileV2?: {
    firstName?: string | null;
    id?: string | null;
    lastName?: string | null;
    username?: string | null;
    kick?: string | null;
    twitch?: string | null;
    youtube?: string | null;
    birthdate?: string | null;
    country?: string | null;
  } | null;
};

export type IGetUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type IGetUserByEmailQuery = {
  getUserByEmailV2?: {
    avatar?: string | null;
    heading?: string | null;
    email: string;
    firstName?: string | null;
    id: string;
    lastName?: string | null;
    username: string;
    kick?: string | null;
    twitch?: string | null;
    youtube?: string | null;
    birthdate?: string | null;
    lastUpdated?: string | null;
    country?: string | null;
    firstLogin?: boolean;
    isLock?: boolean;
    isTempLock?: boolean;
    google_account?: string | null;
    twitter_account?: string | null;
    discord_account?: string | null;
    apple_account?: string | null;
    unread?: number | null;
    channel?: {
      id: string;
      isChannelLive?: string | null;
      ivsChannelName?: string | null;
      liveUrl?: string | null;
      channelArn?: string | null;
      channelStreamKey?: string | null;
      channelInputUrl?: string | null;
      name?: string | null;
    } | null;
    role: { id?: string | null; name?: string | null };
    plan?: {
      annual_price?: number | null;
      description: string;
      id?: string | null;
      paypal_annual: string;
      paypal_monthly?: string | null;
      revenue: string;
      slug?: string | null;
      stripe_annual?: string | null;
      stripe_monthly?: string | null;
      vod_storage?: number | null;
      monthly_price?: number | null;
      klic_stream?: number | null;
      name?: string | null;
      contentType?: boolean | null;
      monitization?: boolean | null;
      streamType?: boolean | null;
      bracktology?: boolean | null;
    } | null;
  } | null;
};

export type IGetUserByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;

export type IGetUserByUsernameQuery = {
  getUserByUsernameV2?: {
    avatar?: string | null;
    heading?: string | null;
    email: string;
    firstName?: string | null;
    id: string;
    lastName?: string | null;
    kick?: string | null;
    twitch?: string | null;
    youtube?: string | null;
    birthdate?: string | null;
    lastUpdated?: string | null;
    country?: string | null;
    username: string;
    firstLogin?: boolean;
    unread?: number | null;
    channel?: {
      id: string;
      isChannelLive?: string | null;
      ivsChannelName?: string | null;
      liveUrl?: string | null;
      channelArn?: string | null;
      channelStreamKey?: string | null;
      channelInputUrl?: string | null;
      name?: string | null;
    } | null;
    role: { id?: string | null; name?: string | null };
    plan?: {
      annual_price?: number | null;
      description: string;
      id?: string | null;
      paypal_annual: string;
      paypal_monthly?: string | null;
      revenue: string;
      slug?: string | null;
      stripe_annual?: string | null;
      stripe_monthly?: string | null;
      vod_storage?: number | null;
      monthly_price?: number | null;
      klic_stream?: number | null;
      name?: string | null;
      contentType?: boolean | null;
      monitization?: boolean | null;
      streamType?: boolean | null;
      bracktology?: boolean | null;
    } | null;
  } | null;
};

export type IGlobalSignOutV2MutationVariables = Exact<{
  username: Scalars['String'];
}>;

export type IGlobalSignOutV2Mutation = {
  globalSignOutV2?: { body?: string | null } | null;
};

export type ICreateVisitEventMutationVariables = Exact<{
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
}>;

export type ICreateVisitEventMutation = { createVisitEvent?: string | null };

export type ICheckPpvVisitQueryVariables = Exact<{
  cache: Scalars['String'];
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
}>;

export type ICheckPpvVisitQuery = {
  checkPpvVisit?: {
    alreadyVisitedByIp?: boolean | null;
    alreadyVisitedByUser?: boolean | null;
    isAllowed?: boolean | null;
  } | null;
};

// New APIs

export type IFollowChannelV2MutationVariables = Exact<{
  followChannel?: InputMaybe<IFollowChannelV2>;
}>;

export type IFollowCategoryV2MutationVariables = Exact<{
  followCategory?: InputMaybe<IFollowCategoryV2>;
}>;
export type IUnFollowChannelV2MutationVariables = Exact<{
  unfollowChannel?: InputMaybe<IFollowChannelV2>;
}>;
export type IFollowChannelActionMutationVariables = Exact<{
  followerAction?: InputMaybe<IFollowChannelAction>;
}>;

export type FollowChannelActionMutation = {
  followChannelAction?: string | null;
};
export type IFollowChannelV2Mutation = {
  followChannelV2?: string | null;
};
export type IFollowCategoryV2Mutation = {
  followCategoryV2?: string | null;
};
export type IUnFollowChannelV2Mutation = {
  unfollowChannelV2?: string | null;
};
export type IUpdateChannelV2MutationVariables = Exact<{
  aboutChannel?: InputMaybe<IUpdateChannelV2>;
}>;
export type IUpdateChannelV2Mutation = {
  updateChannelV2?: string | null;
};
export const followChannelV2Document = gql`
  mutation followChannelV2($followChannel: FollowChannelInput) {
    followChannelV2(followChannel: $followChannel)
  }
`;
export const followChannelActionDocument = gql`
  mutation followChannelAction($followerAction: FollowChannelActionInput) {
    followChannelAction(followerAction: $followerAction)
  }
`;
export const followCategoryV2Document = gql`
  mutation followCategoryV2($followCategory: FollowCategoryInput) {
    followCategoryV2(followCategory: $followCategory)
  }
`;
export const updateChannelV2Document = gql`
  mutation updateChannelV2($aboutChannel: UpdateChannelInput) {
    updateChannelV2(aboutChannel: $aboutChannel)
  }
`;
export const unfollowChannelV2Document = gql`
  mutation unFollowChannelV2($unfollowChannel: FollowChannelInput) {
    unFollowChannelV2(unfollowChannel: $unfollowChannel)
  }
`;
export const SubscribeChannelV2Document = gql`
  mutation createSubscriptionV2($createSubscription: SubscribeChannelInput) {
    createSubscriptionV2(createSubscription: $createSubscription)
  }
`;

export type IFollowChannelV2 = {
  channelId: Scalars['String'];
  userId: Scalars['String'];
};
export type IFollowChannelAction = {
  channelId: Scalars['String'];
  userId: Scalars['String'];
  type: Scalars['String'];
};
export type IFollowCategoryV2 = {
  categoryId: Scalars['String'];
  userId: Scalars['String'];
};
export type IUpdateChannelV2 = {
  channelId: Scalars['String'];
  aboutme: Scalars['String'];
};
// New APIs
// Channel Subscription
export type IChannelSubscriptionQuery = {
  checkChannelSubscribeV2?: {
    isTaken?: boolean | null;
    plan?: Array<{
      paypalId: string | null;
      price: string | null;
      square: string | null;
      type: string | null;
    } | null>;
  } | null;
};
export type IGetChannelSubscribePayload = {
  channelId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IGetChannelSubscribeQuery = {
  checkChannelSubscribeV2?: { isTaken?: boolean | null } | null;
};

export type IGetFeaturedCategoryByTypeVariables = {
  type?: Maybe<Scalars['String']>;
};

export type IGetFeaturedCategoryByTypeQuery = {
  getFeaturedCategoryByType?: Array<{
    id: string;
    categoryId: string;
    position: Scalars['Int'];
    category: {
      name: string;
      slug: string;
      thumbnail: string;
      id: string;
    };
  } | null> | null;
};

export const GetFeaturedCategoryByTypeDocument = gql`
  query GetFeaturedCategoryByType($type: String!) {
    getFeaturedCategoryByType(type: $type) {
      id
      categoryId
      position
      category {
        name
        slug
        thumbnail
        id
      }
    }
  }
`;

export type IGetPlanListQuery = {
  getPlanListV2?: Array<{
    annual_price?: number | null;
    description: string;
    id?: string | null;
    paypal_annual: string;
    paypal_monthly?: string | null;
    revenue: string;
    slug?: string | null;
    stripe_annual?: string | null;
    stripe_monthly?: string | null;
    vod_storage?: number | null;
    monthly_price?: number | null;
    klic_stream?: number | null;
    name?: string | null;
  } | null> | null;
};

export const GetChannelSubscribeDocument = gql`
  query ChannelSubscription($channelId: String!, $userId: String!) {
    checkChannelSubscribeV2(channelId: $channelId, userId: $userId) {
      isTaken
      plan {
        paypalId
        price
        square
        type
      }
    }
  }
`;
export const GetSettingV2Document = gql`
  query GetSettingV2 {
    getSettingV2 {
      liveCategory
      scheduleCategory
    }
  }
`;
export const GetChannelEventStreamsDocument = gql`
  query GetChannelEventStreams {
    getChannelEventStreams {
      channelId
      channelName
      event {
        eventName
        id
        status
        streamers {
          id
          type
          isActive
          position
          streamName
          streamType
        }
      }
    }
  }
`;
export const UpdateMinuteWatchDocument = gql`
  query UpdateMinuteWatch(
    $streamId: String!
    $startTime: String!
    $endTime: String!
  ) {
    updateMinuteWatch(
      streamId: $streamId
      startTime: $startTime
      endTime: $endTime
    )
  }
`;
export type IGetSettingV2Variables = Exact<{
  [key: string]: never;
}>;

export type IUpdateMinuteWatchVariables = Exact<{
  streamId: Scalars['String'];
  startTime?: Scalars['String'];
  endTime?: Scalars['String'];
}>;

export type IUpdateMinuteWatchQuery = {
  updateMinuteWatch: string | null;
};

export type IGetSettingV2Query = {
  getSettingV2: {
    liveCategory: string[];
    scheduleCategory: string[];
  };
};
export type IGetChannelEventStreamsQuery = {
  getChannelEventStreams: Array<{
    channelName?: string | null;
    channelId?: string | null;
    event?: Array<{
      id?: string | null;
      status?: IStatusTypeV2 | null;
      eventName?: string | null;
      streamers?: Array<{
        id?: string | null;
        isActive?: string | null;
        position?: string | null;
        streamName?: string | null;
        streamType?: string | null;
        type?: IStreamsTypeV2 | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};
export type IGetChannelEventStreamsResponse = Array<{
  channelName?: string | null;
  channelId?: string | null;
  event?: Array<{
    id?: string | null;
    status?: IStatusTypeV2 | null;
    eventName?: string | null;
    streamers?: Array<{
      id?: string | null;
      isActive?: string | null;
      position?: string | null;
      streamName?: string | null;
      streamType?: string | null;
      type?: IStreamsTypeV2 | null;
    } | null> | null;
  } | null> | null;
} | null>;
// Channel Subscription

export const GetSignedUrlV2Document = gql`
  query GetSignedUrlV2($key: String!) {
    getSignedUrlV2(key: $key) {
      url
    }
  }
`;
export const GetPresignedUploadUrlV2Document = gql`
  mutation GetPresignedUploadUrlV2($key: String!, $type: String!) {
    gfxImageProcessor(key: $key, type: $type) {
      url
    }
  }
`;
export const CheckUsernameDocument = gql`
  query CheckUsername($username: String!) {
    checkUsernameV2(username: $username) {
      isTaken
    }
  }
`;
export const CheckEmailDocument = gql`
  query CheckEmail($email: String!) {
    checkEmailV2(email: $email) {
      isTaken
    }
  }
`;
export const CheckFollowDocument = gql`
  query checkFollower($channelId: String!, $userId: String!) {
    checkFollowerV2(channelId: $channelId, userId: $userId) {
      isTaken
    }
  }
`;
export const DeleteMediaByIdDocument = gql`
  query deleteMediaById($mediaId: String!, $username: String!) {
    deleteMediaById(mediaId: $mediaId, username: $username) {
      isTaken
    }
  }
`;
export const DeleteFeaturedEventDocument = gql`
  query deleteFeaturedEvent($eventId: String!) {
    deleteFeaturedEvent(eventId: $eventId)
  }
`;
export const DeleteEventTypeDocument = gql`
  query deleteEventType($eventTypeId: String!) {
    deleteEventType(eventTypeId: $eventTypeId)
  }
`;
export const DeleteCategoryDocument = gql`
  query deleteCategory($categoryId: String!) {
    deleteCategory(categoryId: $categoryId)
  }
`;
export const DeleteUserPanelDocument = gql`
  mutation DeleteUserPanel($panelId: String!) {
    deleteUserPanel(panelId: $panelId)
  }
`;
export const DeleteEventPanelDocument = gql`
  mutation DeleteEventPanel($panelId: String!) {
    deleteEventPanel(panelId: $panelId)
  }
`;
export const DeleteUserMasterPanelDocument = gql`
  mutation DeleteUserMasterPanel($masterId: String!) {
    deleteUserMasterPanel(masterId: $masterId)
  }
`;
export const DeleteEventMasterPanelDocument = gql`
  mutation DeleteEventMasterPanel($masterId: String!) {
    deleteEventMasterPanel(masterId: $masterId)
  }
`;

export const DeleteRecommendedEventDocument = gql`
  query deleteRecommendedEvent($position: Int!) {
    deleteRecommendedEvent(position: $position)
  }
`;
export const DeleteCarouselEventDocument = gql`
  query deleteCarouselEvent($position: Int!) {
    deleteCarouselEvent(position: $position)
  }
`;
export const DeleteFeaturedCategoryDocument = gql`
  query deleteFeaturedCategory($featuredId: String!) {
    deleteFeaturedCategory(featuredId: $featuredId)
  }
`;
export const SearchKeywordDocument = gql`
  query getSearchByKeyword($keyword: String!) {
    getSearchByKeyword(keyword: $keyword) {
      description
      imgUrl
      title
      type
      userId
      eventId
      channelId
      isLive
      eventStatus
    }
  }
`;
export const GetFollowerListV2Document = gql`
  query getFollowerListV2($getFollowerInput: FollowerInputV2) {
    getFollowerListV2(getFollowerInput: $getFollowerInput) {
      avatar
      channel {
        id
        isChannelLive
        ivsChannelName
        liveUrl
        channelArn
        channelStreamKey
        channelInputUrl
        name
        aboutme
        followcount
      }
      email
      firstName
      id
      lastName
      isSubscribed
      username
      heading
      created_at
      isTBlock
    }
  }
`;
export const GetFollowingV2Document = gql`
  query getFollowerByChannel($getFollowerInput: ChannelFollowerInputV2) {
    getFollowerByChannel(getFollowerInput: $getFollowerInput) {
      events {
        avatar
        email
        username
        firstName
        heading
        id
        isSubscribed
        created_at
        channel {
          aboutme
          channelArn
          channelInputUrl
          channelStreamKey
          followcount
          id
          isChannelLive
          ivsChannelName
          liveUrl
          name
        }
        isTBlock
        lastName
      }
      count
    }
  }
`;
export const GetRevenueChartDocument = gql`
  query getRevenueChart(
    $channelId: String!
    $type: String
    $startDate: String!
    $endDate: String!
  ) {
    getRevenueChart(
      channelId: $channelId
      type: $type
      startDate: $startDate
      endDate: $endDate
    ) {
      total {
        revenue
        subscription
        minute_watch
        stream_minute
        follower
      }
      chart {
        average
        date
        value
      }
      additional {
        date
        average {
          follower
          minute_watch
          revenue
          stream_minute
          subscription
        }
        value {
          avg_viewers
          follower
          subscription
          revenue
          stream_minute
          minute_watch
          live_views
          max_viewers
          ad_break
          ad_time_per_hour
          unique_viewer
        }
      }
    }
  }
`;
export const GetChannelRevenueChartDocument = gql`
  query getChannelRevenueChart(
    $channelId: String!
    $type: String
    $startDate: String!
    $endDate: String!
  ) {
    getChannelRevenueChart(
      channelId: $channelId
      type: $type
      startDate: $startDate
      endDate: $endDate
    ) {
      chart {
        ad_revenue
        date
        ppv_revenue
        revenue
        subscription
      }
      total_revenue
    }
  }
`;
export const GetDashboardV2Document = gql`
  query getDashboardV2(
    $channelId: String!
    $userId: String!
    $startDate: String
    $endDate: String
  ) {
    getDashboardV2(
      channelId: $channelId
      userId: $userId
      startDate: $startDate
      endDate: $endDate
    ) {
      stats {
        followers
        streamers
        views
        total_event
        new_event
        minute_watch
        max_viewers
        average_viewers
        new_followers
        subscriber
        revenue
      }
      latestChannel {
        avatar
        created_at
        email
        firstName
        heading
        lastName
        username
        isSubscribed
      }
      events {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          platform
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
    }
  }
`;
export const FollowerForChannelDocument = gql`
  query getFollowerForChannel($channelId: String!) {
    getFollowerForChannel(channelId: $channelId) {
      count
    }
  }
`;
export const GetAboutMeDocument = gql`
  query getAboutMeV2($userId: String!) {
    getMeAboutV2(userId: $userId) {
      link
      text
      linkType
    }
  }
`;

export type IGetChannelEventsByStatusByUsernameQuery = {
  getChannelEventsByStatusByUsername: EventDataRes[];
};
export type IGetChannelEventByStatusQuery = {
  getChannelEventByStatusV2: {
    aboutme: string;
    avatar: string;
    banner: string;
    followcount: number;
    id: string;
    isChannelLive: boolean;
    isLock: boolean;
    isTempLock: boolean;
    ivsChannelName: string;
    liveUrl: string;
    name: string;
    events: EventDataRes[];
    eventCount: number;
  };
};
export type IGetChannelEventsByStatusByUsernameVariables = Exact<{
  username: Scalars['String'];
  status: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export type IGetChannelEventByStatusQueryVariables = Exact<{
  status: Scalars['String'];
  username: Scalars['String'];
  limit?: Scalars['Int'];
  page?: Scalars['Int'];
}>;
export const GetChannelEventsByStatusByUsernameDocument = gql`
  query GetChannelEventsByStatusByUsername(
    $limit: Int
    $page: Int
    $username: String!
    $status: String!
  ) {
    getChannelEventsByStatusByUsername(
      limit: $limit
      page: $page
      username: $username
      status: $status
    ) {
      viewers {
        id
        type
        current
        total
      }
      attendees
      availableActions {
        archive
        edit
        remove
        finish
        start
      }
      createdAt
      ownerChannelId
      slug
      eventStartedAt
      eventStoppedAt
      details {
        duration
        eventCategory
        eventDescription
        eventName
        eventOwner
        eventPosterImage
        eventOwnerAvatar
        eventStartDateAndTime
        eventThumbnail
        eventType
        platform
        restrict
        eventOwnerLive
        startDateTimeOfEvent
      }
      id
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      options {
        allowOtherChats
        isPrivateEvent
        numberOfChatsPerStream
        privateEventPassword
        recordEvent
        isFollowerOnly
        recordEventExpirationDate
        newStreamTypeOptions
      }
      status
      streamers {
        id
        isPromo
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;
export const GetChannelEventByStatusV2Document = gql`
  query GetChannelEventByStatusV2Document(
    $limit: Int
    $page: Int
    $username: String!
    $status: String!
  ) {
    getChannelEventByStatusV2(
      limit: $limit
      page: $page
      username: $username
      status: $status
    ) {
      aboutme
      avatar
      banner
      followcount
      id
      isChannelLive
      isLock
      isTempLock
      ivsChannelName
      liveUrl
      name
      eventCount
      events {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          platform
          restrict
          eventOwnerLive
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
    }
  }
`;

export const GetCurrentUserDocument = gql`
  query GetCurrentUser($token: String!) {
    getMeV2(token: $token) {
      avatar
      lastUpdated
      unread
      channel {
        id
        isChannelLive
        ivsChannelName
        liveUrl
        channelArn
        channelStreamKey
        channelInputUrl
        name
      }
      email
      firstName
      id
      lastName
      firstLogin
      isSubscribed
      isLock
      isTempLock
      google_account
      apple_account
      twitter_account
      discord_account
      birthdate
      country
      role {
        id
        name
      }
      username
      plan {
        annual_price
        description
        id
        klic_stream
        monthly_price
        name
        paypal_annual
        paypal_monthly
        revenue
        slug
        stripe_annual
        stripe_monthly
        vod_storage
        contentType
        monitization
        streamType
        bracktology
      }
      heading
    }
  }
`;
export const CreateCategoryV2Document = gql`
  mutation CreateCategoryV2($createCategoryInput: CreateCategoryInput) {
    createCategoryV2(createCategoryInput: $createCategoryInput) {
      id
      isActive
      name
      thumbnail
    }
  }
`;
export const CreateUserPanelDocument = gql`
  mutation CreateUserPanel($masterId: String!, $data: UserPanelInput) {
    createUserPanel(masterId: $masterId, data: $data) {
      title
      url
      image
      position
      description
    }
  }
`;
export const CreateEventPanelDocument = gql`
  mutation CreateEventPanel($masterId: String!, $data: UserPanelInput) {
    createEventPanel(masterId: $masterId, data: $data) {
      title
      url
      image
      position
      description
    }
  }
`;
export const CreateUserMasterPanelDocument = gql`
  mutation CreateUserMasterPanel(
    $userId: String!
    $data: UserMasterPanelInput
  ) {
    createUserMasterPanel(userId: $userId, data: $data)
  }
`;
export const UpdateMasterPanelDocument = gql`
  mutation UpdateMasterPanel(
    $masterId: String!
    $title: String!
    $type: String!
  ) {
    updateMasterPanel(masterId: $masterId, title: $title, type: $type)
  }
`;

export const CreateEventMasterPanelDocument = gql`
  mutation CreateEventMasterPanel(
    $userId: String!
    $data: UserMasterPanelInput
  ) {
    createEventMasterPanel(userId: $userId, data: $data)
  }
`;
export const UpdateUserPanelDocument = gql`
  mutation UpdateUserPanel(
    $panelId: String!
    $masterId: String!
    $data: UserPanelInput
  ) {
    updateUserPanel(panelId: $panelId, masterId: $masterId, data: $data)
  }
`;

export const UpdateEventPanelDocument = gql`
  mutation UpdateEventPanel(
    $panelId: String!
    $masterId: String!
    $data: UserPanelInput
  ) {
    updateEventPanel(panelId: $panelId, masterId: $masterId, data: $data)
  }
`;
export const UpdatePanelPositionDocument = gql`
  mutation UpdatePanelPosition(
    $panelId: String!
    $masterId: String!
    $position: Int
  ) {
    updatePositionByMasterId(
      panelId: $panelId
      masterId: $masterId
      position: $position
    )
  }
`;
export const UpdateCarouselPositionV2Document = gql`
  mutation UpdateCarouselPositionV2($updatedCarousel: UpdatedCarouselInput) {
    updateCarouselPositionV2(updatedCarousel: $updatedCarousel)
  }
`;
export const UpdateFeatureEventPositionDocument = gql`
  mutation UpdateFeatureEventPosition(
    $featuredEventInput: [EditFeaturedInput]
  ) {
    updateFeatureEventPosition(featuredEventInput: $featuredEventInput)
  }
`;
export const UpdateEventPanelPositionDocument = gql`
  mutation UpdateEventPanelPosition(
    $panelId: String!
    $masterId: String!
    $position: Int
  ) {
    updateEventPanelPosition(
      panelId: $panelId
      masterId: $masterId
      position: $position
    )
  }
`;
export const UpdatePanelPositionByUserIdDocument = gql`
  mutation UpdatePanelPositionByUserId(
    $userId: String!
    $masterId: String!
    $position: Int
  ) {
    updatePanelPositionByUserId(
      userId: $userId
      masterId: $masterId
      position: $position
    )
  }
`;
export const UpdatePanelPositionByEventIdDocument = gql`
  mutation UpdatePanelPositionByEventId(
    $userId: String!
    $masterId: String!
    $position: Int
  ) {
    updatePanelPositionByEventId(
      userId: $userId
      masterId: $masterId
      position: $position
    )
  }
`;

export const GetCategoriesV2Document = gql`
  query GetCategoriesV2 {
    getCategoriesV2 {
      id
      isActive
      name
      thumbnail
      slug
      totalView
      categoryTags {
        categoryId
        eventTypeId
        eventType {
          name
        }
      }
    }
  }
`;

export const GetTrendingCategoriesDocument = gql`
  query GetTrendingCategory($userId: String, $page: Int, $limit: Int) {
    getTrendingCategory(userId: $userId, page: $page, limit: $limit) {
      id
      name
      slug
      isActive
      thumbnail
      followerCount
      totalEvent
      totalStream
      totalView
      categoryTags {
        eventType {
          name
        }
      }
    }
  }
`;

export const GetCategoryWithScheduleEventsDocument = gql`
  query GetCategoryWithScheduleEvents(
    $userId: String
    $page: Int
    $limit: Int
  ) {
    getCategoryWithScheduleEvents(userId: $userId, page: $page, limit: $limit) {
      title
      slug
      events {
        id
        status
        createdAt
        attendees
        eventStartedAt
        eventStoppedAt
        slug
        details {
          eventName
          eventType
          eventCategory
          eventTag
          eventOwner
          eventOwnerAvatar
          eventStartDateAndTime
          duration
          eventDescription
          eventThumbnail
          eventPosterImage
          platform
          braketologyType
          braketologyEmbedLink
          vodArchiveTime
          streamCheckInTime
          startDateTimeOfEvent
        }
        options {
          isPrivateEvent
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          allowOtherChats
          isFollowerOnly
          numberOfChatsPerStream
          newStreamTypeOptions
        }
        monetization {
          monetizationType
          adLength
          adFrequency
          preRoll
          pricePerPPV
          allowFreePreview
          freePreviewTime
          contributorsOptions
          priceInput
          minPrice
          maxPrice
          price1
          price2
          price3
          price4
          messageForViewers
          subscribersOnly
          allowNonSubscribersPPV
          allowFreePreviewSub
          freePreviewTimeSub
          allowPPVSub
          pricePerPPVSub
          ppvStripeLink
          donationLink
        }
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
        availableActions {
          edit
          start
          finish
          archive
          remove
        }
        viewers {
          id
          type
          total
          current
        }
      }
    }
  }
`;

export const GetCategoryWithEventsDocument = gql`
  query GetCategoryWithEvents($userId: String, $page: Int, $limit: Int) {
    getCategoryWithEvents(userId: $userId, page: $page, limit: $limit) {
      title
      slug
      events {
        id
        status
        createdAt
        attendees
        eventStartedAt
        eventStoppedAt
        slug
        details {
          eventName
          eventType
          eventCategory
          eventTag
          eventOwner
          eventOwnerAvatar
          eventStartDateAndTime
          duration
          eventDescription
          eventThumbnail
          eventPosterImage
          platform
          braketologyType
          braketologyEmbedLink
          vodArchiveTime
          streamCheckInTime
          startDateTimeOfEvent
        }
        options {
          isPrivateEvent
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          allowOtherChats
          isFollowerOnly
          numberOfChatsPerStream
          newStreamTypeOptions
        }
        monetization {
          monetizationType
          adLength
          adFrequency
          preRoll
          pricePerPPV
          allowFreePreview
          freePreviewTime
          contributorsOptions
          priceInput
          minPrice
          maxPrice
          price1
          price2
          price3
          price4
          messageForViewers
          subscribersOnly
          allowNonSubscribersPPV
          allowFreePreviewSub
          freePreviewTimeSub
          allowPPVSub
          pricePerPPVSub
          ppvStripeLink
          donationLink
        }
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
        availableActions {
          edit
          start
          finish
          archive
          remove
        }
        viewers {
          id
          type
          total
          current
        }
      }
    }
  }
`;

export const UpdateCategoryV2Document = gql`
  mutation UpdateCategoryV2($updateCategoryInput: UpdateCategoryInput) {
    updateCategoryV2(updateCategoryInput: $updateCategoryInput) {
      id
      isActive
      name
      thumbnail
      slug
    }
  }
`;
export const GetChannelDocument = gql`
  query GetChannel($username: String!) {
    getChannelV2(username: $username) {
      avatar
      banner
      id
      isChannelLive
      ivsChannelName
      liveUrl
      name
      followcount
      aboutme
      isLock
      isTempLock
    }
  }
`;
export const GetAllChannelsDocument = gql`
  query GetAllChannels {
    getAllChannels {
      avatar
      banner
      id
      isChannelLive
      ivsChannelName
      liveUrl
      name
      followcount
      aboutme
      userId
    }
  }
`;
export const GetAllUsersV2Document = gql`
  query GetAllUsers {
    getAllUsers {
      firstName
      lastName
      id
      email
      avatar
      heading
      name
      role {
        id
        name
      }
      plan {
        id
        name
      }
      created_at
      isLock
      isTempLock
    }
  }
`;
export const GetAdminEventListDocument = gql`
  query GetAdminEventList($limit: Int) {
    getEventList(limit: $limit) {
      viewers {
        id
        type
        current
        total
      }
      attendees
      availableActions {
        archive
        edit
        remove
        finish
        start
      }
      createdAt
      slug
      details {
        duration
        eventCategory
        eventDescription
        eventName
        eventOwner
        eventPosterImage
        eventStartDateAndTime
        eventThumbnail
        eventType
      }
      id
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      options {
        allowOtherChats
        isPrivateEvent
        numberOfChatsPerStream
        privateEventPassword
        recordEvent
        recordEventExpirationDate
        newStreamTypeOptions
      }
      status
      streamers {
        id
        isPromo
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;
export const GetEventsForChannelDocument = gql`
  query GetEventsForChannel($channelId: String!) {
    getEventsForChannel(channelId: $channelId) {
      events {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventCategoryThumbnail
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          startDateTimeOfEvent
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
    }
  }
`;
export const CreateEventForChannelV2Document = gql`
  mutation CreateEventForChannelV2(
    $createEventInput: CreateEventForChannelAsDraftInputV2
  ) {
    createEventForChannelV2(createEventInput: $createEventInput)
  }
`;
export const EditEventV2Document = gql`
  mutation EditEventV2($editEventInput: EditEventInputV2) {
    editEventV2(editEventInput: $editEventInput) {
      id
      slug
      username
      is_change
    }
  }
`;
export const UpdateChatOptionV2V2Document = gql`
  mutation UpdateEventChatOptionsV2(
    $editEventChatOptionsInput: EditChatOptionsInputV2
  ) {
    updateEventChatOptionsV2(
      editEventChatOptionsInput: $editEventChatOptionsInput
    )
  }
`;
export const EventActionsV2Document = gql`
  mutation EventActionsV2(
    $eventId: String!
    $action: EventActionType!
    $description: String
    $streamId: String
    $channelId: String
  ) {
    eventActionsV2(
      eventId: $eventId
      action: $action
      description: $description
      streamId: $streamId
      channelId: $channelId
    ) {
      eventId
      action
    }
  }
`;
export const CreatorEventActionsV2Document = gql`
  mutation CreatorEventActionsV2(
    $eventId: String!
    $action: EventActionType!
    $streamerId: String
  ) {
    eventCreatorActionsV2(
      eventId: $eventId
      action: $action
      streamerId: $streamerId
    )
  }
`;
export const SetUserPreferenceV2Document = gql`
  mutation SetUserPreferenceV2($preferenceInput: PreferenceInput) {
    SetUserPreferenceV2(preferenceInput: $preferenceInput)
  }
`;
export const ILandingFeatureCategoryV2Document = gql`
  mutation editLandingFeatureCategoryV2(
    $editCategoryInput: LandingFeaturedCategoryInput
  ) {
    editLandingFeatureCategoryV2(editCategoryInput: $editCategoryInput)
  }
`;
export const DeleteVideoByIdDocument = gql`
  mutation DeleteVideoById($videoId: String!) {
    deleteVideoById(videoId: $videoId)
  }
`;
export const GetEventViewersDocument = gql`
  query GetEventViewers($slug: String!, $channelName: String!) {
    getEventViewers(slug: $slug, channelName: $channelName) {
      current
      id
      type
      total
    }
  }
`;
export const GetEventByIdV2Document = gql`
  query GetEventByIdV2($slug: String!, $channelName: String!) {
    getEventByIdV2(slug: $slug, channelName: $channelName) {
      slug
      ownerId
      eventStartedAt
      eventStoppedAt
      viewers {
        id
        type
        current
        total
      }
      attendees
      availableActions {
        archive
        edit
        remove
        finish
        start
      }
      createdAt
      details {
        duration
        eventCategory
        eventTag
        eventDescription
        eventName
        eventOwner
        eventOwnerAvatar
        eventPosterImage
        eventStartDateAndTime
        eventThumbnail
        eventType
        platform
        braketologyEmbedLink
        braketologyType
        vodArchiveTime
        streamCheckInTime
        restrict
        eventOwnerLive
        kick
        twitch
        facebook
        youtube
        custom
        startDateTimeOfEvent
        startDateTimeOfEventUTC
      }
      id
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        ppvStripeLink
        donationLink
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      options {
        allowOtherChats
        isPrivateEvent
        numberOfChatsPerStream
        newStreamTypeOptions
        privateEventPassword
        recordEvent
        recordEventExpirationDate
        isFollowerOnly
      }
      status
      streamers {
        id
        position
        isPromo
        categoryId
        streamName
        category {
          id
          followerCount
          isActive
          name
          slug
          thumbnail
        }
        viewers {
          id
          type
          current
          total
        }
        media {
          id
          name
          isChannelLive
          livePlaybackUrl
          masterKey
          playlistDuration
          recordingStartedAt
        }
        isActive
        isEventActive
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            name
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;
export const SendMessageEventChatV2Document = gql`
  mutation SendMessageEventChatV2(
    $eventId: String!
    $chatData: ChatDataInput!
  ) {
    sendMessageEventChatV2(eventId: $eventId, chatData: $chatData) {
      eventId
      data {
        user {
          id
          displayName
        }
        message
        color
        time
        pin
      }
    }
  }
`;
export const PinMessageEventChatV2Document = gql`
  mutation PinMessageEventChatV2(
    $eventId: String!
    $setPriority: Boolean
    $chatData: ChatDataInput!
  ) {
    pinMessageEventChatV2(
      eventId: $eventId
      setPriority: $setPriority
      chatData: $chatData
    ) {
      event
      data {
        id
        user {
          id
          displayName
        }
        priority
        message
        color
        time
        pin
      }
    }
  }
`;
export const RemoveMessageChatDocument = gql`
  mutation removeMessageChat($eventId: String!, $chatData: ChatDataInput!) {
    removeMessageChat(eventId: $eventId, chatData: $chatData)
  }
`;
export const OnNewSendMessageEventChatV2Document = gql`
  subscription OnNewSendMessageEventChatV2($eventId: String) {
    onNewSendMessageEventChatV2(eventId: $eventId) {
      eventId
      data {
        user {
          id
          displayName
        }
        message
        color
        time
        pin
      }
    }
  }
`;

export const OnUpdateChatSettingV2Document = gql`
  subscription OnUpdateChatSettingV2 {
    onUpdateChatSettingV2 {
      followersOnly
      subsOnly
      emoteOnly
      slowMode
      eventId
    }
  }
`;

export const OnPinMessageEventChatV2Document = gql`
  subscription OnPinMessageEventChatV2 {
    onPinMessageEventChatV2 {
      event
      data {
        user {
          id
          displayName
        }
        message
        color
        time
        pin
      }
    }
  }
`;
export const GetEventChatMessagesV2Document = gql`
  query GetEventChatMessagesV2($eventId: String!) {
    getEventChatMessagesV2(eventId: $eventId) {
      messages {
        user {
          id
          displayName
        }
        id
        message
        color
        time
        pin
        priority
      }
    }
  }
`;
export const ClearChatV2Document = gql`
  mutation ClearChatV2($eventId: String!) {
    clearChatV2(eventId: $eventId)
  }
`;
export const VerifyStreamAvailabilityDocument = gql`
  query VerifyStreamAvailability(
    $channelId: String
    $duration: String
    $startDate: String
  ) {
    verifyChannelAvailability(
      channelId: $channelId
      duration: $duration
      startDate: $startDate
    )
  }
`;
export const GetNotificationHistoryDocument = gql`
  query getNotificationHistory($userId: String) {
    getNotificationHistory(userId: $userId) {
      id
      userId
      notificationType
      title
      body
      referenceId
      addition_data {
        channelId
        channelName
        eventId
        userId
      }
      read
      createdAt
      slug
      username
      page
      url
      avatar
    }
  }
`;
export const SendMessageKlicChatV2Document = gql`
  mutation SendMessageKlicChatV2(
    $eventId: String!
    $channelId: String!
    $chatData: ChatDataInput!
  ) {
    sendMessageKlicChatV2(
      eventId: $eventId
      channelId: $channelId
      chatData: $chatData
    ) {
      event
      channel
      data {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const OnSendMessageKlicChatV2Document = gql`
  subscription OnSendMessageKlicChatV2 {
    onSendMessageKlicChatV2 {
      event
      channel
      data {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const OnClearChatV2Document = gql`
  subscription OnClearChatV2 {
    onClearChatV2
  }
`;
export const GetKlicChatMessagesV2Document = gql`
  query GetKlicChatMessagesV2($eventId: String!, $channelId: String!) {
    getKlicChatMessagesV2(eventId: $eventId, channelId: $channelId) {
      channel
      messages {
        user {
          id
          displayName
        }
        message
        color
        time
      }
    }
  }
`;
export const UpdateEventTypeV2Document = gql`
  mutation UpdateEventTypeV2($updateEventTypeInput: UpdateEventTypeInput) {
    updateEventTypeV2(updateEventTypeInput: $updateEventTypeInput) {
      id
      name
      isActive
    }
  }
`;
export const CreateEventTypeV2Document = gql`
  mutation CreateEventTypeV2($createEventTypeInput: CreateEventTypeInput) {
    createEventTypeV2(createEventTypeInput: $createEventTypeInput) {
      id
      name
      isActive
    }
  }
`;
export const GetEventTypesV2Document = gql`
  query GetEventTypesV2 {
    getEventTypesV2 {
      id
      name
      isActive
    }
  }
`;
export const GetHomepageSetupV2Document = gql`
  query getHomePageSetupV2 {
    getEventsForCarouselV2 {
      id
      name
      isActive
    }
  }
`;
export const GetLandingSidebarDataV2Document = gql`
  query GetLandingSidebarDataV2($userId: String) {
    getLandingSidebarDataV2(userId: $userId) {
      recommededEvents {
        description
        eventId
        id
        name
        position
        posterImage
        slug
        status
        streamers
        thumbnail
        username
        category
        viewers {
          current
          id
          total
          type
        }
      }
      followerChannel {
        id
        followcount
        isChannelLive
        ivsChannelName
        aboutme
        user {
          avatar
          username
          lastName
          id
          heading
          email
        }
      }
      followerWithEvent {
        id
        followcount
        isChannelLive
        ivsChannelName
        aboutme
        user {
          avatar
          username
          lastName
          id
          heading
          email
        }
        event {
          viewers {
            id
            type
            current
            total
          }
          attendees
          availableActions {
            archive
            edit
            remove
            finish
            start
          }
          createdAt
          slug
          details {
            duration
            eventCategory
            eventDescription
            eventName
            eventOwner
            eventOwnerAvatar
            eventPosterImage
            eventStartDateAndTime
            eventThumbnail
            eventType
            platform
            startDateTimeOfEvent
          }
          id
          monetization {
            adFrequency
            adLength
            allowFreePreview
            allowFreePreviewSub
            allowNonSubscribersPPV
            allowPPVSub
            contributorsOptions
            freePreviewTime
            freePreviewTimeSub
            maxPrice
            messageForViewers
            minPrice
            monetizationType
            preRoll
            price1
            price2
            price3
            price4
            priceInput
            pricePerPPV
            pricePerPPVSub
            sponsor {
              sponsorAmount
              sponsorLogo
              sponsorName
            }
            subscribersOnly
          }
          options {
            allowOtherChats
            isPrivateEvent
            numberOfChatsPerStream
            privateEventPassword
            recordEvent
            recordEventExpirationDate
            isFollowerOnly
            newStreamTypeOptions
          }
          status
          streamers {
            id
            isPromo
            emailInvite {
              customMessage
              email
              isPrivateMessage
            }
            embedStreams {
              logo
              streamName
              streamType
              streamUrl
              thumbnail
              chat {
                type
                url
              }
            }
            klic {
              isThumbnailOverridden
              logo
              mediaOffset
              streamUrl
              thumbnailUrl
              vodUrl
              chat {
                url
                type
              }
              channel {
                channelArn
                channelInputUrl
                channelStreamKey
                id
                isChannelLive
                ivsChannelName
                liveUrl
                userId
                name
                user {
                  firstName
                  lastName
                  id
                  email
                  username
                  avatar
                  heading
                }
              }
            }
            type
          }
        }
      }
    }
  }
`;
export const GetLandingDataV2Document = gql`
  query GetLandingDataV2 {
    getLandingDataV2 {
      trendingCategory {
        id
        name
        slug
        isActive
        thumbnail
        followerCount
        totalEvent
        totalStream
        categoryTags {
          eventType {
            name
          }
        }
      }
      categoryWithEvents {
        title
        slug
        events {
          id
          status
          createdAt
          attendees
          eventStartedAt
          eventStoppedAt
          slug
          details {
            eventName
            eventType
            eventCategory
            eventTag
            eventOwner
            eventOwnerAvatar
            eventStartDateAndTime
            duration
            eventDescription
            eventThumbnail
            eventPosterImage
            platform
            braketologyType
            braketologyEmbedLink
            vodArchiveTime
            streamCheckInTime
            startDateTimeOfEvent
          }
          options {
            isPrivateEvent
            privateEventPassword
            recordEvent
            recordEventExpirationDate
            allowOtherChats
            isFollowerOnly
            numberOfChatsPerStream
            newStreamTypeOptions
          }
          monetization {
            monetizationType
            adLength
            adFrequency
            preRoll
            pricePerPPV
            allowFreePreview
            freePreviewTime
            contributorsOptions
            priceInput
            minPrice
            maxPrice
            price1
            price2
            price3
            price4
            messageForViewers
            subscribersOnly
            allowNonSubscribersPPV
            allowFreePreviewSub
            freePreviewTimeSub
            allowPPVSub
            pricePerPPVSub
            ppvStripeLink
            donationLink
          }
          streamers {
            id
            isPromo
            emailInvite {
              customMessage
              email
              isPrivateMessage
            }
            embedStreams {
              logo
              streamName
              streamType
              streamUrl
              thumbnail
              chat {
                type
                url
              }
            }
            klic {
              isThumbnailOverridden
              logo
              mediaOffset
              streamUrl
              thumbnailUrl
              vodUrl
              chat {
                url
                type
              }
              channel {
                channelArn
                channelInputUrl
                channelStreamKey
                id
                isChannelLive
                ivsChannelName
                liveUrl
                userId
                name
                user {
                  firstName
                  lastName
                  id
                  email
                  username
                  avatar
                  heading
                }
              }
            }
            type
          }
          availableActions {
            edit
            start
            finish
            archive
            remove
          }
          viewers {
            id
            type
            total
            current
          }
        }
      }
      pastEvents {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          startDateTimeOfEvent
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
    }
  }
`;

export const GetPastEventsDocument = gql`
  query GetPastEvents($userId: String, $page: Int, $limit: Int) {
    getPastEvents(userId: $userId, page: $page, limit: $limit) {
      viewers {
        id
        type
        current
        total
      }
      attendees
      availableActions {
        archive
        edit
        remove
        finish
        start
      }
      createdAt
      slug
      eventStartedAt
      eventStoppedAt
      details {
        duration
        eventCategory
        eventDescription
        eventName
        eventOwner
        eventOwnerAvatar
        eventPosterImage
        eventStartDateAndTime
        eventThumbnail
        eventType
        startDateTimeOfEvent
      }
      id
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      options {
        allowOtherChats
        isPrivateEvent
        numberOfChatsPerStream
        privateEventPassword
        recordEvent
        recordEventExpirationDate
        isFollowerOnly
        newStreamTypeOptions
      }
      status
      streamers {
        id
        isPromo
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            name
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;

export const GetCategoryWithEventsV2Document = gql`
  query GetCategoryWithEventsV2($userId: String, $page: Int, $limit: Int) {
    getCategoryWithEventsV2(userId: $userId, page: $page, limit: $limit) {
      title
      slug
      events {
        id
        status
        createdAt
        attendees
        eventStartedAt
        eventStoppedAt
        slug
        details {
          eventName
          eventType
          eventCategory
          eventTag
          eventOwner
          eventOwnerAvatar
          eventStartDateAndTime
          duration
          eventDescription
          eventThumbnail
          eventPosterImage
          platform
          braketologyType
          braketologyEmbedLink
          vodArchiveTime
          streamCheckInTime
          startDateTimeOfEvent
        }
        options {
          isPrivateEvent
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          allowOtherChats
          isFollowerOnly
          numberOfChatsPerStream
          newStreamTypeOptions
        }
        monetization {
          monetizationType
          adLength
          adFrequency
          preRoll
          pricePerPPV
          allowFreePreview
          freePreviewTime
          contributorsOptions
          priceInput
          minPrice
          maxPrice
          price1
          price2
          price3
          price4
          messageForViewers
          subscribersOnly
          allowNonSubscribersPPV
          allowFreePreviewSub
          freePreviewTimeSub
          allowPPVSub
          pricePerPPVSub
          ppvStripeLink
          donationLink
        }
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
        availableActions {
          edit
          start
          finish
          archive
          remove
        }
        viewers {
          id
          type
          total
          current
        }
      }
    }
  }
`;
export const GetCategoryByIdV2Document = gql`
  query GetCategoryById($slug: String!, $limit: Int) {
    getEventByCategory(categoryId: $slug, limit: $limit) {
      detail {
        followerCount
        id
        name
        totalEvent
        totalStream
        isActive
        slug
        thumbnail
      }
      pastEvents {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          platform
          startDateTimeOfEvent
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
      liveEvents {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          platform
          startDateTimeOfEvent
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
      scheduledEvents {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          platform
          startDateTimeOfEvent
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
    }
  }
`;
export const GetCategoryByIdStatusV2Document = gql`
  query GetCategoryById($categoryId: String!, $type: String!, $limit: Int) {
    getEventByCategory(categoryId: $categoryId, type: $type, limit: $limit) {
      detail {
        followerCount
        id
        name
        totalEvent
        totalStream
        isActive
        slug
        thumbnail
      }
      pastEvents {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          platform
          startDateTimeOfEvent
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
      liveEvents {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          platform
          startDateTimeOfEvent
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
      scheduledEvents {
        viewers {
          id
          type
          current
          total
        }
        attendees
        availableActions {
          archive
          edit
          remove
          finish
          start
        }
        createdAt
        slug
        eventStartedAt
        eventStoppedAt
        details {
          duration
          eventCategory
          eventDescription
          eventName
          eventOwner
          eventOwnerAvatar
          eventPosterImage
          eventStartDateAndTime
          eventThumbnail
          eventType
          platform
          startDateTimeOfEvent
        }
        id
        monetization {
          adFrequency
          adLength
          allowFreePreview
          allowFreePreviewSub
          allowNonSubscribersPPV
          allowPPVSub
          contributorsOptions
          freePreviewTime
          freePreviewTimeSub
          maxPrice
          messageForViewers
          minPrice
          monetizationType
          preRoll
          price1
          price2
          price3
          price4
          priceInput
          pricePerPPV
          pricePerPPVSub
          sponsor {
            sponsorAmount
            sponsorLogo
            sponsorName
          }
          subscribersOnly
        }
        options {
          allowOtherChats
          isPrivateEvent
          numberOfChatsPerStream
          privateEventPassword
          recordEvent
          recordEventExpirationDate
          isFollowerOnly
          newStreamTypeOptions
        }
        status
        streamers {
          id
          isPromo
          emailInvite {
            customMessage
            email
            isPrivateMessage
          }
          embedStreams {
            logo
            streamName
            streamType
            streamUrl
            thumbnail
            chat {
              type
              url
            }
          }
          klic {
            isThumbnailOverridden
            logo
            mediaOffset
            streamUrl
            thumbnailUrl
            vodUrl
            chat {
              url
              type
            }
            channel {
              channelArn
              channelInputUrl
              channelStreamKey
              id
              isChannelLive
              ivsChannelName
              liveUrl
              userId
              name
              user {
                firstName
                lastName
                id
                email
                username
                avatar
                heading
              }
            }
          }
          type
        }
      }
    }
  }
`;
export const GetEventsForCarouselV2Document = gql`
  query GetEventsForCarouselV2 {
    getEventsForCarouselV2 {
      viewers {
        id
        type
        current
        total
      }
      carouselId
      carouselstreamId
      carouselchannelId
      slug
      username
      eventId
      id
      position
      posterImage
      thumbnail
      name
      description
      status
      streamers
    }
  }
`;

export const GetPanelByUserIdDocument = gql`
  query GetPanelByUserId($userId: String!) {
    getPanelByUserId(userId: $userId) {
      id
      title
      userId
      panels {
        id
        title
        url
        image
        description
      }
    }
  }
`;
export const NotifyResetPasswordUserIdDocument = gql`
  query notifyResetPassword($userId: String!) {
    notifyResetPassword(userId: $userId)
  }
`;

export const GetPanelByEventIdDocument = gql`
  query GetPanelByEventId($userId: String!) {
    getPanelbyEventId(userId: $userId) {
      id
      title
      panels {
        id
        title
        url
        image
        description
      }
    }
  }
`;

export const GetCarouselEventsV2Document = gql`
  query GetCarouselEventsV2 {
    getCarouselEventsV2 {
      slug
      eventStartedAt
      eventStoppedAt
      viewers {
        id
        type
        current
        total
      }
      attendees
      availableActions {
        archive
        edit
        remove
        finish
        start
      }
      createdAt
      details {
        duration
        eventCategory
        eventDescription
        eventName
        eventOwner
        eventOwnerAvatar
        eventPosterImage
        eventStartDateAndTime
        eventThumbnail
        eventType
        platform
        braketologyEmbedLink
        braketologyType
        vodArchiveTime
        streamCheckInTime
        startDateTimeOfEvent
      }
      id
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        ppvStripeLink
        donationLink
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      options {
        allowOtherChats
        isPrivateEvent
        numberOfChatsPerStream
        newStreamTypeOptions
        privateEventPassword
        recordEvent
        recordEventExpirationDate
        isFollowerOnly
      }
      status
      streamers {
        id
        position
        isPromo
        viewers {
          id
          type
          current
          total
        }
        media {
          id
          name
          isChannelLive
          livePlaybackUrl
          masterKey
          playlistDuration
          recordingStartedAt
        }
        isActive
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            name
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;
export const GetCarouselEventsV3Document = gql`
  query GetCarouselEventsV3 {
    getCarouselEventsV3 {
      slug
      eventStartedAt
      activeStreamId
      eventStoppedAt
      viewers {
        id
        type
        current
        total
      }
      attendees
      availableActions {
        archive
        edit
        remove
        finish
        start
      }
      createdAt
      details {
        duration
        eventCategory
        eventDescription
        eventName
        eventOwner
        eventOwnerAvatar
        eventPosterImage
        eventStartDateAndTime
        eventThumbnail
        eventType
        platform
        braketologyEmbedLink
        braketologyType
        vodArchiveTime
        streamCheckInTime
        startDateTimeOfEvent
      }
      id
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        ppvStripeLink
        donationLink
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      options {
        allowOtherChats
        isPrivateEvent
        numberOfChatsPerStream
        newStreamTypeOptions
        privateEventPassword
        recordEvent
        recordEventExpirationDate
        isFollowerOnly
      }
      status
      streamers {
        id
        position
        isPromo
        viewers {
          id
          type
          current
          total
        }
        media {
          id
          name
          isChannelLive
          livePlaybackUrl
          masterKey
          playlistDuration
          recordingStartedAt
        }
        isActive
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            name
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;
export const GetFeaturedEventsV2Document = gql`
  query GetFeaturedEventV2($type: String) {
    getFeaturedEventV2(type: $type) {
      slug
      eventStartedAt
      eventStoppedAt
      featuredPosition
      viewers {
        id
        type
        current
        total
      }
      attendees
      availableActions {
        archive
        edit
        remove
        finish
        start
      }
      createdAt
      details {
        duration
        eventCategory
        eventDescription
        eventName
        eventOwner
        eventOwnerAvatar
        eventPosterImage
        eventStartDateAndTime
        eventThumbnail
        eventType
        platform
        braketologyEmbedLink
        braketologyType
        vodArchiveTime
        streamCheckInTime
      }
      id
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        ppvStripeLink
        donationLink
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      options {
        allowOtherChats
        isPrivateEvent
        numberOfChatsPerStream
        newStreamTypeOptions
        privateEventPassword
        recordEvent
        recordEventExpirationDate
        isFollowerOnly
      }
      status
      streamers {
        id
        position
        isPromo
        viewers {
          id
          type
          current
          total
        }
        media {
          id
          name
          isChannelLive
          livePlaybackUrl
          masterKey
          playlistDuration
          recordingStartedAt
        }
        isActive
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            name
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;
export const GetLiveEventsV2Document = gql`
  query GetLiveEventsV2 {
    getLiveEventsV2 {
      name
      id
      posterImage
      slug
      status
      thumbnail
      eventId
      description
    }
  }
`;
export const GetUpcomingEventsV3Document = gql`
  query GetUpcomingEventsV3($userId: String, $page: Int, $limit: Int) {
    getUpcomingEventsV3(userId: $userId, page: $page, limit: $limit) {
      id
      status
      createdAt
      attendees
      eventStartedAt
      eventStoppedAt
      slug
      details {
        eventName
        eventType
        eventCategory
        eventTag
        eventOwner
        eventOwnerAvatar
        eventStartDateAndTime
        duration
        eventDescription
        eventThumbnail
        eventPosterImage
        platform
        braketologyType
        braketologyEmbedLink
        vodArchiveTime
        streamCheckInTime
        startDateTimeOfEvent
      }
      options {
        isPrivateEvent
        privateEventPassword
        recordEvent
        recordEventExpirationDate
        allowOtherChats
        isFollowerOnly
        numberOfChatsPerStream
        newStreamTypeOptions
      }
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      viewers {
        id
        type
        total
        current
      }
      availableActions {
        edit
        start
        finish
        archive
        remove
      }
      streamers {
        id
        isPromo
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            name
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;
export const GetLiveEventsV3Document = gql`
  query GetLiveEventsV3 {
    getLiveEventsV3 {
      id
      status
      ownerId
      ownerChannelId
      createdAt
      attendees
      eventStartedAt
      eventStoppedAt
      slug
      details {
        eventName
        eventType
        eventCategory
        eventTag
        eventOwner
        eventOwnerAvatar
        eventStartDateAndTime
        duration
        eventDescription
        eventThumbnail
        eventPosterImage
        platform
        braketologyType
        braketologyEmbedLink
        vodArchiveTime
        streamCheckInTime
        startDateTimeOfEvent
      }
      monetization {
        adFrequency
        adLength
        allowFreePreview
        allowFreePreviewSub
        allowNonSubscribersPPV
        allowPPVSub
        contributorsOptions
        freePreviewTime
        freePreviewTimeSub
        maxPrice
        messageForViewers
        minPrice
        monetizationType
        preRoll
        price1
        price2
        price3
        price4
        priceInput
        pricePerPPV
        pricePerPPVSub
        sponsor {
          sponsorAmount
          sponsorLogo
          sponsorName
        }
        subscribersOnly
      }
      options {
        isPrivateEvent
        privateEventPassword
        recordEvent
        recordEventExpirationDate
        allowOtherChats
        isFollowerOnly
        numberOfChatsPerStream
        newStreamTypeOptions
      }
      viewers {
        id
        type
        total
        current
      }
      availableActions {
        edit
        start
        finish
        archive
        remove
      }
      streamers {
        id
        isPromo
        emailInvite {
          customMessage
          email
          isPrivateMessage
        }
        embedStreams {
          logo
          streamName
          streamType
          streamUrl
          thumbnail
          chat {
            type
            url
          }
        }
        klic {
          isThumbnailOverridden
          logo
          mediaOffset
          streamUrl
          thumbnailUrl
          vodUrl
          chat {
            url
            type
          }
          channel {
            channelArn
            channelInputUrl
            channelStreamKey
            id
            isChannelLive
            ivsChannelName
            liveUrl
            userId
            name
            user {
              firstName
              lastName
              id
              email
              username
              avatar
              heading
            }
          }
        }
        type
      }
    }
  }
`;
export const GetEventsV2Document = gql`
  query GetEventV2 {
    getEventV2 {
      name
      id
      description
      posterImage
      slug
      status
      thumbnail
    }
  }
`;

export const GetStreamV2Document = gql`
  query GetStreamV2($getStreamInput: GetStreamInput) {
    getStreamV2(getStreamInput: $getStreamInput) {
      name
      isChannelLive
      livePlaybackUrl
      masterKey
      playlistDuration
      recordingStartedAt
    }
  }
`;
export const GetStreamViewerV2Document = gql`
  query GetStreamViewerV2($getStreamInput: GetStreamInput) {
    getStreamViewerV2(getStreamInput: $getStreamInput) {
      name
      isChannelLive
      livePlaybackUrl
      masterKey
      playlistDuration
      recordingStartedAt
      viewerCount
    }
  }
`;
export const GetMediasForChannelDocument = gql`
  query GetMediasForChannel($username: String!) {
    getMediasForChannel(username: $username) {
      id
      name
      isChannelLive
      livePlaybackUrl
      masterKey
      playlistDuration
      recordingStartedAt
      isPublic
    }
  }
`;
export const GetThumbnailDocument = gql`
  query GetThumbnail($path: String!) {
    getThumbnail(path: $path) {
      url
    }
  }
`;
export const AddViewDocument = gql`
  mutation AddView($id: String!, $type: String!) {
    addLiveViewV2(id: $id, type: $type) {
      id
      type
      total
      current
    }
  }
`;
export const ContactRequestV2Document = gql`
  mutation ContactRequestV2($contactInput: ContactInput) {
    ContactRequestV2(contactInput: $contactInput)
  }
`;
export const AddChatSettingDocument = gql`
  mutation AddChatSetting($chatSettingInput: chatSettingV2Payload) {
    addChatSettingV2(chatSettingInput: $chatSettingInput) {
      followersOnly
      subsOnly
      emoteOnly
      slowMode
      eventId
    }
  }
`;
export const UpdateChatSettingDocument = gql`
  mutation UpdateChatSetting($chatSettingInput: chatSettingV2Payload) {
    updateChatSettingV2(chatSettingInput: $chatSettingInput) {
      followersOnly
      subsOnly
      emoteOnly
      slowMode
      eventId
    }
  }
`;

export const AddUserChatSettingDocument = gql`
  mutation AddUserChatSetting($userChatSettingInput: userChatSettingPayload) {
    addUserChatSettingV2(userChatSettingInput: $userChatSettingInput) {
      color
      discrimination
      explicitLanguage
      hostility
      profanity
      userId
      eventId
    }
  }
`;
export const UpdateUserChatSettingDocument = gql`
  mutation UpdateUserChatSetting(
    $userChatSettingInput: userChatSettingPayload
  ) {
    updateUserChatSettingV2(userChatSettingInput: $userChatSettingInput) {
      color
      discrimination
      explicitLanguage
      hostility
      profanity
      userId
      eventId
    }
  }
`;
export const AddChatModeratorDocument = gql`
  mutation AddChatModerator($eventId: String!, $userId: String!) {
    addChatModeratorV2(eventId: $eventId, userId: $userId) {
      eventId
      userId
    }
  }
`;
export const DeleteChatModeratorDocument = gql`
  mutation DeleteChatModerator($eventId: String!, $userId: String!) {
    deleteChatModeratorV2(eventId: $eventId, userId: $userId)
  }
`;
export const RemoveViewDocument = gql`
  mutation RemoveView($id: String!, $type: String!) {
    removeLiveViewV2(id: $id, type: $type) {
      id
      type
      total
      current
    }
  }
`;
export const GetViewsDocument = gql`
  query GetViews($id: String!, $type: String!) {
    getViews(id: $id, type: $type) {
      id
      type
      total
      current
    }
  }
`;
export const OnViewerNumberChangeDocument = gql`
  subscription OnViewerNumberChange {
    onViewerNumberChange {
      id
      type
      total
      current
    }
  }
`;
export const AttendEventV2Document = gql`
  mutation AttendEventV2($eventId: String!, $userId: String!) {
    attendEventV2(eventId: $eventId, userId: $userId) {
      attendees
      eventId
    }
  }
`;
export const OnAttendEventDocument = gql`
  subscription OnAttendEvent {
    onAttendEventV2 {
      attendees
      eventId
    }
  }
`;
export const GetAttendeesV2Document = gql`
  query GetAttendeesV2($userIds: [String]!) {
    getAttendeesV2(userIds: $userIds) {
      avatar
      email
      firstName
      heading
      lastName
      roleId
      username
    }
  }
`;
export const StopStreamerByAdminDocument = gql`
  mutation StopStreamerByAdmin($streamerId: String!) {
    stopStreamerByAdmin(streamerId: $streamerId) {
      id
      isPromo
      viewers {
        id
        type
        current
        total
      }
      media {
        id
        name
        isChannelLive
        livePlaybackUrl
        masterKey
        playlistDuration
        recordingStartedAt
      }
      isActive
      emailInvite {
        customMessage
        email
        isPrivateMessage
      }
      embedStreams {
        logo
        streamName
        streamType
        streamUrl
        thumbnail
        chat {
          type
          url
        }
      }
      klic {
        isThumbnailOverridden
        logo
        mediaOffset
        streamUrl
        thumbnailUrl
        vodUrl
        chat {
          url
          type
        }
        channel {
          channelArn
          channelInputUrl
          channelStreamKey
          id
          isChannelLive
          ivsChannelName
          liveUrl
          userId
          name
          user {
            firstName
            lastName
            id
            email
            username
            avatar
            heading
          }
        }
      }
      type
    }
  }
`;
export const OnStopStreamerByAdminDocument = gql`
  subscription OnStopStreamerByAdmin {
    onStopStreamerByAdmin {
      id
      isPromo
      viewers {
        id
        type
        current
        total
      }
      media {
        id
        name
        isChannelLive
        livePlaybackUrl
        masterKey
        playlistDuration
        recordingStartedAt
      }
      isActive
      emailInvite {
        customMessage
        email
        isPrivateMessage
      }
      embedStreams {
        logo
        streamName
        streamType
        streamUrl
        thumbnail
        chat {
          type
          url
        }
      }
      klic {
        isThumbnailOverridden
        logo
        mediaOffset
        streamUrl
        thumbnailUrl
        vodUrl
        chat {
          url
          type
        }
        channel {
          channelArn
          channelInputUrl
          channelStreamKey
          id
          isChannelLive
          ivsChannelName
          liveUrl
          userId
          name
          user {
            firstName
            lastName
            id
            email
            username
            avatar
            heading
          }
        }
      }
      type
    }
  }
`;
export const StartStreamerByAdminDocument = gql`
  mutation StartStreamerByAdmin($streamerId: String!) {
    startStreamerByAdmin(streamerId: $streamerId) {
      id
      isPromo
      viewers {
        id
        type
        current
        total
      }
      media {
        id
        name
        isChannelLive
        livePlaybackUrl
        masterKey
        playlistDuration
        recordingStartedAt
      }
      isActive
      emailInvite {
        customMessage
        email
        isPrivateMessage
      }
      embedStreams {
        logo
        streamName
        streamType
        streamUrl
        thumbnail
        chat {
          type
          url
        }
      }
      klic {
        isThumbnailOverridden
        logo
        mediaOffset
        streamUrl
        thumbnailUrl
        vodUrl
        chat {
          url
          type
        }
        channel {
          channelArn
          channelInputUrl
          channelStreamKey
          id
          isChannelLive
          ivsChannelName
          liveUrl
          userId
          name
          user {
            firstName
            lastName
            id
            email
            username
            avatar
            heading
          }
        }
      }
      type
    }
  }
`;
export const onEventActionChangeDocument = gql`
  subscription onEventActionsV2 {
    onEventActionsV2 {
      eventId
      action
    }
  }
`;
export const onEditEventChangeDocument = gql`
  subscription onEditEventV2 {
    onEditEventV2 {
      id
      slug
      username
      is_change
    }
  }
`;
export const onFollowChannelV2Document = gql`
  subscription onFollowChannelV2 {
    onFollowChannelV2
  }
`;
export const onUnFollowChannelV2Document = gql`
  subscription onUnFollowChannelV2 {
    onUnFollowChannelV2
  }
`;
export const OnStartStreamerByAdminDocument = gql`
  subscription OnStartStreamerByAdmin {
    onStartStreamerByAdmin {
      id
      isPromo
      viewers {
        id
        type
        current
        total
      }
      media {
        id
        name
        isChannelLive
        livePlaybackUrl
        masterKey
        playlistDuration
        recordingStartedAt
      }
      isActive
      emailInvite {
        customMessage
        email
        isPrivateMessage
      }
      embedStreams {
        logo
        streamName
        streamType
        streamUrl
        thumbnail
        chat {
          type
          url
        }
      }
      klic {
        isThumbnailOverridden
        logo
        mediaOffset
        streamUrl
        thumbnailUrl
        vodUrl
        chat {
          url
          type
        }
        channel {
          channelArn
          channelInputUrl
          channelStreamKey
          id
          isChannelLive
          ivsChannelName
          liveUrl
          userId
          name
          user {
            firstName
            lastName
            id
            email
            username
            avatar
            heading
          }
        }
      }
      type
    }
  }
`;
export const EditMediaDocument = gql`
  mutation EditMedia($editMediaInput: EditMediaInput) {
    editMediaV2(editMediaInput: $editMediaInput) {
      id
      isChannelLive
      livePlaybackUrl
      masterKey
      name
      playlistDuration
      recordingStartedAt
      isPublic
    }
  }
`;

export const EditCarousalDocument = gql`
  mutation editCarouselEventV2($editCarouselInput: EditCarouselInput) {
    editCarouselEventV2(editCarouselInput: $editCarouselInput)
  }
`;
export const ModifyCarousalDocument = gql`
  mutation modifyCarouselV2($editCarouselInput: [ModifyCarouselInput]) {
    modifyCarouselV2(editCarouselInput: $editCarouselInput)
  }
`;
export const CreateFeaturedCategoryDocument = gql`
  mutation createFeaturedCategory($createInput: FeatureCategoryMultiInput) {
    createFeaturedCategory(createInput: $createInput)
  }
`;
export const UpdateFeaturedCategoryDocument = gql`
  mutation updateFeaturedCategory($updateInput: FeatureCategoryUpdateInput) {
    updateFeaturedCategory(updateInput: $updateInput)
  }
`;
export const UpdateFeaturedCategoryPositionDocument = gql`
  mutation updateFeatureCategoryPosition(
    $featuredId: String!
    $position: Int
    $type: String!
  ) {
    updateFeatureCategoryPosition(
      featuredId: $featuredId
      type: $type
      position: $position
    )
  }
`;
export const EditFeaturedDocument = gql`
  mutation editFeaturedEventV2($editFeaturedInput: [EditFeaturedInput]) {
    editFeaturedEventV2(editFeaturedInput: $editFeaturedInput)
  }
`;

export const EditRecommendedDocument = gql`
  mutation editRecommendedEventV2($editInput: EditFeaturedInput) {
    editRecommendedEventV2(editInput: $editInput)
  }
`;
export const UpdateUserProfileV2Document = gql`
  mutation UpdateUserProfileV2(
    $updateUserProfileInput: UpdateUserProfileInput
  ) {
    updateUserProfileV2(updateUserProfileInput: $updateUserProfileInput) {
      avatar
      cognitoId
      firstName
      id
      lastName
      roleId
      username
      heading
    }
  }
`;

export const UserProfileV2Document = gql`
  mutation userSocialProfileV2($socialProfileInput: ProfileInput) {
    userSocialProfileV2(socialProfileInput: $socialProfileInput) {
      firstName
      id
      lastName
      username
      kick
      twitch
      youtube
      birthdate
      country
    }
  }
`;
export const CongnitoProfileV2Document = gql`
  mutation CongnitoProfileV2($cognitoInput: UpdateCognitoProfileInput) {
    CongnitoProfileV2(cognitoInput: $cognitoInput) {
      firstName
      id
      lastName
      username
      kick
      twitch
      youtube
      birthdate
      country
    }
  }
`;
export const CompleteSignUpDocument = gql`
  mutation CompleteSignUp($completeSignUpInput: CompleteSignUpInput) {
    completeSignUp(completeSignUpInput: $completeSignUpInput)
  }
`;
export const GetUserByUsernameDocument = gql`
  query GetUserByUsername($username: String!) {
    getUserByUsernameV2(username: $username) {
      avatar
      heading
      lastUpdated
      unread
      channel {
        id
        isChannelLive
        ivsChannelName
        liveUrl
        channelArn
        channelStreamKey
        channelInputUrl
        name
      }
      email
      firstName
      id
      lastName
      kick
      twitch
      youtube
      birthdate
      country
      firstLogin
      role {
        id
        name
      }
      plan {
        annual_price
        description
        id
        klic_stream
        monthly_price
        name
        paypal_annual
        paypal_monthly
        revenue
        slug
        stripe_annual
        stripe_monthly
        vod_storage
        contentType
        monitization
        streamType
        bracktology
      }
      username
    }
  }
`;
export const GetUserByEmailDocument = gql`
  query GetUserByEmail($email: String!) {
    getUserByEmailV2(email: $email) {
      avatar
      heading
      unread
      channel {
        id
        isChannelLive
        ivsChannelName
        liveUrl
        channelArn
        channelStreamKey
        channelInputUrl
        name
      }
      email
      firstName
      id
      lastName
      isLock
      isTempLock
      google_account
      apple_account
      twitter_account
      discord_account
      birthdate
      country
      role {
        id
        name
      }
      kick
      twitch
      youtube
      birthdate
      firstLogin
      country
      username
      plan {
        annual_price
        description
        id
        klic_stream
        monthly_price
        name
        paypal_annual
        paypal_monthly
        revenue
        slug
        stripe_annual
        stripe_monthly
        vod_storage
        contentType
        monitization
        streamType
        bracktology
      }
    }
  }
`;
export const GlobalSignOutV2Document = gql`
  mutation GlobalSignOutV2($username: String!) {
    globalSignOutV2(username: $username) {
      body
    }
  }
`;
export const CreateVisitEventDocument = gql`
  mutation CreateVisitEvent($eventId: String!, $userId: String) {
    createVisitEvent(eventId: $eventId, userId: $userId)
  }
`;
export const ModifyRoleManagerDocument = gql`
  mutation ModifyRoleManager($roleManager: ModifyRoleManagerInput) {
    modifyRoleManager(roleManager: $roleManager)
  }
`;
export const ModifPaymentSettingDocument = gql`
  mutation ModifPaymentSetting($cardInput: ModifyPaymentSettingInput) {
    modifyPaymentSetting(cardInput: $cardInput)
  }
`;
export const ReportAndBlockDocument = gql`
  mutation ReportAndBlockDocument($report: CreateReportInput) {
    insertReport(report: $report) {
      id
      description
    }
  }
`;
export const ModifyChatRuleByArrayDocument = gql`
  mutation modifyChatRuleByArray($ruleInput: [ChatRulePayload]) {
    modifyChatRuleByArray(ruleInput: $ruleInput)
  }
`;
export const CancelSubscriptionDocument = gql`
  mutation cancelSubscription($subscriptionInput: CancelSubscriptionInput) {
    cancelSubscription(subscriptionInput: $subscriptionInput)
  }
`;
export const ReadNotificationDocument = gql`
  mutation markAsReadNotification($userId: String!, $notificationId: String) {
    markAsReadNotification(userId: $userId, notificationId: $notificationId)
  }
`;
export const CheckPpvVisitDocument = gql`
  query CheckPPVVisit($cache: String!, $eventId: String!, $userId: String) {
    checkPpvVisit(cache: $cache, eventId: $eventId, userId: $userId) {
      alreadyVisitedByIp
      alreadyVisitedByUser
      isAllowed
    }
  }
`;
export const GetReasonListForReportDocument = gql`
  query getAllReasons {
    getAllReasons {
      id
      title
    }
  }
`;
export const GetPlanListV2Document = gql`
  query GetPlanListV2 {
    getPlanListV2 {
      annual_price
      description
      id
      paypal_annual
      paypal_monthly
      revenue
      slug
      stripe_annual
      stripe_monthly
      vod_storage
      monthly_price
      klic_stream
      name
    }
  }
`;
export const GetChatSettingDocument = gql`
  query GetChatSetting($eventId: String!) {
    getChatSettingV2(eventId: $eventId) {
      followersOnly
      subsOnly
      emoteOnly
      slowMode
      eventId
    }
  }
`;
export const GetRoleManagerDocument = gql`
  query getManagerList($userId: String!) {
    getManagerList(userId: $userId) {
      editor
      id
      moderator
      updatedAt
      user {
        avatar
        heading
        username
        channel {
          id
          isChannelLive
          ivsChannelName
          liveUrl
          channelArn
          channelStreamKey
          channelInputUrl
          name
        }
        email
        firstName
        id
        lastName
      }
    }
  }
`;
export const GetChatRuleByUserIdDocument = gql`
  query getChatRuleByUserId($userId: String!) {
    getChatRuleByUserId(userId: $userId) {
      description
      id
      position
      title
      userId
    }
  }
`;
export const GetPaymentSettingByUserIdDocument = gql`
  query getPaymentSettingByUserId($userId: String!) {
    getPaymentSettingByUserId(userId: $userId) {
      card_name
      card_no
      expiry_month
      expiry_year
      id
      card_type
    }
  }
`;
export const GetPaymentHistoryDocument = gql`
  query getPaymentHistory($userId: String!, $channelId: String) {
    getPaymentHistory(userId: $userId, channelId: $channelId) {
      id
      userId
      fromUserId
      paymentMethod
      amount
      type
      paymentDate
      buyer {
        avatar
        heading
        username
      }
      owner {
        avatar
        heading
        username
      }
      subscription {
        id
        planId
        startDate
        endDate
        paymentMode
        isActive
      }
    }
  }
`;
export const DeleteRoleManagerDocument = gql`
  query deleteManagerById($roleId: String!) {
    deleteManagerById(roleId: $roleId)
  }
`;
export const DeletePaymentSettingByIdDocument = gql`
  query deletePaymentSetting($cardId: String!) {
    deletePaymentSetting(cardId: $cardId)
  }
`;
export const GetChatModeratorDocument = gql`
  query GetChatModerators($eventId: String!) {
    getChatModeratorV2(eventId: $eventId) {
      eventId
      userId
    }
  }
`;
export const GetUserChatSettingDocument = gql`
  query GetUserChatSettings($eventId: String, $userId: String!) {
    getUserChatSettingV2(eventId: $eventId, userId: $userId) {
      color
      discrimination
      explicitLanguage
      hostility
      profanity
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper
) {
  return {
    GetSignedUrlV2(
      variables: IGetSignedUrlV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetSignedUrlV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetSignedUrlV2Query>(
            GetSignedUrlV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetSignedUrlV2',
        'query'
      );
    },
    GetPresignedUploadUrlV2(
      variables: IGetPresignedUploadUrlV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetPresignedUploadUrlV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPresignedUploadUrlV2Mutation>(
            GetPresignedUploadUrlV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetPresignedUploadUrlV2',
        'mutation'
      );
    },
    CheckUsername(
      variables: ICheckUsernameQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICheckUsernameQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICheckUsernameQuery>(
            CheckUsernameDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CheckUsername',
        'query'
      );
    },
    CheckEmail(
      variables: ICheckEmailQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICheckEmailQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICheckEmailQuery>(CheckEmailDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'CheckEmail',
        'query'
      );
    },
    GetCurrentUser(
      variables: IGetCurrentUserQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCurrentUserQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCurrentUserQuery>(
            GetCurrentUserDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCurrentUser',
        'query'
      );
    },
    GetMeAbout(
      variables: IGetAboutMeQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetAboutMeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetAboutMeQuery>(GetAboutMeDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetMeAbout',
        'query'
      );
    },
    CreateCategoryV2(
      variables?: ICreateCategoryV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateCategoryV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateCategoryV2Mutation>(
            CreateCategoryV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CreateCategoryV2',
        'mutation'
      );
    },
    GetCategoriesV2(
      variables?: IGetCategoriesV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCategoriesV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCategoriesV2Query>(
            GetCategoriesV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCategoriesV2',
        'query'
      );
    },
    GetFeaturedCategoryByTypeLive(
      variables?: IGetFeaturedCategoryByTypeVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetFeaturedCategoryByTypeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetFeaturedCategoryByTypeQuery>(
            GetFeaturedCategoryByTypeDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetFeaturedCategoryByTypeLive',
        'query'
      );
    },
    GetFeaturedCategoryByTypeRecent(
      variables?: IGetFeaturedCategoryByTypeVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetFeaturedCategoryByTypeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetFeaturedCategoryByTypeQuery>(
            GetFeaturedCategoryByTypeDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetFeaturedCategoryByTypeRecent',
        'query'
      );
    },
    GetFeaturedCategoryByType(
      variables?: IGetFeaturedCategoryByTypeVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetFeaturedCategoryByTypeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetFeaturedCategoryByTypeQuery>(
            GetFeaturedCategoryByTypeDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetFeaturedCategoryByType',
        'query'
      );
    },
    UpdateCategoryV2(
      variables?: IUpdateCategoryV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateCategoryV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateCategoryV2Mutation>(
            UpdateCategoryV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'UpdateCategoryV2',
        'mutation'
      );
    },
    GetChannel(
      variables: IGetChannelQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChannelQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChannelQuery>(GetChannelDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetChannel',
        'query'
      );
    },
    GetAllChannels(
      variables?: IGetAllChannelsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetAllChannelsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetAllChannelsQuery>(
            GetAllChannelsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetAllChannels',
        'query'
      );
    },
    getAllUsers(
      variables?: IGetAllUsersV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetAllUsersV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetAllUsersV2Query>(
            GetAllUsersV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetAllUsers',
        'query'
      );
    },
    GetEventsForChannel(
      variables: IGetEventsForChannelQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetEventsForChannelQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetEventsForChannelQuery>(
            GetEventsForChannelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetEventsForChannel',
        'query'
      );
    },
    GetCategoryById(
      variables: IGetCategoryByIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCategoryByIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCategoryByIdQuery>(
            GetCategoryByIdV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCategoryById',
        'query'
      );
    },
    GetCategoryByIdStatus(
      variables: IGetCategoryByIdStatusQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCategoryByIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCategoryByIdQuery>(
            GetCategoryByIdStatusV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCategoryById',
        'query'
      );
    },
    CreateEventForChannelV2(
      variables?: ICreateEventForChannelV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateEventForChannelV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateEventForChannelV2Mutation>(
            CreateEventForChannelV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CreateEventForChannelV2',
        'mutation'
      );
    },
    EditEventV2(
      variables?: IEditEventV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IEditEventV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IEditEventV2Mutation>(EditEventV2Document, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'EditEventV2',
        'mutation'
      );
    },
    UpdateEventChatOptionsV2(
      variables?: IUpdateEventSettingV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateEventChatOptionsV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateEventChatOptionsV2Mutation>(
            UpdateChatOptionV2V2Document,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'UpdateEventChatOptionsV2',
        'mutation'
      );
    },
    EventActionsV2(
      variables: IEventActionsV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IEventActionsV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IEventActionsV2Mutation>(
            EventActionsV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'EventActionsV2',
        'mutation'
      );
    },
    DeleteVideoById(
      variables: IDeleteVideoByIdMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteVideoByIdMutation> {
      console.log(
        'DeleteVideoById',
        variables,
        requestHeaders,
        DeleteVideoByIdDocument
      );
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteVideoByIdMutation>(
            DeleteVideoByIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'DeleteVideoById',
        'mutation'
      );
    },
    GetEventByIdV2(
      variables: IGetEventByIdV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetEventByIdV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetEventByIdV2Query>(
            GetEventByIdV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetEventByIdV2',
        'query'
      );
    },
    GetEventViewers(
      variables: IGetEventViewersQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetEventViewersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetEventViewersQuery>(
            GetEventViewersDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetEventViewers',
        'query'
      );
    },
    PinMessageEventChatV2(
      variables: IPinMessageEventChatV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IPinMessageEventChatV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IPinMessageEventChatV2Mutation>(
            PinMessageEventChatV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'PinMessageEventChatV2',
        'mutation'
      );
    },
    RemoveMessageChat(
      variables: IRemoveMessageChatMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<RemoveMessageChatMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveMessageChatMutation>(
            RemoveMessageChatDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'removeMessageChat',
        'mutation'
      );
    },
    SendMessageEventChatV2(
      variables: ISendMessageEventChatV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ISendMessageEventChatV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISendMessageEventChatV2Mutation>(
            SendMessageEventChatV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'SendMessageEventChatV2',
        'mutation'
      );
    },
    OnPinMessageEventChatV2(
      variables?: IOnPinMessageEventChatV2SubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnPinMessageEventChatV2Subscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnPinMessageEventChatV2Subscription>(
            OnPinMessageEventChatV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'OnPinMessageEventChatV2',
        'subscription'
      );
    },
    OnNewSendMessageEventChatV2(
      variables?: IOnSendMessageEventChatV2SubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnSendMessageEventChatV2Subscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnSendMessageEventChatV2Subscription>(
            OnNewSendMessageEventChatV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'OnNewSendMessageEventChatV2',
        'subscription'
      );
    },
    OnUpdateChatSettingV2(
      variables?: IOnUpdateChatSettingV2SubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnUpdateChatSettingV2Subscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnUpdateChatSettingV2Subscription>(
            OnUpdateChatSettingV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'onUpdateChatSettingV2',
        'subscription'
      );
    },
    GetEventChatMessagesV2(
      variables: IGetEventChatMessagesV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetEventChatMessagesV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetEventChatMessagesV2Query>(
            GetEventChatMessagesV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetEventChatMessagesV2',
        'query'
      );
    },
    SendMessageKlicChatV2(
      variables: ISendMessageKlicChatV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ISendMessageKlicChatV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISendMessageKlicChatV2Mutation>(
            SendMessageKlicChatV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'SendMessageKlicChatV2',
        'mutation'
      );
    },
    OnSendMessageKlicChatV2(
      variables?: IOnSendMessageKlicChatV2SubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnSendMessageKlicChatV2Subscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnSendMessageKlicChatV2Subscription>(
            OnSendMessageKlicChatV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'OnSendMessageKlicChatV2',
        'subscription'
      );
    },
    OnClearChatV2(
      variables?: IOnClearChatV2SubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnClearChatV2Subscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnClearChatV2Subscription>(
            OnClearChatV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'onClearChatV2',
        'subscription'
      );
    },
    GetKlicChatMessagesV2(
      variables: IGetKlicChatMessagesV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetKlicChatMessagesV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetKlicChatMessagesV2Query>(
            GetKlicChatMessagesV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetKlicChatMessagesV2',
        'query'
      );
    },
    UpdateEventTypeV2(
      variables?: IUpdateEventTypeV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateEventTypeV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateEventTypeV2Mutation>(
            UpdateEventTypeV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'UpdateEventTypeV2',
        'mutation'
      );
    },
    CreateEventTypeV2(
      variables?: ICreateEventTypeV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateEventTypeV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateEventTypeV2Mutation>(
            CreateEventTypeV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CreateEventTypeV2',
        'mutation'
      );
    },
    GetEventTypesV2(
      variables?: IGetEventTypesV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetEventTypesV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetEventTypesV2Query>(
            GetEventTypesV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetEventTypesV2',
        'query'
      );
    },
    GetLandingDataV2(
      variables?: IGetLandingDataV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetLandingDataV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetLandingDataV2Query>(
            GetLandingDataV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetLandingDataV2',
        'query'
      );
    },
    GetPastEvents(
      variables?: IGetPastEventsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetPastEventsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPastEventsQuery>(
            GetPastEventsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetPastEvents',
        'query'
      );
    },
    GetCategoryWithEventsV2(
      variables?: IGetCategoryWithEventsV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCategoryWithEventsV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCategoryWithEventsV2Query>(
            GetCategoryWithEventsV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getCategoryWithEventsV2',
        'query'
      );
    },
    GetLandingSidebarDataV2(
      variables?: IGetLandingSidebarDataV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetLandingSidebarDataV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetLandingSidebarDataV2Query>(
            GetLandingSidebarDataV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetLandingSidebarDataV2',
        'query'
      );
    },
    GetEventsForCarouselV2(
      variables?: IGetEventsForCarouselV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetEventsForCarouselV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetEventsForCarouselV2Query>(
            GetEventsForCarouselV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetEventsForCarouselV2',
        'query'
      );
    },
    GetFeaturedEventV2(
      variables?: IGetFeaturedEventsV2ByTypeQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetFeaturedEventsV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetFeaturedEventsV2Query>(
            GetFeaturedEventsV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetFeaturedEventV2',
        'query'
      );
    },
    GetLiveEventsV2(
      variables?: IGetLiveEventsV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetLiveEventsV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetLiveEventsV2Query>(
            GetLiveEventsV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetLiveEventsV2',
        'query'
      );
    },
    GetLiveEventsV3(
      variables?: IGetLiveEventsV3QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetLiveEventsV3Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetLiveEventsV3Query>(
            GetLiveEventsV3Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetLiveEventsV3',
        'query'
      );
    },
    GetUpcomingEventsV3(
      variables?: IGetUpcomingEventsV3QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetUpcomingEventsV3Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetUpcomingEventsV3Query>(
            GetUpcomingEventsV3Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetUpcomingEventsV3',
        'query'
      );
    },
    GetEventV2(
      variables?: IGetEventsV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetEventsV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetEventsV2Query>(GetEventsV2Document, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getEventV2',
        'query'
      );
    },
    GetTrendingCategory(
      variables?: IGetTrendingCategoriesQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetTrendingCategoriesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetTrendingCategoriesQuery>(
            GetTrendingCategoriesDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetTrendingCategory',
        'query'
      );
    },
    GetCategoryWithScheduleEvents(
      variables?: IGetCategoryWithScheduleEventsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCategoryWithScheduleEventsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCategoryWithScheduleEventsQuery>(
            GetCategoryWithScheduleEventsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCategoryWithScheduleEvents',
        'query'
      );
    },
    GetCategoryWithEvents(
      variables?: IGetCategoryWithEventsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCategoryWithEventsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCategoryWithEventsQuery>(
            GetCategoryWithEventsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCategoryWithEvents',
        'query'
      );
    },
    GetStreamV2(
      variables?: IGetStreamV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetStreamV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetStreamV2Query>(GetStreamV2Document, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetStreamV2',
        'query'
      );
    },
    GetStreamViewerV2(
      variables?: IGetStreamV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetStreamViewerV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetStreamViewerV2Query>(
            GetStreamViewerV2Document,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'GetStreamViewerV2',
        'query'
      );
    },
    GetMediasForChannel(
      variables: IGetMediasForChannelQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetMediasForChannelQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetMediasForChannelQuery>(
            GetMediasForChannelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetMediasForChannel',
        'query'
      );
    },
    GetThumbnail(
      variables: IGetThumbnailQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetThumbnailQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetThumbnailQuery>(GetThumbnailDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetThumbnail',
        'query'
      );
    },
    AddView(
      variables: IAddViewMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IAddViewMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAddViewMutation>(AddViewDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'AddView',
        'mutation'
      );
    },
    RemoveView(
      variables: IRemoveViewMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IRemoveViewMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IRemoveViewMutation>(RemoveViewDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'RemoveView',
        'mutation'
      );
    },
    GetViews(
      variables: IGetViewsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetViewsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetViewsQuery>(GetViewsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetViews',
        'query'
      );
    },
    OnViewerNumberChange(
      variables?: IOnViewerNumberChangeSubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnViewerNumberChangeSubscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnViewerNumberChangeSubscription>(
            OnViewerNumberChangeDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'OnViewerNumberChange',
        'subscription'
      );
    },
    AttendEventV2(
      variables: IAttendEventV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IAttendEventV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAttendEventV2Mutation>(
            AttendEventV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'AttendEventV2',
        'mutation'
      );
    },
    OnAttendEvent(
      variables?: IOnAttendEventSubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnAttendEventSubscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnAttendEventSubscription>(
            OnAttendEventDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'OnAttendEvent',
        'subscription'
      );
    },
    GetAttendeesV2(
      variables: IGetAttendeesV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetAttendeesV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetAttendeesV2Query>(
            GetAttendeesV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetAttendeesV2',
        'query'
      );
    },
    StopStreamerByAdmin(
      variables: IStopStreamerByAdminMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IStopStreamerByAdminMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IStopStreamerByAdminMutation>(
            StopStreamerByAdminDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'StopStreamerByAdmin',
        'mutation'
      );
    },
    OnStopStreamerByAdmin(
      variables?: IOnStopStreamerByAdminSubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnStopStreamerByAdminSubscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnStopStreamerByAdminSubscription>(
            OnStopStreamerByAdminDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'OnStopStreamerByAdmin',
        'subscription'
      );
    },
    StartStreamerByAdmin(
      variables: IStartStreamerByAdminMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IStartStreamerByAdminMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IStartStreamerByAdminMutation>(
            StartStreamerByAdminDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'StartStreamerByAdmin',
        'mutation'
      );
    },
    OnStartStreamerByAdmin(
      variables?: IOnStartStreamerByAdminSubscriptionVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IOnStartStreamerByAdminSubscription> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IOnStartStreamerByAdminSubscription>(
            OnStartStreamerByAdminDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'OnStartStreamerByAdmin',
        'subscription'
      );
    },
    EditMedia(
      variables?: IEditMediaMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IEditMediaMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IEditMediaMutation>(EditMediaDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'EditMedia',
        'mutation'
      );
    },
    EditCarousalV2(
      variables?: IEditCarousalV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IEditCarousalV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IEditCarousalV2Mutation>(
            EditCarousalDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'editCarouselEventV2',
        'mutation'
      );
    },
    ModifyCarousalV2(
      variables?: IModifyCarouselV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IModifyCarousalV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IModifyCarousalV2Mutation>(
            ModifyCarousalDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'modifyCarouselV2',
        'mutation'
      );
    },
    ModifyFeatureCategoryPosition(
      variables?: ModifyFeaturedCategoryPositionMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IModifyFeatureCategoryPositionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IModifyFeatureCategoryPositionMutation>(
            IModifyFeaturedCategoryPositionMutationVariablesDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'modifyFeatureCategoryPosition',
        'mutation'
      );
    },
    CreateFeaturedCategory(
      variables?: ICreateFeaturedCategoryV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateFeaturedCategoryV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateFeaturedCategoryV2Mutation>(
            CreateFeaturedCategoryDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'createFeaturedCategory',
        'mutation'
      );
    },
    UpdateFeaturedCategory(
      variables?: IUpdateFeaturedCategoryV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateFeaturedCategoryV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateFeaturedCategoryV2Mutation>(
            UpdateFeaturedCategoryDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'updateFeaturedCategory',
        'mutation'
      );
    },
    UpdateFeaturedCategoryPosition(
      variables?: IUpdateFeaturedCategoryPositionInput,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateFeaturedCategoryPositionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateFeaturedCategoryPositionMutation>(
            UpdateFeaturedCategoryPositionDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'updateFeaturedCategoryPosition',
        'mutation'
      );
    },
    EditFeaturedEventV2(
      variables?: IEditFeatureEventV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IEditFeaturedV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IEditFeaturedV2Mutation>(
            EditFeaturedDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'editFeaturedEventV2',
        'mutation'
      );
    },
    EditRecommendedEventV2(
      variables?: IEditRecommendedEventV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IEditRecommendedV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IEditRecommendedV2Mutation>(
            EditRecommendedDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'editRecommendedEventV2',
        'mutation'
      );
    },
    UpdateUserProfileV2(
      variables?: IUpdateUserProfileV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateUserProfileV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateUserProfileV2Mutation>(
            UpdateUserProfileV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'UpdateUserProfileV2',
        'mutation'
      );
    },
    CompleteSignUp(
      variables?: ICompleteSignUpMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICompleteSignUpMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICompleteSignUpMutation>(
            CompleteSignUpDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CompleteSignUp',
        'mutation'
      );
    },
    GetUserByUsername(
      variables: IGetUserByUsernameQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetUserByUsernameQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetUserByUsernameQuery>(
            GetUserByUsernameDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetUserByUsername',
        'query'
      );
    },
    GetUserByEmail(
      variables: IGetUserByEmailQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetUserByEmailQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetUserByEmailQuery>(
            GetUserByEmailDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getUserByEmailV2',
        'query'
      );
    },
    GlobalSignOutV2(
      variables: IGlobalSignOutV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGlobalSignOutV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGlobalSignOutV2Mutation>(
            GlobalSignOutV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GlobalSignOutV2',
        'mutation'
      );
    },
    CreateVisitEvent(
      variables: ICreateVisitEventMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateVisitEventMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateVisitEventMutation>(
            CreateVisitEventDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CreateVisitEvent',
        'mutation'
      );
    },
    CheckPPVVisit(
      variables: ICheckPpvVisitQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICheckPpvVisitQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICheckPpvVisitQuery>(
            CheckPpvVisitDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CheckPPVVisit',
        'query'
      );
    },
    FolllowChannel(
      variables?: IFollowChannelV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IFollowChannelV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IFollowChannelV2Mutation>(
            followChannelV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'followChannelV2',
        'mutation'
      );
    },
    UnFolllowChannel(
      variables?: IUnFollowChannelV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUnFollowChannelV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUnFollowChannelV2Mutation>(
            unfollowChannelV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'unFollowChannelV2',
        'mutation'
      );
    },
    CheckFollow(
      variables: IFollowChannelPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICheckFollowerQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICheckFollowerQuery>(CheckFollowDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'checkFollowerV2',
        'query'
      );
    },
    DeleteMediaById(
      variables: IDeleteMediaIdPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteMediaQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteMediaQuery>(
            DeleteMediaByIdDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteMediaById',
        'query'
      );
    },
    DeleteFeaturedEvent(
      variables: IDeleteFeaturedEventPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteFeatureEventQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteFeatureEventQuery>(
            DeleteFeaturedEventDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteFeaturedEvent',
        'query'
      );
    },
    DeleteEventType(
      variables: IDeleteEventTypePayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteEntityType> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteEntityType>(
            DeleteEventTypeDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteEventType',
        'query'
      );
    },
    DeleteCategory(
      variables: IDeleteCategoryPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteCategory> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteCategory>(DeleteCategoryDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'deleteCategory',
        'query'
      );
    },
    DeleteRecommendedEvent(
      variables: IDeleteRecommendedEventPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteRecommendedEventQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteRecommendedEventQuery>(
            DeleteRecommendedEventDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteRecommendedEvent',
        'query'
      );
    },
    DeleteCarouselEvent(
      variables: IDeleteRecommendedEventPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteCarouselEventQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteCarouselEventQuery>(
            DeleteCarouselEventDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteCarouselEvent',
        'query'
      );
    },
    DeleteFeaturedCategory(
      variables: IDeleteFeaturedCategoryPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteFeaturedCategoryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteFeaturedCategoryQuery>(
            DeleteFeaturedCategoryDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteFeaturedCategory',
        'query'
      );
    },
    CountChannelFollow(
      variables: IFollowChannelCPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IFollowerChannelQueryVariables> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IFollowerChannelQueryVariables>(
            FollowerForChannelDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getFollowerForChannel',
        'query'
      );
    },
    SubscribeChannel(
      variables: ISubscribeChannelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ISubscribeChannelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISubscribeChannelMutation>(
            SubscribeChannelV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'createSubscriptionV2',
        'mutation'
      );
    },
    ChannelSubscription(
      variables: IGetChannelSubscribePayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IChannelSubscriptionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IChannelSubscriptionQuery>(
            GetChannelSubscribeDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'checkChannelSubscribeV2',
        'query'
      );
    },
    UpdateAboutChannel(
      variables?: IUpdateChannelV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateChannelV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateChannelV2Mutation>(
            updateChannelV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateChannelV2',
        'mutation'
      );
    },
    GetHomePageSetupV2(
      variables?: IGetHomepageSetupV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetHomePageSetupV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetHomePageSetupV2Query>(
            GetHomepageSetupV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getEventsForCarouselV2',
        'query'
      );
    },
    GetSearchKeyword(
      variables: ISearchPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ISearchKeywordQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISearchKeywordQuery>(
            SearchKeywordDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getSearchByKeyword',
        'query'
      );
    },
    UpdateEventStatusV2(
      variables: IUpdateEventStatusMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateEventStatusMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateEventStatusMutation>(
            UpdateEventStatusDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'updateEventStatusV2',
        'mutation'
      );
    },
    GetDashboardV2(
      variables: IDashboardV2Payload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetDashboardV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetDashboardV2Query>(
            GetDashboardV2Document,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getDashboardV2',
        'query'
      );
    },
    GetFollowerListV2(
      variables: IFollowChannelCPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetFollowerListQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetFollowerListQuery>(
            GetFollowerListV2Document,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getFollowerListV2',
        'query'
      );
    },
    GetFollowingListV2(
      variables: IFollowingCPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetFollowingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetFollowingQuery>(
            GetFollowingV2Document,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getFollowerByChannel',
        'query'
      );
    },
    UpdateSocialLinkV2(
      variables?: IUpdateSocialLinkMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateSocialLinkMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateSocialLinkMutation>(
            UpdateSocialLinkV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateSocialLinkV2',
        'mutation'
      );
    },
    GetPlanListV2(
      variables?: IGetPlanListV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetPlanListQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPlanListQuery>(GetPlanListV2Document, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getPlanListV2',
        'query'
      );
    },
    UpdatePlanV2(
      variables?: IChangePLanMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IChangePLanMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IChangePLanMutation>(ChangePlanV2Document, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'changePlanV2',
        'mutation'
      );
    },
    FolllowCategory(
      variables?: IFollowCategoryV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IFollowCategoryV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IFollowCategoryV2Mutation>(
            followCategoryV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'followCategoryV2',
        'mutation'
      );
    },
    CheckCategoryFollow(
      variables: ICheckCategoryQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICheckCategoryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICheckCategoryQuery>(
            CheckFollowCategoryDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'FollowCategoryV2',
        'query'
      );
    },
    UserProfileV2(
      variables?: IUserProfileV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUserProfileV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUserProfileV2Mutation>(
            UserProfileV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'userSocialProfileV2',
        'mutation'
      );
    },
    GetCarouselEventsV2(
      variables?: IGetCarouselEventsV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCarouselEventsV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCarouselEventsV2Query>(
            GetCarouselEventsV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCarouselEventsV2',
        'query'
      );
    },
    GetCarouselEventsV3(
      variables?: IGetCarouselEventsV2QueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetCarouselEventsV3Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCarouselEventsV3Query>(
            GetCarouselEventsV3Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCarouselEventsV3',
        'query'
      );
    },
    GetAdminEventList(
      variables: GetAdminEventQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetAdminEventListQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetAdminEventListQuery>(
            GetAdminEventListDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetAdminEventList',
        'query'
      );
    },
    CongnitoProfileV2(
      variables?: ICongnitoProfileV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUserProfileV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUserProfileV2Mutation>(
            CongnitoProfileV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CongnitoProfileV2',
        'mutation'
      );
    },
    AdminUserLockUnlockV2(
      variables?: IAdminUserLockMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IAdminUserLockMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAdminUserLockMutation>(
            AdminUserLockDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'UserLockUnlockV2',
        'mutation'
      );
    },
    DeleteUserById(
      variables?: IDeleteUserByIdMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteUserByIdMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteUserByIdMutation>(
            DeleteUserByIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'UserLockUnlockV2',
        'mutation'
      );
    },
    DuplicateEventForChannel(
      variables?: IDuplicateEventMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDuplicateEventMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDuplicateEventMutation>(
            DuplicateEventDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'DuplicateEventForChannelV2',
        'mutation'
      );
    },
    FolllowChannelAction(
      variables?: IFollowChannelActionMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<FollowChannelActionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FollowChannelActionMutation>(
            followChannelActionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'followChannelAction',
        'mutation'
      );
    },
    CreateUserPanel(
      variables?: ICreateUserPanelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateUserPanelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateUserPanelMutation>(
            CreateUserPanelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'createUserPanel',
        'mutation'
      );
    },
    CreateEventPanel(
      variables?: ICreateUserPanelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateEventPanelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateEventPanelMutation>(
            CreateEventPanelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'createEventPanel',
        'mutation'
      );
    },
    CreateUserMasterPanel(
      variables?: ICreateUserMasterPanelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateUserMasterPanelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateUserMasterPanelMutation>(
            CreateUserMasterPanelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'createUserMasterPanel',
        'mutation'
      );
    },
    UpdateMasterPanel(
      variables?: IUpdateMasterPanelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateMasterPanelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateMasterPanelMutation>(
            UpdateMasterPanelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateMasterPanel',
        'mutation'
      );
    },
    CreateEventMasterPanel(
      variables?: ICreateUserMasterPanelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreateEventMasterPanelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateEventMasterPanelMutation>(
            CreateEventMasterPanelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'createEventMasterPanel',
        'mutation'
      );
    },
    DeleteUserPanel(
      variables: IDeleteUserPanelPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteUserPanel> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteUserPanel>(DeleteUserPanelDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'deleteUserPanel',
        'mutation'
      );
    },
    DeleteEventPanel(
      variables: IDeleteUserPanelPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteUserPanel> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteUserPanel>(
            DeleteEventPanelDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteEventPanel',
        'mutation'
      );
    },
    DeleteUserMasterPanel(
      variables: IDeleteUserMasterPanelPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteUserMasterPanel> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteUserMasterPanel>(
            DeleteUserMasterPanelDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteUserMasterPanel',
        'mutation'
      );
    },
    DeleteEventMasterPanel(
      variables: IDeleteUserMasterPanelPayload,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteUserMasterPanel> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteUserMasterPanel>(
            DeleteEventMasterPanelDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteEventMasterPanel',
        'mutation'
      );
    },
    GetPanelByUserId(
      variables: IGetPanelByUserIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetPanelByUserIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPanelByUserIdQuery>(
            GetPanelByUserIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetPanelByUserId',
        'query'
      );
    },
    NotifyResetPasswordUserId(
      variables: IGetPanelByUserIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<NotifyResetPasswordUserIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<NotifyResetPasswordUserIdQuery>(
            NotifyResetPasswordUserIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'notifyResetPassword',
        'query'
      );
    },
    GetPanelbyEventId(
      variables: IGetPanelByUserIdQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetPanelByEventIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPanelByEventIdQuery>(
            GetPanelByEventIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetPanelByEventId',
        'query'
      );
    },
    UpdateUserPanel(
      variables: IUpdateUserPanelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateUserPanelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateUserPanelMutation>(
            UpdateUserPanelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateUserPanel',
        'mutation'
      );
    },

    UpdateEventPanel(
      variables: IUpdateUserPanelMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateEventPanelMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateEventPanelMutation>(
            UpdateEventPanelDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateEventPanel',
        'mutation'
      );
    },
    UpdatePanelPosition(
      variables: IUpdatePanelPositionMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdatePanelPositionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdatePanelPositionMutation>(
            UpdatePanelPositionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updatePositionByMasterId',
        'mutation'
      );
    },
    UpdateCarouselPositionV2(
      variables: IUpdateCarouselPositionV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateCarouselPositionV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateCarouselPositionV2Mutation>(
            UpdateCarouselPositionV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateCarouselPositionV2',
        'mutation'
      );
    },
    UpdateFeaturedEventPosition(
      variables: IUpdateFeaturedEventPositionMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateFeaturedEventPositionV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateFeaturedEventPositionV2Mutation>(
            UpdateFeatureEventPositionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateFeatureEventPosition',
        'mutation'
      );
    },
    UpdateEventPanelPosition(
      variables: IUpdatePanelPositionMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdatePanelPositionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdatePanelPositionMutation>(
            UpdateEventPanelPositionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updateEventPanelPosition',
        'mutation'
      );
    },
    UpdatePanelPositionByUserId(
      variables: IUpdatePanelPositionByUserIdMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdatePanelPositionByUserIdMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdatePanelPositionByUserIdMutation>(
            UpdatePanelPositionByUserIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updatePanelPositionByUserId',
        'mutation'
      );
    },
    UpdatePanelPositionByEventId(
      variables: IUpdatePanelPositionByUserIdMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdatePanelPositionByUserIdMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdatePanelPositionByUserIdMutation>(
            UpdatePanelPositionByEventIdDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'updatePanelPositionByEventId',
        'mutation'
      );
    },
    CreatorEventActionsV2(
      variables: ICreatorEventActionsV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICreatorEventActionsV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreatorEventActionsV2Mutation>(
            CreatorEventActionsV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'CreatorEventActionsV2',
        'mutation'
      );
    },
    SetUserPreferenceV2(
      variables: ISetUserPreferenceV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ISetUserPreferenceV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetUserPreferenceV2Mutation>(
            SetUserPreferenceV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'SetUserPreferenceV2',
        'mutation'
      );
    },
    GetChannelEventsByStatusByUsername(
      variables: IGetChannelEventsByStatusByUsernameVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChannelEventsByStatusByUsernameQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChannelEventsByStatusByUsernameQuery>(
            GetChannelEventsByStatusByUsernameDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getChannelEventsByStatusByUsername',
        'query'
      );
    },
    GetChannelEventByStatusV2(
      variables: IGetChannelEventByStatusQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChannelEventByStatusQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChannelEventByStatusQuery>(
            GetChannelEventByStatusV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'getChannelEventByStatusV2',
        'query'
      );
    },
    GetSettingV2(
      variables?: IGetSettingV2Variables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetSettingV2Query> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetSettingV2Query>(GetSettingV2Document, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getSettingV2',
        'query'
      );
    },
    GetChannelEventStreams(
      variables?: IGetSettingV2Variables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChannelEventStreamsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChannelEventStreamsQuery>(
            GetChannelEventStreamsDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getChannelEventStreams',
        'query'
      );
    },
    EditLandingFeatureCategoryV2(
      variables: ILandingFeatureCategoryV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ILandingFeatureCategoryV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ILandingFeatureCategoryV2Mutation>(
            ILandingFeatureCategoryV2Document,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'editLandingFeatureCategoryV2',
        'mutation'
      );
    },
    UpdateMinuteWatch(
      variables?: IUpdateMinuteWatchVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateMinuteWatchQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateMinuteWatchQuery>(
            UpdateMinuteWatchDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'updateMinuteWatch',
        'query'
      );
    },
    GetRevenueChart(
      variables: IRevenueChartVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetRevenueChartQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetRevenueChartQuery>(
            GetRevenueChartDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getRevenueChart',
        'query'
      );
    },
    GetChannelRevenueChart(
      variables: IRevenueChartVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChannelRevenueChartDataQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChannelRevenueChartDataQuery>(
            GetChannelRevenueChartDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getChannelRevenueChart',
        'query'
      );
    },
    ResetPasswordByAdmin(
      variables?: IResetPasswordByIdMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IResetUserPasswordMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IResetUserPasswordMutation>(
            ResetUserPasswordDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'ResetPasswordByAdmin',
        'mutation'
      );
    },
    GetChatSetting(
      variables: IChatSettingVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChatSettingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChatSettingQuery>(
            GetChatSettingDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getPlanListV2',
        'query'
      );
    },
    GetChatModerators(
      variables: IChatModeratorVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChatModeratorQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChatModeratorQuery>(
            GetChatModeratorDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getChatModeratorV2',
        'query'
      );
    },
    GetUserChatSettings(
      variables: IUserChatSettingVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetUserChatSettingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetUserChatSettingQuery>(
            GetUserChatSettingDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getUserChatSettingV2',
        'query'
      );
    },
    AddChatSetting(
      variables: IAddChatSettingMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IAddChatSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAddChatSettingMutation>(
            AddChatSettingDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'addChatSettingV2',
        'mutation'
      );
    },
    ContactRequestV2(
      variables: IContactRequestV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IContactRequestV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IContactRequestV2Mutation>(
            ContactRequestV2Document,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'ContactRequestV2',
        'mutation'
      );
    },
    UpdateChatSetting(
      variables: IUpdateChatSettingMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateChatSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateChatSettingMutation>(
            UpdateChatSettingDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'updateChatSettingV2',
        'mutation'
      );
    },
    AddUserChatSetting(
      variables: AddUserChatSettingMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IAddUserChatSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAddUserChatSettingMutation>(
            AddUserChatSettingDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'addUserChatSettingV2',
        'mutation'
      );
    },
    UpdateUserChatSetting(
      variables: UpdateUserChatSettingMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IUpdateUserChatSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateUserChatSettingMutation>(
            UpdateUserChatSettingDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'updateUserChatSettingV2',
        'mutation'
      );
    },
    AddChatModerator(
      variables: AddChatModeratorMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IAddChatModeratorMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAddChatModeratorMutation>(
            AddChatModeratorDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'addChatModeratorV2',
        'mutation'
      );
    },
    DeleteChatModerator(
      variables: DeleteChatModeratorMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteChatModeratorMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteChatModeratorMutation>(
            DeleteChatModeratorDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteChatModeratorV2',
        'mutation'
      );
    },
    ClearChatV2(
      variables: IClearChatV2MutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IClearChatV2Mutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IClearChatV2Mutation>(ClearChatV2Document, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'clearChatV2',
        'mutation'
      );
    },
    VerifyStreamAvailability(
      variables: IVerifyStreamerAvailabilityQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IVerifyStremerAvailabilityQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IVerifyStremerAvailabilityQuery>(
            VerifyStreamAvailabilityDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'verifyChannelAvailability',
        'Query'
      );
    },
    GetNotificationHistory(
      variables: IGetNotificationHistoryQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IIGetNotificationHistoryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IIGetNotificationHistoryQuery>(
            GetNotificationHistoryDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getNotificationHistory',
        'Query'
      );
    },
    GetRoleManager(
      variables: IRoleManagerVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetRoleManagerQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetRoleManagerQuery>(
            GetRoleManagerDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getManagerList',
        'query'
      );
    },
    DeleteRoleManager(
      variables: IDeleteRoleManagerVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeleteRoleManagerQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeleteRoleManagerQuery>(
            DeleteRoleManagerDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deleteManagerById',
        'query'
      );
    },
    ModifyRoleManager(
      variables: IModifyRoleManagerMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IModifyRoleManagerMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IModifyRoleManagerMutation>(
            ModifyRoleManagerDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'modifyRoleManager',
        'mutation'
      );
    },
    ModifyChatRuleByArray(
      variables: IModifyChatRuleMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IModifyChatRuleByArrayMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IModifyChatRuleByArrayMutation>(
            ModifyChatRuleByArrayDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'modifyChatRuleByArray',
        'mutation'
      );
    },
    GetChatRuleByUserId(
      variables: IRoleManagerVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetChatRuleByUserIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetChatRuleByUserIdQuery>(
            GetChatRuleByUserIdDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getChatRuleByUserId',
        'query'
      );
    },
    ModifyPaymentSetting(
      variables: IModifyPaymentSettingMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IModifyPaymentSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IModifyPaymentSettingMutation>(
            ModifPaymentSettingDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'modifyPaymentSetting',
        'mutation'
      );
    },
    ReportAndBlock(
      variables: IReportAndBlockMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IReportAndBlockMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IReportAndBlockMutation>(
            ReportAndBlockDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'insertReport',
        'mutation'
      );
    },
    ReadNotification(
      variables: IReadNotificationMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IReadNotificationMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IReadNotificationMutation>(
            ReadNotificationDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'markAsReadNotification',
        'mutation'
      );
    },
    GetReasonListForReport(
      variables: IGetReasonListForReportQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetReasonListForReportQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetReasonListForReportQuery>(
            GetReasonListForReportDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getAllReasons',
        'query'
      );
    },
    GetPaymentSettingByUserId(
      variables: IRoleManagerVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetPaymentSettingByUserIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPaymentSettingByUserIdQuery>(
            GetPaymentSettingByUserIdDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getPaymentSettingByUserId',
        'query'
      );
    },
    GetPaymentHistory(
      variables: IGetPaymentHistoryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IGetPaymentHistoryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPaymentHistoryQuery>(
            GetPaymentHistoryDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'getPaymentHistory',
        'query'
      );
    },
    DeletePaymentSettingById(
      variables: IDeletePaymentSettingVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<IDeletePaymentSettingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IDeletePaymentSettingQuery>(
            DeletePaymentSettingByIdDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'deletePaymentSetting',
        'query'
      );
    },
    CancelSubscription(
      variables: ICancelSubscriptionMutationVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<ICancelSubscriptionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICancelSubscriptionMutation>(
            CancelSubscriptionDocument,
            variables,
            {
              ...requestHeaders,
              ...wrappedRequestHeaders,
            }
          ),
        'cancelSubscription',
        'mutation'
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
